export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CartProperties: any;
  DateOnly: any;
  DateTime: any;
  DateTimeOffset: any;
  Decimal: any;
  Dictionary: any;
  Guid: any;
  Long: any;
};

export type AddCartItemParametersInput = {
  /** Unique SKU/Article code that identifies the item to purchase */
  code: Scalars['String'];
  properties?: InputMaybe<Scalars['CartProperties']>;
  /** A decimal value greater than or equal to zero */
  quantity: Scalars['Decimal'];
};

export type AddItemsToCartInput = {
  items: Array<InputMaybe<AddCartItemParametersInput>>;
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};

export type AddMoreSaleQueryInput = {
  bookingId?: InputMaybe<Scalars['String']>;
  moreSales: Array<InputMaybe<MoreSaleInput>>;
  regionCode: Scalars['Int'];
  siteId: Scalars['ID'];
};

export type AddToCarFavoritesListResponse = {
  __typename?: 'AddToCarFavoritesListResponse';
  cars?: Maybe<Array<Maybe<Car>>>;
  createDate: Scalars['DateTime'];
  lastReadDate: Scalars['DateTime'];
  listId?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInformationInputType = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
};

export type AggregateBase = {
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type AggregateTypes = ColorTermsAggregate | FinanceFilterAggregates | HistogramRangeAggregate | LinksAggregate | RangeAggregate | RangeSingleAggregate | TermsAggregate | TermsSingleAggregate;

export type AnchorLeadinBlock = BlockBaseType & {
  __typename?: 'AnchorLeadinBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<CallToAction>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type AnchorLinksBarPropertyBlock = {
  __typename?: 'AnchorLinksBarPropertyBlock';
  anchorLinks?: Maybe<Array<Maybe<CallToAction>>>;
  headerButtons?: Maybe<Array<Maybe<CallToAction>>>;
  modalFooterBranchButtons?: Maybe<Array<Maybe<CallToAction>>>;
  modalFooterButtons?: Maybe<Array<Maybe<CallToAction>>>;
  showFloatingAnchorLinksBar: Scalars['Boolean'];
};

export type Area = {
  __typename?: 'Area';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  disclaimer?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<AreaGroup>>>;
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AreaGroup = {
  __typename?: 'AreaGroup';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  disclaimer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Attribute = {
  __typename?: 'Attribute';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<AttributeValueModel>>>;
};

export type AttributeValueModel = {
  __typename?: 'AttributeValueModel';
  endText?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['String']>;
  locationDescription?: Maybe<Scalars['String']>;
  preText?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum AutoComplete {
  /** City */
  City = 'CITY',
  /** No autocomplete */
  Off = 'OFF',
  /** Postal code */
  PostalCode = 'POSTAL_CODE',
  /** Street address */
  StreetAddress = 'STREET_ADDRESS'
}

export type BigHighlightCardBlock = BlockBaseType & {
  __typename?: 'BigHighlightCardBlock';
  animation?: Maybe<Scalars['String']>;
  badgeText?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primaryShade?: Maybe<Scalars['String']>;
  secondaryShade?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showLogo: Scalars['Boolean'];
  skew: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BlockBaseType = {
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BookAndOrderCheckoutStep = CheckoutStep & {
  __typename?: 'BookAndOrderCheckoutStep';
  /** SubmitOrderState */
  state?: Maybe<SubmitOrderState>;
  status: CheckoutStepStatus;
};

export enum BookingEngine {
  BookMaker = 'BOOK_MAKER',
  External = 'EXTERNAL',
  HybridDms = 'HYBRID_DMS',
  Kobra = 'KOBRA'
}

export type BookingInformationRequest = {
  bookingId: Scalars['String'];
  culture: Scalars['String'];
  indexPrefix: Scalars['String'];
  regionCode: Scalars['Int'];
  serviceId?: InputMaybe<Scalars['ID']>;
  siteId: Scalars['ID'];
};

export type BookingInformationResponse = {
  __typename?: 'BookingInformationResponse';
  branchId: Scalars['String'];
  branchName: Scalars['String'];
  cancelable: Scalars['Boolean'];
  carMakeCode: Scalars['String'];
  city: Scalars['String'];
  containerId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  headerImagePath: Scalars['String'];
  imageUrl: Scalars['String'];
  isSlot: Scalars['Boolean'];
  isTireHotel: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  leaveCarTimes?: Maybe<Array<Maybe<Time>>>;
  longitude: Scalars['Float'];
  makeModel: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  reBookable: Scalars['Boolean'];
  regNr?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceName: Scalars['String'];
  servicePrice?: Maybe<Scalars['Float']>;
  slots?: Maybe<Array<Maybe<SearchSlot>>>;
  startDate: Scalars['DateTime'];
  streetAddress: Scalars['String'];
  technicianName: Scalars['String'];
  visibilityType: BranchVisibilityType;
  year: Scalars['String'];
  zipCode: Scalars['String'];
};

export type BookingReference = {
  __typename?: 'BookingReference';
  bookingId?: Maybe<Scalars['String']>;
  /** ContainerId */
  containerId?: Maybe<Scalars['Int']>;
  /** Expected booking duration in minutes */
  duration?: Maybe<Scalars['Int']>;
  leaveTime?: Maybe<LeaveTimeGraphType>;
  /** Preliminary workshop booking expire time in minutes calculated at the time of request */
  minutesUntilExpiration?: Maybe<Scalars['Int']>;
  /** Workshop booking start-time */
  starts?: Maybe<Scalars['DateTime']>;
  technician?: Maybe<BookingReferenceTechnicianGraphType>;
  workshopBranch?: Maybe<Branch>;
  workshopService?: Maybe<Scalars['String']>;
};

export type BookingReferenceTechnicianGraphType = {
  __typename?: 'BookingReferenceTechnicianGraphType';
  branchName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BookingResponse = StatusCodeResponse | SubmittedBooking;

export enum BookingScheduleType {
  Day = 'DAY',
  Mixed = 'MIXED',
  Slot = 'SLOT'
}

export type BookingSettings = {
  __typename?: 'BookingSettings';
  chatId: Scalars['Int'];
  emailRegex?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
  moreSaleSettings?: Maybe<MoreSaleSettings>;
  noImageEmployee?: Maybe<Scalars['String']>;
  policyUrl?: Maybe<Scalars['String']>;
  priceThousandSeparator?: Maybe<Scalars['String']>;
  registrationNumberLength: Scalars['Int'];
  registrationNumberMask?: Maybe<Scalars['String']>;
  registrationNumberRegexp?: Maybe<Scalars['String']>;
  servicePlanBranchId: Scalars['Int'];
  showBranchSettings: Scalars['Boolean'];
  showGenericSettings: Scalars['Boolean'];
  siteId: Scalars['ID'];
  slotGroups?: Maybe<Array<Maybe<SlotGroup>>>;
  socialSecurityMask?: Maybe<Scalars['String']>;
  termsAndConditionText?: Maybe<Scalars['String']>;
};

export enum BookingType {
  DamageInspection = 'DAMAGE_INSPECTION',
  Inspection = 'INSPECTION',
  MobiliaCareWindscreenChipRepair = 'MOBILIA_CARE_WINDSCREEN_CHIP_REPAIR',
  MobiliaCareWindscreenReplacement = 'MOBILIA_CARE_WINDSCREEN_REPLACEMENT',
  MobiliaCareWindscreenTreatment = 'MOBILIA_CARE_WINDSCREEN_TREATMENT',
  Rekond = 'REKOND',
  Reparation = 'REPARATION',
  Service = 'SERVICE',
  TireShift = 'TIRE_SHIFT',
  WheelAdjustment = 'WHEEL_ADJUSTMENT',
  WheelSettings = 'WHEEL_SETTINGS',
  WheelShift = 'WHEEL_SHIFT',
  WindscreenChipRepair = 'WINDSCREEN_CHIP_REPAIR',
  WindscreenReplacement = 'WINDSCREEN_REPLACEMENT'
}

export type BookmakerTechnicianType = {
  __typename?: 'BookmakerTechnicianType';
  branchCode?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  firstAvailableTimes?: Maybe<Array<Maybe<Day>>>;
  generalContainer?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl: Scalars['String'];
  regionCode: Scalars['Int'];
  scheduleBookingGrade?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type BoosterInputField = {
  __typename?: 'BoosterInputField';
  autoComplete: AutoComplete;
  formatMatch?: Maybe<Scalars['String']>;
  htmlInputType: HtmlInputType;
  id: Scalars['ID'];
  inputMode: InputMode;
  maxLength?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  radioButtonChoices?: Maybe<Array<Maybe<RadioButtonChoice>>>;
  tooltip?: Maybe<Scalars['String']>;
  validationType: ValidationType;
};

export enum BoosterType {
  /** Checkbox */
  Checkbox = 'CHECKBOX',
  /** Form */
  Form = 'FORM'
}

export type Branch = {
  __typename?: 'Branch';
  branchTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  carMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  employeeActiveDirectoryOfficeName?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Maybe<Facility>>>;
  /** Get branch gallery image */
  galleryImage?: Maybe<GalleryImage>;
  id: Scalars['String'];
  information?: Maybe<Information>;
  introText?: Maybe<Scalars['String']>;
  kobraKey?: Maybe<Scalars['String']>;
  leaveCarTimes?: Maybe<Array<Maybe<Time>>>;
  location?: Maybe<Location>;
  message?: Maybe<Message>;
  name: Scalars['String'];
  route?: Maybe<Scalars['String']>;
  salesPersonBookingPageUrl?: Maybe<Scalars['String']>;
  slots?: Maybe<Array<Maybe<SearchSlot>>>;
  /** @deprecated Is this field used anymore? Route seems to be located under BranchPage instead, right or wrong? */
  urlFriendlyName: Scalars['String'];
  visibilityType: BranchVisibilityType;
  workshopServices?: Maybe<Array<Maybe<BranchWorkshopService>>>;
};

export enum BranchAndDateBookingType {
  FullDay = 'FULL_DAY',
  TimeSlots = 'TIME_SLOTS'
}

export type BranchAndDateCheckoutStep = CheckoutStep & {
  __typename?: 'BranchAndDateCheckoutStep';
  bookingType: BranchAndDateBookingType;
  /** Is null if booking information has not been set. */
  state?: Maybe<BookingReference>;
  status: CheckoutStepStatus;
};

export type BranchCustomerSupportBlock = BlockBaseType & {
  __typename?: 'BranchCustomerSupportBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchEmployeesBlock = BlockBaseType & {
  __typename?: 'BranchEmployeesBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  employeeType?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  salesPersonBookingPageUrl?: Maybe<Scalars['String']>;
  salesPersons?: Maybe<Array<Maybe<SalesPerson>>>;
  shade?: Maybe<Scalars['String']>;
  technicians?: Maybe<Array<Maybe<Technician>>>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchFacilitiesBlock = {
  __typename?: 'BranchFacilitiesBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  facilities?: Maybe<Array<Maybe<Facility>>>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchGeneralInformationBlock = {
  __typename?: 'BranchGeneralInformationBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  carMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  /** Get branch gallery images */
  galleryImages?: Maybe<Array<Maybe<GalleryImage>>>;
  generalInformation?: Maybe<Information>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  introText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** Get branch news articles */
  newsArticles?: Maybe<Array<Maybe<BranchNewsArticle>>>;
  seoMetaDescription?: Maybe<Scalars['String']>;
  seoPageTitle?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchGeneralInformationHeroBlock = {
  __typename?: 'BranchGeneralInformationHeroBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  carMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  /** Get branch gallery images */
  galleryImages?: Maybe<Array<Maybe<GalleryImage>>>;
  generalInformation?: Maybe<Information>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  introText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** Get branch news articles */
  newsArticles?: Maybe<Array<Maybe<BranchNewsArticle>>>;
  seoMetaDescription?: Maybe<Scalars['String']>;
  seoPageTitle?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchIntroductionBlock = BlockBaseType & {
  __typename?: 'BranchIntroductionBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  listHeader?: Maybe<Scalars['String']>;
  listIntroText?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchNamesQuery = {
  bookingType: Scalars['Int'];
  carMakeCode?: InputMaybe<Scalars['String']>;
  indexPrefix?: InputMaybe<Scalars['String']>;
  isTransport: Scalars['Boolean'];
};

export type BranchNamesType = {
  __typename?: 'BranchNamesType';
  bookingEngine: BookingEngine;
  employeeActiveDirectoryOfficeName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kobraKey?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Is this field used anymore? Route seems to be located under BranchPage instead, right or wrong? */
  urlFriendlyName: Scalars['String'];
  visibilityType: BranchVisibilityType;
};

export type BranchNewsArticle = {
  __typename?: 'BranchNewsArticle';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageHorizontalCrop?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
  imageVerticalCrop?: Maybe<Scalars['String']>;
  imageZoomLevel?: Maybe<Scalars['String']>;
  linkSize?: Maybe<Scalars['String']>;
  linkTarget?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BranchNewsBlock = {
  __typename?: 'BranchNewsBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchOpeningHoursBlock = BlockBaseType & {
  __typename?: 'BranchOpeningHoursBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  departmentsOpeningHours?: Maybe<Array<Maybe<Department>>>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchSearchBarBlock = BlockBaseType & {
  __typename?: 'BranchSearchBarBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchSearchBlock = BlockBaseType & {
  __typename?: 'BranchSearchBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchSearchResult = {
  __typename?: 'BranchSearchResult';
  aggregates?: Maybe<Array<Maybe<AggregateTypes>>>;
  branches?: Maybe<Array<Maybe<Branch>>>;
  totalNumberOfHits: Scalars['Long'];
};

export type BranchSeoBlock = {
  __typename?: 'BranchSeoBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  seoNearbyText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BranchSettings = {
  __typename?: 'BranchSettings';
  bookingPageLinkUrl?: Maybe<Scalars['String']>;
  branchContactPageUrl?: Maybe<Scalars['String']>;
  branchSalesPersonContactPageUrl?: Maybe<Scalars['String']>;
  branchTechnicianPersonContactPageUrl?: Maybe<Scalars['String']>;
};

export type BranchSiteSearchResultType = {
  __typename?: 'BranchSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  matchedFilters?: Maybe<Array<Maybe<KeyValuePair>>>;
  results?: Maybe<Array<Maybe<Branch>>>;
  totalHits: Scalars['Long'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export enum BranchVisibilityType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type BranchWorkshopService = {
  __typename?: 'BranchWorkshopService';
  bookingDepartmentId?: Maybe<Scalars['String']>;
  bookingType?: Maybe<BookingType>;
  externalUrl: Scalars['String'];
  hideDialog: Scalars['Boolean'];
  name: Scalars['String'];
  serviceBrands?: Maybe<Array<Maybe<CarMake>>>;
  serviceId: Scalars['ID'];
};

export type BrandLeadinCard = BlockBaseType & {
  __typename?: 'BrandLeadinCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BrandLeadinGridBlock = BlockBaseType & {
  __typename?: 'BrandLeadinGridBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  gridLinks?: Maybe<Array<Maybe<CallToAction>>>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type BrandModelCombinationModel = {
  __typename?: 'BrandModelCombinationModel';
  brand?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<EquipmentLevelCarImageColor>>>;
  equipmentLevels?: Maybe<Array<Maybe<VehicleEquipmentLevelModel>>>;
  model?: Maybe<Scalars['String']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BreadcrumbsBlock = BlockBaseType & {
  __typename?: 'BreadcrumbsBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CallToAction = {
  __typename?: 'CallToAction';
  accessibleName?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  buttonType?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  modalSize?: Maybe<Scalars['String']>;
  modalTitle?: Maybe<Scalars['String']>;
  showInAnchorLeadinBlock: Scalars['Boolean'];
  smallText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  truncateText: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  urlTarget?: Maybe<Scalars['String']>;
};

export type CallToActionBarBlock = BlockBaseType & {
  __typename?: 'CallToActionBarBlock';
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  shade?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CallToActionNavigationBarBlock = BlockBaseType & {
  __typename?: 'CallToActionNavigationBarBlock';
  animation?: Maybe<Scalars['String']>;
  appearanceType?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isSticky: Scalars['Boolean'];
  labelCloseMenu?: Maybe<Scalars['String']>;
  labelOpenMenu?: Maybe<Scalars['String']>;
  labelSectionHeading?: Maybe<Scalars['String']>;
  linkCollections?: Maybe<Array<Maybe<LinkCollectionBlock>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  sectionCollection?: Maybe<LinkCollectionBlock>;
  serviceMessage?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showBackButton: Scalars['Boolean'];
  showBreadcrumbs: Scalars['Boolean'];
  showCallToActionOnScroll: Scalars['Boolean'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CampaignCustomerType = {
  __typename?: 'CampaignCustomerType';
  hasSubmittedInfo: Scalars['Boolean'];
  showWheelWearSales: Scalars['Boolean'];
  uuid: Scalars['String'];
};

export type Car = {
  __typename?: 'Car';
  accessories?: Maybe<Array<Maybe<Scalars['String']>>>;
  carText?: Maybe<CarText>;
  commerce?: Maybe<CarCommerce>;
  conditionReportUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  department?: Maybe<CarDepartment>;
  engine?: Maybe<CarEngine>;
  enhancedProperties?: Maybe<EnhancedProperties>;
  finance?: Maybe<CarFinance>;
  generalInfo?: Maybe<CarGeneralInfo>;
  id: Scalars['String'];
  imageList?: Maybe<Array<Maybe<CarMedia>>>;
  insuranceOption?: Maybe<CarInsuranceOption>;
  movieList?: Maybe<Array<Maybe<CarMovie>>>;
  priceInfo?: Maybe<CarPriceInfo>;
  status?: Maybe<CarStatus>;
  warranty?: Maybe<CarWarrantyObj>;
};


export type CarImageListArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};

export type CarBranch = {
  __typename?: 'CarBranch';
  city?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CarCommerce = {
  __typename?: 'CarCommerce';
  allowTradeIn: Scalars['Boolean'];
  disabledOnWayke: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  homeDelivery: Scalars['Boolean'];
  reserved: Scalars['Boolean'];
};

export type CarCommerceTypeNew = {
  __typename?: 'CarCommerceTypeNew';
  allowTradeIn: Scalars['Boolean'];
  disabledOnWayke: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  homeDelivery: Scalars['Boolean'];
  reserved: Scalars['Boolean'];
};

export type CarComparisonBlock = BlockBaseType & {
  __typename?: 'CarComparisonBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarConditionalRate = {
  __typename?: 'CarConditionalRate';
  conditionMaxTermLength: Scalars['Decimal'];
  conditionMinDownPaymentPercent: Scalars['Decimal'];
  interestRate: Scalars['Decimal'];
};

export type CarDepartment = {
  __typename?: 'CarDepartment';
  crmDepartmentName?: Maybe<Scalars['String']>;
  crmRegionName?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  gps?: Maybe<CarDepartmentLocation>;
  isCentralWarehouseCar: Scalars['Boolean'];
};

export type CarDepartmentLocation = {
  __typename?: 'CarDepartmentLocation';
  departmentLatitude?: Maybe<Scalars['Float']>;
  departmentLongitude?: Maybe<Scalars['Float']>;
};

export type CarDynamicListBlock = BlockBaseType & {
  __typename?: 'CarDynamicListBlock';
  accordionHeader?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carSearchPageQueryParams?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fetchCount: Scalars['Int'];
  fixed: Scalars['Boolean'];
  hScroll: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  infiniteScroll: Scalars['Boolean'];
  infinityThreshold: Scalars['Int'];
  labelLoadMoreButton?: Maybe<Scalars['String']>;
  mainQuery?: Maybe<Array<Maybe<SelectedQuery>>>;
  mediaIds: Array<Scalars['Int']>;
  minimumColumnsOnSmallerScreens: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  paginationLarge: Scalars['Int'];
  paginationSmall: Scalars['Int'];
  searchFilterParameters?: Maybe<Array<Maybe<SearchFilterParameter>>>;
  shade?: Maybe<Scalars['String']>;
  showCount: Scalars['Int'];
  subQueries?: Maybe<Array<Maybe<SelectedQuery>>>;
  type: Scalars['String'];
  useDefaultSearchPageForViewMore: Scalars['Boolean'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarEngine = {
  __typename?: 'CarEngine';
  co2: Scalars['Int'];
  enginePowerHp: Scalars['Int'];
  enginePowerKw: Scalars['Int'];
  engineVolumeCcm: Scalars['Int'];
  engineVolumeLiter: Scalars['Decimal'];
  fuelConsumptionMixedDriving: Scalars['Decimal'];
};

export type CarFavoritesCreateFavoritesListResponse = {
  __typename?: 'CarFavoritesCreateFavoritesListResponse';
  cars?: Maybe<Array<Maybe<Car>>>;
  createDate: Scalars['DateTime'];
  lastReadDate: Scalars['DateTime'];
  listId?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
};

export type CarFavoritesGetFavoritesByIdResponse = {
  __typename?: 'CarFavoritesGetFavoritesByIdResponse';
  cars?: Maybe<Array<Maybe<Car>>>;
  createDate: Scalars['DateTime'];
  lastReadDate: Scalars['DateTime'];
  listId?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
};

export type CarFeatureAccordionTableBlock = BlockBaseType & {
  __typename?: 'CarFeatureAccordionTableBlock';
  accessoriesIcon?: Maybe<Scalars['String']>;
  accessoriesTitle?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carObjectStructure?: Maybe<Array<Maybe<Area>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  information?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};


export type CarFeatureAccordionTableBlockCarObjectStructureArgs = {
  languageCode: Scalars['String'];
};

export type CarFeatureTableBlock = BlockBaseType & {
  __typename?: 'CarFeatureTableBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carObjectStructure?: Maybe<Array<Maybe<Area>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelMileage?: Maybe<Scalars['String']>;
  labelModelYear?: Maybe<Scalars['String']>;
  labelViewMore?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};


export type CarFeatureTableBlockCarObjectStructureArgs = {
  languageCode: Scalars['String'];
};

export type CarFilterSubscriptionInfoResult = {
  __typename?: 'CarFilterSubscriptionInfoResult';
  email?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<FilterResult>>>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  siteId: Scalars['ID'];
  validFrom: Scalars['DateTime'];
  validTo?: Maybe<Scalars['DateTime']>;
};

export type CarFilterSubscriptionInput = {
  email?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  numberOfDays?: InputMaybe<Scalars['Int']>;
};

export type CarFilterSubscriptionResult = {
  __typename?: 'CarFilterSubscriptionResult';
  success: Scalars['Boolean'];
};

export type CarFinance = {
  __typename?: 'CarFinance';
  carPrice: Scalars['Decimal'];
  carPriceExclVat: Scalars['Decimal'];
  conditionalRates?: Maybe<Array<Maybe<CarConditionalRate>>>;
  defaultTermLength: Scalars['Int'];
  defaultTermLengthYear: Scalars['Int'];
  documentFee: Scalars['Decimal'];
  downPayment: Scalars['Decimal'];
  entryFee: Scalars['Decimal'];
  maxCash: Scalars['Int'];
  maxDownPaymentPercentage: Scalars['Decimal'];
  minCash: Scalars['Int'];
  minDownPaymentPercentage: Scalars['Decimal'];
  monthFee: Scalars['Decimal'];
  monthlyFee: Scalars['Float'];
  standardInterestRate: Scalars['Decimal'];
};

export type CarFinanceCalculatorBlock = BlockBaseType & {
  __typename?: 'CarFinanceCalculatorBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  downPayment?: Maybe<Scalars['String']>;
  downPaymentCaption?: Maybe<Scalars['String']>;
  effectiveRate?: Maybe<Scalars['String']>;
  establishmentCost?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  financingProposal?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  interest?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  monthlyFee?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  registrationCost?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  termLength?: Maybe<Scalars['String']>;
  termLengthUnit?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCostWithDownPayment?: Maybe<Scalars['String']>;
  totalCreditCost?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarFinanceDuration = {
  __typename?: 'CarFinanceDuration';
  current: Scalars['Float'];
  default: Scalars['Float'];
  fixed: Scalars['Boolean'];
  max: Scalars['Float'];
  min: Scalars['Float'];
  step: Scalars['Float'];
};

export type CarFinanceOption = {
  __typename?: 'CarFinanceOption';
  administrationFee: Scalars['Float'];
  creditApplicationUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  downPayment?: Maybe<CarFinanceDuration>;
  duration?: Maybe<CarFinanceDuration>;
  effectiveInterest: Scalars['Float'];
  financialInstitution?: Maybe<Scalars['String']>;
  financialOptionId?: Maybe<Scalars['String']>;
  financialProductCode?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  interest: Scalars['Float'];
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  loanAmount: Scalars['Float'];
  moneyLaunderingInformationUrl?: Maybe<Scalars['String']>;
  monthlyCost: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  registrationFee?: Maybe<Scalars['Float']>;
  residual?: Maybe<CarFinanceDuration>;
  setupFee: Scalars['Float'];
  totalCreditCost: Scalars['Float'];
  totalResidualValue: Scalars['Float'];
  totalVehicleCost: Scalars['Float'];
  useCreditScoring: Scalars['Boolean'];
  vehiclePrice: Scalars['Float'];
};

export type CarGalleryUsp = {
  __typename?: 'CarGalleryUsp';
  overlayIndex: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type CarGeneralInfo = {
  __typename?: 'CarGeneralInfo';
  brand?: Maybe<Scalars['String']>;
  brandUrlFriendly?: Maybe<Scalars['String']>;
  carBody?: Maybe<Scalars['String']>;
  chassisNumber?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  colorInterior?: Maybe<Scalars['String']>;
  doors: Scalars['Int'];
  driveWheel?: Maybe<Scalars['String']>;
  fuel?: Maybe<Scalars['String']>;
  grossWeight: Scalars['Int'];
  hasManufacturerPackaging: Scalars['Boolean'];
  hasMrfPackaging: Scalars['Boolean'];
  interior?: Maybe<Scalars['String']>;
  isDemoCar: Scalars['Boolean'];
  isNewCar: Scalars['Boolean'];
  isTransportCar: Scalars['Boolean'];
  isUsedCar: Scalars['Boolean'];
  mileage: Scalars['Int'];
  model?: Maybe<Scalars['String']>;
  modelUrlFriendly?: Maybe<Scalars['String']>;
  modelYear: Scalars['Int'];
  registrationNumber?: Maybe<Scalars['String']>;
  resellerPackagingOptions?: Maybe<Array<Maybe<CarResellerPackagingOption>>>;
  seats: Scalars['Int'];
  trailerWeight: Scalars['Int'];
  transmission?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
  vehicleGroup?: Maybe<Scalars['String']>;
};

export type CarHeadBlock = BlockBaseType & {
  __typename?: 'CarHeadBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  manufacturerPackagingName?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  priceExclVatLabel?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  salesPersonContactUrl?: Maybe<Scalars['String']>;
  salesPersons?: Maybe<Array<Maybe<SalesPerson>>>;
  shade?: Maybe<Scalars['String']>;
  showAllSalesMen: Scalars['Boolean'];
  showSalesmen: Scalars['Boolean'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspText?: Maybe<Scalars['String']>;
};

export type CarImageColor = {
  __typename?: 'CarImageColor';
  defaultSelected: Scalars['Boolean'];
  equipmentLevelNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  hex?: Maybe<Scalars['String']>;
  imagesBasePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CarInsuranceOption = {
  __typename?: 'CarInsuranceOption';
  description?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  institute: Scalars['String'];
  insuranceHeader?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CarInsuranceOptionNew = {
  __typename?: 'CarInsuranceOptionNew';
  description?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  institute: Scalars['String'];
  insuranceHeader?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CarMake = {
  __typename?: 'CarMake';
  carMakeCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CarMakeOverviewBlock = BlockBaseType & {
  __typename?: 'CarMakeOverviewBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carMakeOverviewCardBlocks?: Maybe<Array<Maybe<CarMakeOverviewCardBlock>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  more?: Maybe<Array<Maybe<CarMakeOverviewMore>>>;
  name?: Maybe<Scalars['String']>;
  remainingCount?: Maybe<Scalars['Int']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewMoreButtons?: Maybe<Array<Maybe<CallToAction>>>;
  viewMoreImage?: Maybe<Image>;
  viewMoreTitle?: Maybe<Scalars['String']>;
};


export type CarMakeOverviewBlockMoreArgs = {
  take?: InputMaybe<Scalars['Int']>;
};

export type CarMakeOverviewCardBlock = BlockBaseType & {
  __typename?: 'CarMakeOverviewCardBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  button?: Maybe<CallToAction>;
  carMakeId?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  overview?: Maybe<CarMakeOverviewType>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};


export type CarMakeOverviewCardBlockOverviewArgs = {
  take?: InputMaybe<Scalars['Int']>;
};

export type CarMakeOverviewModel = {
  __typename?: 'CarMakeOverviewModel';
  count: Scalars['Long'];
  model?: Maybe<Scalars['String']>;
  urlFriendlyRoute?: Maybe<Scalars['String']>;
};

export type CarMakeOverviewMore = {
  __typename?: 'CarMakeOverviewMore';
  carMake?: Maybe<Scalars['String']>;
  count: Scalars['Long'];
  urlFriendlyRoute?: Maybe<Scalars['String']>;
};

export type CarMakeOverviewType = {
  __typename?: 'CarMakeOverviewType';
  carMake?: Maybe<Scalars['String']>;
  models?: Maybe<Array<Maybe<CarMakeOverviewModel>>>;
  remainingCount?: Maybe<Scalars['Int']>;
  urlFriendlyRoute?: Maybe<Scalars['String']>;
};

export type CarMakes = {
  __typename?: 'CarMakes';
  carMakeCode: Scalars['String'];
  isOther: Scalars['Boolean'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CarMedia = {
  __typename?: 'CarMedia';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  sourceUrl?: Maybe<Scalars['String']>;
  type: MediaType;
  url?: Maybe<Scalars['String']>;
};

export type CarMediaNew = {
  __typename?: 'CarMediaNew';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  sourceUrl?: Maybe<Scalars['String']>;
  type: MediaType;
  url?: Maybe<Scalars['String']>;
};

export type CarMetadataColorsBlockType = {
  __typename?: 'CarMetadataColorsBlockType';
  colorCode: Scalars['String'];
  default: Scalars['Boolean'];
  hex: Scalars['String'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  imageFilesBasePath: Scalars['String'];
  images: Scalars['String'];
  name: Scalars['String'];
};

export type CarMetadataModelsBlockType = {
  __typename?: 'CarMetadataModelsBlockType';
  brand: Scalars['String'];
  commercialVehicles: Scalars['Boolean'];
  id: Scalars['ID'];
  model: Scalars['String'];
};

export type CarMetadataOptionPacksBlockType = {
  __typename?: 'CarMetadataOptionPacksBlockType';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  optionCode: Scalars['String'];
  optionId: Scalars['String'];
};

export type CarMetadataVersionsBlockType = {
  __typename?: 'CarMetadataVersionsBlockType';
  brand: Scalars['String'];
  changedDate: Scalars['String'];
  createdDate?: Maybe<Scalars['String']>;
  dataDate: Scalars['String'];
  dataStatus: Scalars['String'];
  fuelTypeCodes: Array<Scalars['String']>;
  id: Scalars['ID'];
  localEquipmentLevel: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['String'];
  name: Scalars['String'];
  registrationTypeCode: Scalars['String'];
  uniqueId: Scalars['String'];
};

export type CarModel = {
  __typename?: 'CarModel';
  brand: Scalars['String'];
  imagePath: Scalars['String'];
  name: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type CarModelLinksBlock = BlockBaseType & {
  __typename?: 'CarModelLinksBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarModelPageBlock = {
  __typename?: 'CarModelPageBlock';
  activeConfigurationGroupId?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  campaignDescription?: Maybe<Scalars['String']>;
  campaignTitle?: Maybe<Scalars['String']>;
  carModelName?: Maybe<Scalars['String']>;
  carType?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  childrenIds: Array<Scalars['ID']>;
  contentLink: Scalars['String'];
  displayInHeader: Scalars['Boolean'];
  engineType?: Maybe<Scalars['String']>;
  generalDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isCampaign: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name: Scalars['String'];
  navigationBottomBlockIds: Array<Scalars['ID']>;
  navigationPanelId?: Maybe<Scalars['ID']>;
  navigationTopBlockIds: Array<Scalars['ID']>;
  offerModelsString?: Maybe<Scalars['String']>;
  offerType?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  preTitleText?: Maybe<Scalars['String']>;
  priceColumns: Scalars['Int'];
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  range: Scalars['Int'];
  registrationNumberModalSettings?: Maybe<RegistrationNumberModalSettings>;
  richText?: Maybe<RichText>;
  route: Scalars['String'];
  seats: Scalars['Int'];
  selectedJatoImage?: Maybe<Scalars['String']>;
  simpleUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uSP?: Maybe<RichText>;
  visibleInMenu: Scalars['Boolean'];
};


export type CarModelPageBlockSelectedJatoImageArgs = {
  imageAngle?: InputMaybe<Scalars['String']>;
};

export type CarModelSiteSearchResultType = {
  __typename?: 'CarModelSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  results?: Maybe<Array<Maybe<CarModel>>>;
  showMoreModelsUrl: Scalars['String'];
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type CarModelTabBlock = BlockBaseType & {
  __typename?: 'CarModelTabBlock';
  anchorId?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  innerPadding?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subTheme?: Maybe<Scalars['String']>;
  tabName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarMovie = {
  __typename?: 'CarMovie';
  sortOrder: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type CarMovieNew = {
  __typename?: 'CarMovieNew';
  sortOrder: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type CarNew = {
  __typename?: 'CarNew';
  accessories: Array<Scalars['String']>;
  activeDirectoryDepartmentName?: Maybe<Scalars['String']>;
  annualFee: Scalars['Int'];
  baseColorCode: Scalars['String'];
  branch?: Maybe<CarBranch>;
  brand: Scalars['String'];
  brandUrlFriendly: Scalars['String'];
  businessLeasingPrice: Scalars['Int'];
  carBody: Scalars['String'];
  carHeader: Scalars['String'];
  carPrice: Scalars['Decimal'];
  carPriceExclVat: Scalars['Decimal'];
  carTitle: Scalars['String'];
  carWarranty?: Maybe<Scalars['String']>;
  chassisNumber: Scalars['String'];
  co2: Scalars['Int'];
  color: Scalars['String'];
  colorInterior?: Maybe<Scalars['String']>;
  commerce?: Maybe<CarCommerceTypeNew>;
  conditionReportIds: Array<Scalars['String']>;
  conditionReportUrls?: Maybe<Array<Scalars['String']>>;
  conditionalRates?: Maybe<ConditionalRate>;
  crmDepartmentName: Scalars['String'];
  crmRegionName: Scalars['String'];
  currency: Scalars['String'];
  deductibleVat: Scalars['Boolean'];
  defaultTermLength: Scalars['Int'];
  defaultTermLengthYear: Scalars['Int'];
  departmentCity: Scalars['String'];
  departmentCounty: Scalars['String'];
  departmentId: Scalars['String'];
  departmentLatitude?: Maybe<Scalars['Float']>;
  departmentLongitude?: Maybe<Scalars['Float']>;
  departmentName: Scalars['String'];
  departmentStreet: Scalars['String'];
  departmentZip: Scalars['String'];
  description: Scalars['String'];
  documentFee: Scalars['Decimal'];
  doors: Scalars['Int'];
  downPayment: Scalars['Decimal'];
  driveWheel: Scalars['String'];
  enginePowerHp: Scalars['Int'];
  enginePowerKw: Scalars['Int'];
  engineType: Scalars['String'];
  engineVolumeCcm: Scalars['Int'];
  engineVolumeLiter: Scalars['Decimal'];
  enhancedProperties?: Maybe<EnhancedPropertiesNew>;
  entryFee: Scalars['Decimal'];
  financeMonthPrice: Scalars['Int'];
  financeOptions?: Maybe<Array<Maybe<CarFinanceOption>>>;
  fuel: Scalars['String'];
  fuelConsumptionMixedDriving: Scalars['Decimal'];
  fuelTypes: Array<Scalars['String']>;
  grossWeight: Scalars['Int'];
  hasManufacturerPackaging: Scalars['Boolean'];
  hasMrfPackaging: Scalars['Boolean'];
  id: Scalars['String'];
  imageList?: Maybe<Array<Maybe<CarMediaNew>>>;
  insuranceOption?: Maybe<CarInsuranceOptionNew>;
  interior?: Maybe<Scalars['String']>;
  invalidReason?: Maybe<Scalars['String']>;
  isCentralWarehouseCar: Scalars['Boolean'];
  isDemoCar: Scalars['Boolean'];
  isNewCar: Scalars['Boolean'];
  isOutletCar: Scalars['Boolean'];
  isTransportCar: Scalars['Boolean'];
  isUsedCar: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  lastPublicationDate: Scalars['DateTime'];
  lastRegistrationDate: Scalars['DateTime'];
  lastUpdatedDate: Scalars['DateTime'];
  leasingPrice: Scalars['Int'];
  manufactureYear: Scalars['Int'];
  maxCash: Scalars['Int'];
  maxDownPaymentPercentage: Scalars['Decimal'];
  mileage: Scalars['Int'];
  mileageUnit: Scalars['String'];
  minCash: Scalars['Int'];
  minDownPaymentPercentage: Scalars['Decimal'];
  model: Scalars['String'];
  modelUrlFriendly: Scalars['String'];
  modelYear: Scalars['Int'];
  monthFee: Scalars['Decimal'];
  monthlyFee: Scalars['Decimal'];
  movieList?: Maybe<Array<Maybe<CarMovieNew>>>;
  oldPrice: Scalars['Int'];
  price: Scalars['Int'];
  priceLowest30d: Scalars['Int'];
  registrationNumber: Scalars['String'];
  resellerPackagingOptions?: Maybe<ResellerPackagingOption>;
  salesCategory: SalesCategory;
  seats: Scalars['Int'];
  seoDescription: Scalars['String'];
  shortDescription: Scalars['String'];
  standardInterestRate: Scalars['Decimal'];
  stateReportList?: Maybe<Array<Scalars['Int']>>;
  stateReportUrl?: Maybe<Scalars['String']>;
  trailerWeight: Scalars['Int'];
  transmission: Scalars['String'];
  type: Scalars['String'];
  urlFriendlyRoute: Scalars['String'];
  usedCarOrganizationId: Scalars['String'];
  variant: Scalars['String'];
  vehicleGroup: Scalars['String'];
  visits: Scalars['Int'];
  warrantyExpireDate: Scalars['DateTime'];
  warrantyMileage: Scalars['Int'];
  warrantyText?: Maybe<Scalars['String']>;
  warrantyUsedCarMonths?: Maybe<Scalars['String']>;
};


export type CarNewImageListArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};

export type CarObjectAnchorLinksBarBlock = {
  __typename?: 'CarObjectAnchorLinksBarBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectBannerBlock = {
  __typename?: 'CarObjectBannerBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspText?: Maybe<Scalars['String']>;
  uspText2?: Maybe<Scalars['String']>;
};

export type CarObjectChargingCostBlock = BlockBaseType & {
  __typename?: 'CarObjectChargingCostBlock';
  animation?: Maybe<Scalars['String']>;
  annualMileageLabel?: Maybe<Scalars['String']>;
  annualMileageText?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  chargingCostLabel?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  customPriceText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disclaimerShortText?: Maybe<Scalars['String']>;
  disclaimerText?: Maybe<Scalars['String']>;
  electricityPrice?: Maybe<Scalars['Decimal']>;
  electricityPriceLabel?: Maybe<Scalars['String']>;
  electricityPriceType?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  gridFeeNotIncludedText?: Maybe<Scalars['String']>;
  gridFeeText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  openCalculatorButtons?: Maybe<Array<Maybe<CallToAction>>>;
  shade?: Maybe<Scalars['String']>;
  standardElectricityPriceIncText?: Maybe<Scalars['String']>;
  standardPriceText?: Maybe<Scalars['String']>;
  statedAnnualMileageText?: Maybe<Scalars['String']>;
  textBeforeCtaText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  vehicleBatteryCapacityText?: Maybe<Scalars['String']>;
  vehicleRangeText?: Maybe<Scalars['String']>;
};

export type CarObjectFeatureAccordionTableBlock = BlockBaseType & {
  __typename?: 'CarObjectFeatureAccordionTableBlock';
  accessoriesIcon?: Maybe<Scalars['String']>;
  accessoriesTitle?: Maybe<Scalars['String']>;
  accessoriesViewAllLabel?: Maybe<Scalars['String']>;
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carObjectStructure?: Maybe<Array<Maybe<Area>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  information?: Maybe<Scalars['String']>;
  isExpandedByDefault: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};


export type CarObjectFeatureAccordionTableBlockCarObjectStructureArgs = {
  languageCode: Scalars['String'];
};

export type CarObjectFeatureTableBlock = BlockBaseType & {
  __typename?: 'CarObjectFeatureTableBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carObjectStructure?: Maybe<Array<Maybe<Area>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isExpandedByDefault: Scalars['Boolean'];
  labelShowMore?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};


export type CarObjectFeatureTableBlockCarObjectStructureArgs = {
  languageCode: Scalars['String'];
};

export type CarObjectFinanceCalculatorGeneralBlock = BlockBaseType & {
  __typename?: 'CarObjectFinanceCalculatorGeneralBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  downPayment?: Maybe<Scalars['String']>;
  downPaymentCaption?: Maybe<Scalars['String']>;
  effectiveRate?: Maybe<Scalars['String']>;
  establishmentCost?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  financingProposal?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  interest?: Maybe<Scalars['String']>;
  isExpandedByDefault: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  monthlyFee?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  termLength?: Maybe<Scalars['String']>;
  termLengthUnit?: Maybe<Scalars['String']>;
  termsLengths?: Maybe<Array<Maybe<Scalars['String']>>>;
  termsLengthsDefault?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCostWithDownPayment?: Maybe<Scalars['String']>;
  totalCreditCost?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectFinanceCalculatorWaykeBlock = BlockBaseType & {
  __typename?: 'CarObjectFinanceCalculatorWaykeBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  downPayment?: Maybe<Scalars['String']>;
  downPaymentCaption?: Maybe<Scalars['String']>;
  effectiveRate?: Maybe<Scalars['String']>;
  establishmentCost?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  financingProposal?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  interest?: Maybe<Scalars['String']>;
  isExpandedByDefault: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  monthlyFee?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  termLength?: Maybe<Scalars['String']>;
  termLengthUnit?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCostWithDownPayment?: Maybe<Scalars['String']>;
  totalCreditCost?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectGalleryBlock = BlockBaseType & {
  __typename?: 'CarObjectGalleryBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  footerButtonText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isExpandedByDefault: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  usps?: Maybe<Array<Maybe<CarGalleryUsp>>>;
};

export type CarObjectHeaderBlock = BlockBaseType & {
  __typename?: 'CarObjectHeaderBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectHeroBlock = BlockBaseType & {
  __typename?: 'CarObjectHeroBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  manufacturerPackagingName?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  salesPersonContactUrl?: Maybe<Scalars['String']>;
  salesPersons?: Maybe<Array<Maybe<SalesPerson>>>;
  shade?: Maybe<Scalars['String']>;
  showAllSalesMen: Scalars['Boolean'];
  showSalesmen: Scalars['Boolean'];
  slideShow: Scalars['Boolean'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspText?: Maybe<Scalars['String']>;
};

export type CarObjectInsuranceBlock = BlockBaseType & {
  __typename?: 'CarObjectInsuranceBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  errorText?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelButtonText?: Maybe<Scalars['String']>;
  labelEnterEstimatedMileage?: Maybe<Scalars['String']>;
  labelEnterSocialSecurityNumber?: Maybe<Scalars['String']>;
  labelInsuranceIncludes?: Maybe<Scalars['String']>;
  labelInsuranceOptions?: Maybe<Scalars['String']>;
  labelInsuranceShowMore?: Maybe<Scalars['String']>;
  labelShowLess?: Maybe<Scalars['String']>;
  labelShowMore?: Maybe<Scalars['String']>;
  labelSocialSecurityPlaceholder?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primaryText?: Maybe<Scalars['String']>;
  secondaryText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tertiaryText?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectInsuranceCalculatorBlock = BlockBaseType & {
  __typename?: 'CarObjectInsuranceCalculatorBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  errorText?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isExpandedByDefault: Scalars['Boolean'];
  labelButtonText?: Maybe<Scalars['String']>;
  labelEnterEstimatedMileage?: Maybe<Scalars['String']>;
  labelEnterSocialSecurityNumber?: Maybe<Scalars['String']>;
  labelEstimatedMileagePlaceholder?: Maybe<Scalars['String']>;
  labelInsuranceIncludes?: Maybe<Scalars['String']>;
  labelInsuranceOptions?: Maybe<Scalars['String']>;
  labelInsuranceShowMore?: Maybe<Scalars['String']>;
  labelShowLess?: Maybe<Scalars['String']>;
  labelShowMore?: Maybe<Scalars['String']>;
  labelSocialSecurityPlaceholder?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primaryText?: Maybe<Scalars['String']>;
  secondaryText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tertiaryText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectLeadinLargeBlock = BlockBaseType & {
  __typename?: 'CarObjectLeadinLargeBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  renderInCarObjectHero: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showFinanceAnchorLink: Scalars['Boolean'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspText?: Maybe<Scalars['String']>;
  whiteText: Scalars['Boolean'];
};

export type CarObjectSalesDescriptionBlock = BlockBaseType & {
  __typename?: 'CarObjectSalesDescriptionBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelViewLess?: Maybe<Scalars['String']>;
  labelViewMore?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectTestInfoBlock = BlockBaseType & {
  __typename?: 'CarObjectTestInfoBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  header?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  iconText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  illustrationUrl?: Maybe<Scalars['String']>;
  indexedDate: Scalars['DateTime'];
  isExpandedByDefault: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  testPoints?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarObjectWarrantiesBlock = BlockBaseType & {
  __typename?: 'CarObjectWarrantiesBlock';
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isExpandedByDefault: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarPriceInfo = {
  __typename?: 'CarPriceInfo';
  businessLeasingPrice: Scalars['Int'];
  /** @deprecated Remove once MON-3975 is closed */
  campaignCode?: Maybe<Scalars['String']>;
  financeMonthPrice: Scalars['Int'];
  financeOptions?: Maybe<Array<Maybe<CarFinanceOption>>>;
  /** @deprecated Remove once MON-3975 is closed */
  isOnCampaign: Scalars['Boolean'];
  leasingPrice: Scalars['Int'];
  oldPrice: Scalars['Int'];
  price: Scalars['Decimal'];
  priceExclVat: Scalars['Decimal'];
  priceLowest30d: Scalars['Int'];
};

export type CarResellerPackagingOption = {
  __typename?: 'CarResellerPackagingOption';
  ctaName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CarSearchBarBlock = BlockBaseType & {
  __typename?: 'CarSearchBarBlock';
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isSticky: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarSearchBlock = BlockBaseType & {
  __typename?: 'CarSearchBlock';
  activeFilterLabel?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttonAllFiltersLabel?: Maybe<Scalars['String']>;
  carComparisonPage?: Maybe<Scalars['String']>;
  carSearchButtonLabel?: Maybe<Scalars['String']>;
  carSearchPlaceholderLabel?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  clearAllFiltersLabel?: Maybe<Scalars['String']>;
  clearFilterAriaLabel?: Maybe<Scalars['String']>;
  clearFiltersLabel?: Maybe<Scalars['String']>;
  collapseFiltersLabel?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  contentLink?: Maybe<Scalars['String']>;
  /** @deprecated Use default flag from Sortings-list instead, remove this property once FE is not using it anymore */
  defaultSort?: Maybe<Scalars['String']>;
  everythingIsLoadedLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  expandFiltersLabel?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CarSearchFilter>>>;
  filtersHeading?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  infiniteScroll: Scalars['Boolean'];
  infinityScrollLimit: Scalars['Int'];
  initialFilterCount: Scalars['Int'];
  loadMoreLabel?: Maybe<Scalars['String']>;
  loadingNewContentLabel?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  minimumColumnsOnSmallerScreens: Scalars['Boolean'];
  mixInBlockFrequency: Scalars['Int'];
  mixInBlockIds?: Maybe<Array<Scalars['ID']>>;
  mixInBlockRepetitions: Scalars['Int'];
  mixedContentQuery?: Maybe<Array<Maybe<SelectedQuery>>>;
  name?: Maybe<Scalars['String']>;
  pageSize: Scalars['Int'];
  resultLabel?: Maybe<Scalars['String']>;
  searchPlaceholderLabel?: Maybe<Scalars['String']>;
  seoBlockIds?: Maybe<Array<Scalars['ID']>>;
  shade?: Maybe<Scalars['String']>;
  showCompare: Scalars['Boolean'];
  showLessFiltersLabel?: Maybe<Scalars['String']>;
  showMoreFiltersLabel?: Maybe<Scalars['String']>;
  sortings?: Maybe<Array<Maybe<TextValue>>>;
  templateId?: Maybe<Scalars['String']>;
  titleAllFiltersLabel?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useQuickView: Scalars['Boolean'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarSearchFilter = {
  __typename?: 'CarSearchFilter';
  key?: Maybe<Scalars['String']>;
  keyword: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type CarSearchResultViewModel = {
  __typename?: 'CarSearchResultViewModel';
  aggregates?: Maybe<Array<Maybe<AggregateTypes>>>;
  cars?: Maybe<Array<Maybe<CarNew>>>;
  totalNumberOfHits: Scalars['Long'];
};

export type CarSiteSearchResultType = {
  __typename?: 'CarSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  matchedFilters?: Maybe<Array<Maybe<KeyValuePair>>>;
  results?: Maybe<Array<Maybe<Car>>>;
  suggestedBrand?: Maybe<Scalars['String']>;
  totalHits: Scalars['Long'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type CarStatus = {
  __typename?: 'CarStatus';
  lastPublicationDate: Scalars['DateTime'];
  lastRegistrationDate: Scalars['DateTime'];
  lastUpdatedDate: Scalars['DateTime'];
  visits: Scalars['Int'];
};

export type CarText = {
  __typename?: 'CarText';
  carHeader?: Maybe<Scalars['String']>;
  carTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type CarVariantPickerBlock = BlockBaseType & {
  __typename?: 'CarVariantPickerBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  engineStructureTemplateId?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fullStructureTemplateId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  show360AndColors: Scalars['Boolean'];
  showTemplateStructure: Scalars['Boolean'];
  tabName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CarWarrantyObj = {
  __typename?: 'CarWarrantyObj';
  carWarranty?: Maybe<Scalars['String']>;
  warrantyExpireDate: Scalars['DateTime'];
  warrantyMileage: Scalars['Int'];
  warrantyText?: Maybe<Scalars['String']>;
  warrantyUsedCarMonths?: Maybe<Scalars['String']>;
};

export type Cart = {
  __typename?: 'Cart';
  /** @deprecated Details about applied discounts have been moved to priceDetails */
  discount: CartDiscount;
  /** @deprecated Cart id has been removed and replaced by order id */
  id: Scalars['Guid'];
  items: Array<Maybe<CartItem>>;
  priceDetails: Array<Maybe<CartPriceDetail>>;
  /** @deprecated Properties on cart is not been used and has been marked for deletion. */
  properties: Scalars['CartProperties'];
  totalPrice: CartPrice;
  totalPriceBeforeDiscount: CartPrice;
};

export type CartCustomerInformationAddressGraphType = {
  __typename?: 'CartCustomerInformationAddressGraphType';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};

export type CartCustomerInformationGraphType = {
  __typename?: 'CartCustomerInformationGraphType';
  address?: Maybe<CartCustomerInformationAddressGraphType>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  amount: Scalars['Decimal'];
  items: Array<Maybe<CartDiscountItem>>;
};

export type CartDiscountItem = {
  __typename?: 'CartDiscountItem';
  amount: Scalars['Decimal'];
  name: Scalars['String'];
};

export type CartItem = {
  __typename?: 'CartItem';
  code?: Maybe<Scalars['String']>;
  /** @deprecated Details about applied discounts have been moved to priceDetails */
  discount: CartDiscount;
  id?: Maybe<Scalars['Guid']>;
  priceDetails: Array<Maybe<CartPriceDetail>>;
  product?: Maybe<CartProductsUnion>;
  properties: Scalars['CartProperties'];
  quantity: Scalars['Decimal'];
  totalPrice: CartPrice;
  totalPriceBeforeDiscount: CartPrice;
  unitPrice: CartPrice;
  unitPriceBeforeDiscount: CartPrice;
  /** Is either the null or the variation that the item references to */
  variation?: Maybe<VariationsUnion>;
};

export type CartPrice = {
  __typename?: 'CartPrice';
  amount: Scalars['Decimal'];
  amountExcludingTax: Scalars['Decimal'];
  taxAmount: Scalars['Decimal'];
};

export type CartPriceDetail = {
  __typename?: 'CartPriceDetail';
  amount: Scalars['Decimal'];
  name: Scalars['String'];
  type: PriceDetailType;
};

export type CartProductImage = {
  __typename?: 'CartProductImage';
  altText?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
};

export type CartProductsUnion = PackageCartProduct | ServiceCartProduct | TireCartProduct;

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CategoryLeadinCard = BlockBaseType & {
  __typename?: 'CategoryLeadinCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  link?: Maybe<Array<Maybe<CallToAction>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CategoryLinksBlock = BlockBaseType & {
  __typename?: 'CategoryLinksBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type CheckboxListOption = {
  __typename?: 'CheckboxListOption';
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type CheckoutBlock = {
  __typename?: 'CheckoutBlock';
  acceptTermsLinkText?: Maybe<Scalars['String']>;
  acceptTermsText?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookAndOrderHeading?: Maybe<Scalars['String']>;
  bookTimeAndPlace?: Maybe<Scalars['String']>;
  branchAndTimeCalendarHeading?: Maybe<Scalars['String']>;
  branchAndTimeChangeDate?: Maybe<Scalars['String']>;
  branchAndTimeHeading?: Maybe<Scalars['String']>;
  branchAndTimeSlotsHeading?: Maybe<Scalars['String']>;
  branchSearchNoResult?: Maybe<Scalars['String']>;
  branchSuggestions?: Maybe<Scalars['String']>;
  branchesViewMore?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  changeBranch?: Maybe<Scalars['String']>;
  changeTime?: Maybe<Scalars['String']>;
  checkoutHeading?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contactFormHeading?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dateAndTimeHeading?: Maybe<Scalars['String']>;
  emailErrorText?: Maybe<Scalars['String']>;
  emailLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  faqLinkText?: Maybe<Scalars['String']>;
  faqLists?: Maybe<Array<Maybe<FaqListBlock>>>;
  findBranchHeading?: Maybe<Scalars['String']>;
  firstNameLabel?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  lastNameLabel?: Maybe<Scalars['String']>;
  leaveCarTimeHeading?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  moreSalesHeading?: Maybe<Scalars['String']>;
  moreSalesListHeading?: Maybe<Scalars['String']>;
  moreSalesNoneSelected?: Maybe<Scalars['String']>;
  moreSalesViewMore?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneErrorText?: Maybe<Scalars['String']>;
  phoneLabel?: Maybe<Scalars['String']>;
  returnCarHeading?: Maybe<Scalars['String']>;
  saveAndContinue?: Maybe<Scalars['String']>;
  searchLabel?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  searchTip?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showAllDays?: Maybe<Scalars['String']>;
  showMoreBranches?: Maybe<Scalars['String']>;
  smsReminder?: Maybe<Scalars['String']>;
  stepOf?: Maybe<Scalars['String']>;
  submitModalCompletedButton?: Maybe<Scalars['String']>;
  submitModalCompletedInstructions?: Maybe<Scalars['String']>;
  submitModalCompletedStatus?: Maybe<Scalars['String']>;
  submitModalErrorButton?: Maybe<Scalars['String']>;
  submitModalErrorContactPhoneNumber?: Maybe<Scalars['String']>;
  submitModalErrorInstructions?: Maybe<Scalars['String']>;
  submitModalErrorStatus?: Maybe<Scalars['String']>;
  submitModalHeading?: Maybe<Scalars['String']>;
  submitModalProcessingInstructions?: Maybe<Scalars['String']>;
  submitModalProcessingStatus?: Maybe<Scalars['String']>;
  submitModalProcessingStatusSlow?: Maybe<Scalars['String']>;
  submitModalProcessingStatusVerySlow?: Maybe<Scalars['String']>;
  submitOrderButton?: Maybe<Scalars['String']>;
  summaryDateAndTimeHeading?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  termsHeading?: Maybe<Scalars['String']>;
  timeFilterAfternoon?: Maybe<Scalars['String']>;
  timeFilterAll?: Maybe<Scalars['String']>;
  timeFilterHeading?: Maybe<Scalars['String']>;
  timeFilterLunch?: Maybe<Scalars['String']>;
  timeFilterMorning?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export enum CheckoutStatus {
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Processing = 'PROCESSING'
}

export type CheckoutStep = {
  status: CheckoutStepStatus;
};

export enum CheckoutStepStatus {
  Available = 'AVAILABLE',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED'
}

export type ColorTermsAggregate = AggregateBase & {
  __typename?: 'ColorTermsAggregate';
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ColorTermsAggregateViewModelItem>>>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type ColorTermsAggregateViewModelItem = {
  __typename?: 'ColorTermsAggregateViewModelItem';
  color: Scalars['String'];
  hitCount: Scalars['Long'];
  selected: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ConditionalRate = {
  __typename?: 'ConditionalRate';
  conditionMaxTermLength: Scalars['Decimal'];
  conditionMinDownPaymentPercent: Scalars['Decimal'];
  interestRate: Scalars['Decimal'];
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactActionBarBlock = BlockBaseType & {
  __typename?: 'ContactActionBarBlock';
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  horizontalPosition?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  sticky: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type ContainerInput = {
  containerId: Scalars['Int'];
  technician?: InputMaybe<TechnicianInput>;
};

export type Content = {
  __typename?: 'Content';
  score?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ContentSiteSearchResultType = {
  __typename?: 'ContentSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  results?: Maybe<Array<Maybe<Content>>>;
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CurrentBrandBlock = BlockBaseType & {
  __typename?: 'CurrentBrandBlock';
  allCarBrandsText?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  brands?: Maybe<Array<Maybe<CallToAction>>>;
  carBrandButtonLabel?: Maybe<Scalars['String']>;
  carBrandsModalTitle?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  clearFilterText?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  selectedCarBrandPrefix?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showBrandModalByDefault: Scalars['Boolean'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Customer = {
  __typename?: 'Customer';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  registrationNumber: Scalars['String'];
};

export type CustomerInformationCheckoutStep = CheckoutStep & {
  __typename?: 'CustomerInformationCheckoutStep';
  /** CustomerInformationState */
  state?: Maybe<CustomerInformationState>;
  status: CheckoutStepStatus;
};

export type CustomerInformationInput = {
  customerComment?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  place?: InputMaybe<Scalars['String']>;
};

export type CustomerInformationState = {
  __typename?: 'CustomerInformationState';
  /** CustomerInformation */
  customerInformation?: Maybe<CartCustomerInformationGraphType>;
};

export type Day = {
  __typename?: 'Day';
  available: Scalars['Boolean'];
  availableTechnician?: Maybe<Array<Scalars['Int']>>;
  date: Scalars['DateTime'];
  dateUtc: Scalars['DateTimeOffset'];
  dayInWeek: Scalars['Int'];
  label: Scalars['Int'];
  month: Scalars['String'];
  newMonth: Scalars['Boolean'];
  retrieveTimeSlots: Scalars['Boolean'];
  slotGroups?: Maybe<Array<Maybe<Slot>>>;
};

export type DeleteBookingRequest = {
  bookingId: Scalars['String'];
  branchId: Scalars['ID'];
  indexPrefix?: InputMaybe<Scalars['String']>;
  regionCode: Scalars['Int'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['ID'];
  siteId: Scalars['ID'];
};

export type DeleteCarFavoritesListResponse = {
  __typename?: 'DeleteCarFavoritesListResponse';
  result: Scalars['Boolean'];
};

export type DeleteCarFromFavoritesResponse = {
  __typename?: 'DeleteCarFromFavoritesResponse';
  cars?: Maybe<Array<Maybe<Car>>>;
  createDate: Scalars['DateTime'];
  lastReadDate: Scalars['DateTime'];
  listId?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
};

export enum DeliveryDateStatus {
  InStock = 'IN_STOCK',
  LongDeliveryTime = 'LONG_DELIVERY_TIME',
  OutOfStock = 'OUT_OF_STOCK'
}

export type Department = {
  __typename?: 'Department';
  name?: Maybe<Scalars['String']>;
  openHours?: Maybe<Array<Maybe<OpenHour>>>;
  sortOrder: Scalars['Int'];
  specialOpenHours?: Maybe<Array<Maybe<OpenHour>>>;
};

export type DispositionAreaPropertyBlock = BlockBaseType & {
  __typename?: 'DispositionAreaPropertyBlock';
  animation?: Maybe<Scalars['String']>;
  bleed: Scalars['Boolean'];
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subTheme?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type DispositionBlock = BlockBaseType & {
  __typename?: 'DispositionBlock';
  animation?: Maybe<Scalars['String']>;
  area1?: Maybe<DispositionAreaPropertyBlock>;
  area2?: Maybe<DispositionAreaPropertyBlock>;
  area3?: Maybe<DispositionAreaPropertyBlock>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  reversSmall: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Download = {
  __typename?: 'Download';
  altText?: Maybe<Scalars['String']>;
  changed: Scalars['DateTime'];
  contentReferenceId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  externalDownloadUrl?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['String']>;
  fileTypeDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ResourceType;
};

export type DynamicListBlock = BlockBaseType & {
  __typename?: 'DynamicListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  carSearchPageQueryParams?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fetchCount: Scalars['Int'];
  fixed: Scalars['Boolean'];
  hScroll: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  infiniteScroll: Scalars['Boolean'];
  infinityThreshold: Scalars['Int'];
  labelLoadMoreButton?: Maybe<Scalars['String']>;
  mainQuery?: Maybe<Array<Maybe<SelectedQuery>>>;
  mediaIds: Array<Scalars['Int']>;
  minimumColumnsOnSmallerScreens: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  paginationLarge: Scalars['Int'];
  paginationSmall: Scalars['Int'];
  searchFilterParameters?: Maybe<Array<Maybe<SearchFilterParameter>>>;
  shade?: Maybe<Scalars['String']>;
  showCount: Scalars['Int'];
  subQueries?: Maybe<Array<Maybe<SelectedQuery>>>;
  type: Scalars['String'];
  useDefaultSearchPageForViewMore: Scalars['Boolean'];
  useVerticalMargin: Scalars['Boolean'];
};

export type EmployeeGenericType = SalesPerson | Technician;

export type EnhancedProperties = {
  __typename?: 'EnhancedProperties';
  aEBValue: Scalars['Boolean'];
  aUXValue: Scalars['Boolean'];
  absValue: Scalars['Boolean'];
  accelerationValue: Scalars['Decimal'];
  adultOccupantNCAPValue: Scalars['Int'];
  airbagCutOffSwitchValue: Scalars['Boolean'];
  airbagDriverValue: Scalars['Boolean'];
  airbagFrontalHeadValue: Scalars['Boolean'];
  airbagFrontalValue: Scalars['Boolean'];
  airbagKneesValue: Scalars['Boolean'];
  airbagPassengerValue: Scalars['Boolean'];
  airbagSideChestValue: Scalars['Boolean'];
  airbagSidePelvisValue: Scalars['Boolean'];
  alcolockValue: Scalars['Boolean'];
  androidAutoValue: Scalars['Boolean'];
  annualBonusValue: Scalars['Int'];
  annualMalusValue: Scalars['Int'];
  annualTaxValue: Scalars['Int'];
  antiTheftAlarmValue: Scalars['Boolean'];
  appConnectValue: Scalars['Boolean'];
  appleCarPlayValue: Scalars['Boolean'];
  auxiliaryLampsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  batteryCapacityValue: Scalars['Decimal'];
  batteryWarrantyDistanceValue: Scalars['Int'];
  batteryWarrantyTimeValue: Scalars['Int'];
  blindSpotWarnerValue: Scalars['Boolean'];
  bluetoothAudioValue: Scalars['Boolean'];
  bluetoothPhoneValue: Scalars['Boolean'];
  bluetoothValue: Scalars['Boolean'];
  brakeAssistanceValue: Scalars['Boolean'];
  carDamageWarrantyDistanceValue: Scalars['Int'];
  carDamageWarrantyTimeValue: Scalars['Int'];
  centerDisplayValue: Scalars['Boolean'];
  centralLockingValue: Scalars['Boolean'];
  chargeTimeNormalValue: Scalars['Int'];
  chargeTimeQuickValue: Scalars['Int'];
  chassisValue?: Maybe<Scalars['String']>;
  childOccupantNCAPValue: Scalars['Int'];
  childSafetyLocksValue: Scalars['Boolean'];
  childSeatBeltPassengerValue: Scalars['Boolean'];
  childSeatBeltRearValue: Scalars['Boolean'];
  co2Value: Scalars['Int'];
  colorNameValue?: Maybe<Scalars['String']>;
  combinedEmissionsWLTPValue: Scalars['Int'];
  cruiseControlValue: Scalars['Boolean'];
  curtainAirbagsValue: Scalars['Boolean'];
  displacementCCValue: Scalars['Int'];
  displacementLitresValue: Scalars['Decimal'];
  driverAlertnessDetectionValue: Scalars['Boolean'];
  drivingWheelValue?: Maybe<Scalars['String']>;
  electricalEngineValue: Scalars['Boolean'];
  electricalRangeEPAValue: Scalars['Int'];
  electricalRangeNEDCValue: Scalars['Decimal'];
  electricalRangeWLTPValue: Scalars['Int'];
  electricalSeatDriverValue: Scalars['Boolean'];
  electricalSeatPassengerValue: Scalars['Boolean'];
  emergencyCallingValue: Scalars['Boolean'];
  engineConfigurationValue?: Maybe<Scalars['String']>;
  engineCylindersValue: Scalars['Int'];
  engineNameValue?: Maybe<Scalars['String']>;
  enrichmentProviderEquipPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderExteriorPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderInteriorPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderTrimPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  environmentClassValue?: Maybe<Scalars['String']>;
  finishValue?: Maybe<Scalars['String']>;
  fuelConsumptionCityDrivingValue: Scalars['Decimal'];
  fuelConsumptionCountryRoadDrivingValue: Scalars['Decimal'];
  fuelConsumptionMixedDrivingValue: Scalars['Decimal'];
  gPSValue: Scalars['Boolean'];
  gearboxNameValue?: Maybe<Scalars['String']>;
  gestureControlsValue: Scalars['Boolean'];
  grossWeightValue: Scalars['Int'];
  groundClearenceValue: Scalars['Int'];
  hDMIValue: Scalars['Boolean'];
  hasAutomaticGearboxValue: Scalars['Boolean'];
  headRoomFrontValue: Scalars['Int'];
  headRoomRearValue: Scalars['Int'];
  headUpDisplayValue: Scalars['Boolean'];
  heatedSteeringWheelValue: Scalars['Boolean'];
  heightValue: Scalars['Int'];
  hybridComponentsWarrantyDistanceValue: Scalars['Int'];
  hybridComponentsWarrantyTimeValue: Scalars['Int'];
  interiorMaterialValue?: Maybe<Scalars['String']>;
  isofixRearSeatValue: Scalars['Boolean'];
  keylessEntryValue: Scalars['Boolean'];
  keylessStartValue: Scalars['Boolean'];
  laneAssistanceValue: Scalars['Boolean'];
  legRoomFrontValue: Scalars['Int'];
  legRoomRearValue: Scalars['Int'];
  lengthValue: Scalars['Int'];
  lowBeamValue?: Maybe<Scalars['String']>;
  mainBeamAssistanceValue: Scalars['Boolean'];
  mainBeamValue?: Maybe<Scalars['String']>;
  massageValue: Scalars['Boolean'];
  maxLoadWeightValue: Scalars['Int'];
  maxRoofWeightValue: Scalars['Int'];
  maxSpeedValue: Scalars['Int'];
  maxTrailerLoadUnbrakedValue: Scalars['Int'];
  mildHybridValue: Scalars['Boolean'];
  ncapStarValue: Scalars['Int'];
  ncapYearValue: Scalars['Int'];
  newVehicleWarrantyDistanceValue: Scalars['Int'];
  newVehicleWarrantyTimeValue: Scalars['Int'];
  noiseReducingWindowsValue: Scalars['Boolean'];
  numberOfGearsValue: Scalars['Int'];
  numberOfSpeakersValue: Scalars['Int'];
  numberOfUSBPortsValue: Scalars['Int'];
  otherAirbagsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  parkingAssistanceValue: Scalars['Boolean'];
  parkingSensorsFrontValue: Scalars['Boolean'];
  parkingSensorsRearValue: Scalars['Boolean'];
  pedestrianNCAPValue: Scalars['Int'];
  preHeaterValue: Scalars['Boolean'];
  rainSensorsValue: Scalars['Boolean'];
  remoteStartValue: Scalars['Boolean'];
  rimSizeValue: Scalars['Int'];
  roofColorValue?: Maybe<Scalars['String']>;
  roofRailingValue: Scalars['Boolean'];
  safetyAssistNCAPValue: Scalars['Int'];
  seatsValue: Scalars['Int'];
  segmentValue?: Maybe<Scalars['String']>;
  serviceWeightValue: Scalars['Int'];
  shoulderRoomFrontValue: Scalars['Int'];
  shoulderRoomRearValue: Scalars['Int'];
  sideMirrorFoldingValue?: Maybe<Scalars['String']>;
  speakerBrandValue?: Maybe<Scalars['String']>;
  startAndStopValue: Scalars['Boolean'];
  steeringWheelMaterialValue?: Maybe<Scalars['String']>;
  sunRoofValue: Scalars['Boolean'];
  tankVolumeValue: Scalars['Decimal'];
  timingBeltServiceIntervalDistanceValue: Scalars['Int'];
  timingBeltServiceIntervalTimeValue: Scalars['Int'];
  tintedWindowsValue: Scalars['Boolean'];
  tiresFrontValue?: Maybe<Scalars['String']>;
  tiresRearValue?: Maybe<Scalars['String']>;
  torqueValue: Scalars['Int'];
  touchScreenValue: Scalars['Boolean'];
  towHitchDetachableValue: Scalars['Boolean'];
  towHitchFoldableValue?: Maybe<Scalars['String']>;
  towHitchValue: Scalars['Boolean'];
  trafficSignRecognitionValue: Scalars['Boolean'];
  trailerTotalWeightBValue: Scalars['Int'];
  transmissionKnobMaterialValue?: Maybe<Scalars['String']>;
  trcSystemValue: Scalars['Boolean'];
  tripComputerValue: Scalars['Boolean'];
  trunkDepthValue: Scalars['Int'];
  trunkHeightValue: Scalars['Int'];
  trunkOutletValue: Scalars['Boolean'];
  trunkSpaceFrontValue: Scalars['Int'];
  trunkSpaceValue: Scalars['Int'];
  trunkWidthValue: Scalars['Int'];
  typeOfElectricCarValue?: Maybe<Scalars['String']>;
  uSBValue: Scalars['Boolean'];
  upholsteryValue?: Maybe<Scalars['String']>;
  ventilatedSeatsValue: Scalars['Boolean'];
  wheelBaseValue: Scalars['Int'];
  wiFiValue: Scalars['Boolean'];
  widthValue: Scalars['Int'];
  windowLiftsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  wirelessPhoneChargerValue: Scalars['Boolean'];
};

export type EnhancedPropertiesNew = {
  __typename?: 'EnhancedPropertiesNew';
  aEBValue: Scalars['Boolean'];
  aUXValue: Scalars['Boolean'];
  absValue: Scalars['Boolean'];
  accelerationValue: Scalars['Decimal'];
  adultOccupantNCAPValue: Scalars['Int'];
  airbagCutOffSwitchValue: Scalars['Boolean'];
  airbagDriverValue: Scalars['Boolean'];
  airbagFrontalHeadValue: Scalars['Boolean'];
  airbagFrontalValue: Scalars['Boolean'];
  airbagKneesValue: Scalars['Boolean'];
  airbagPassengerValue: Scalars['Boolean'];
  airbagSideChestValue: Scalars['Boolean'];
  airbagSidePelvisValue: Scalars['Boolean'];
  alcolockValue: Scalars['Boolean'];
  androidAutoValue: Scalars['Boolean'];
  annualBonusValue: Scalars['Int'];
  annualMalusValue: Scalars['Int'];
  annualTaxValue: Scalars['Int'];
  antiTheftAlarmValue: Scalars['Boolean'];
  appConnectValue: Scalars['Boolean'];
  appleCarPlayValue: Scalars['Boolean'];
  auxiliaryLampsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  batteryCapacityValue: Scalars['Decimal'];
  batteryWarrantyDistanceValue: Scalars['Int'];
  batteryWarrantyTimeValue: Scalars['Int'];
  blindSpotWarnerValue: Scalars['Boolean'];
  bluetoothAudioValue: Scalars['Boolean'];
  bluetoothPhoneValue: Scalars['Boolean'];
  bluetoothValue: Scalars['Boolean'];
  brakeAssistanceValue: Scalars['Boolean'];
  carDamageWarrantyDistanceValue: Scalars['Int'];
  carDamageWarrantyTimeValue: Scalars['Int'];
  centerDisplayValue: Scalars['Boolean'];
  centralLockingValue: Scalars['Boolean'];
  chargeTimeNormalValue: Scalars['Int'];
  chargeTimeQuickValue: Scalars['Int'];
  chassisValue?: Maybe<Scalars['String']>;
  childOccupantNCAPValue: Scalars['Int'];
  childSafetyLocksValue: Scalars['Boolean'];
  childSeatBeltPassengerValue: Scalars['Boolean'];
  childSeatBeltRearValue: Scalars['Boolean'];
  co2Value: Scalars['Int'];
  colorNameValue?: Maybe<Scalars['String']>;
  combinedEmissionsWLTPValue: Scalars['Int'];
  cruiseControlValue: Scalars['Boolean'];
  curtainAirbagsValue: Scalars['Boolean'];
  displacementCCValue: Scalars['Int'];
  displacementLitresValue: Scalars['Decimal'];
  driverAlertnessDetectionValue: Scalars['Boolean'];
  drivingWheelValue?: Maybe<Scalars['String']>;
  electricalEngineValue: Scalars['Boolean'];
  electricalRangeEPAValue: Scalars['Int'];
  electricalRangeNEDCValue: Scalars['Decimal'];
  electricalRangeWLTPValue: Scalars['Int'];
  electricalSeatDriverValue: Scalars['Boolean'];
  electricalSeatPassengerValue: Scalars['Boolean'];
  emergencyCallingValue: Scalars['Boolean'];
  engineConfigurationValue?: Maybe<Scalars['String']>;
  engineCylindersValue: Scalars['Int'];
  engineNameValue?: Maybe<Scalars['String']>;
  enrichmentProviderEquipPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderExteriorPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderInteriorPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  enrichmentProviderTrimPackagesValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  environmentClassValue?: Maybe<Scalars['String']>;
  finishValue?: Maybe<Scalars['String']>;
  fuelConsumptionCityDrivingValue: Scalars['Decimal'];
  fuelConsumptionCountryRoadDrivingValue: Scalars['Decimal'];
  fuelConsumptionMixedDrivingValue: Scalars['Decimal'];
  gPSValue: Scalars['Boolean'];
  gearboxNameValue?: Maybe<Scalars['String']>;
  gestureControlsValue: Scalars['Boolean'];
  grossWeightValue: Scalars['Int'];
  groundClearenceValue: Scalars['Int'];
  hDMIValue: Scalars['Boolean'];
  hasAutomaticGearboxValue: Scalars['Boolean'];
  headRoomFrontValue: Scalars['Int'];
  headRoomRearValue: Scalars['Int'];
  headUpDisplayValue: Scalars['Boolean'];
  heatedSteeringWheelValue: Scalars['Boolean'];
  heightValue: Scalars['Int'];
  hybridComponentsWarrantyDistanceValue: Scalars['Int'];
  hybridComponentsWarrantyTimeValue: Scalars['Int'];
  interiorMaterialValue?: Maybe<Scalars['String']>;
  isofixRearSeatValue: Scalars['Boolean'];
  keylessEntryValue: Scalars['Boolean'];
  keylessStartValue: Scalars['Boolean'];
  laneAssistanceValue: Scalars['Boolean'];
  legRoomFrontValue: Scalars['Int'];
  legRoomRearValue: Scalars['Int'];
  lengthValue: Scalars['Int'];
  lowBeamValue?: Maybe<Scalars['String']>;
  mainBeamAssistanceValue: Scalars['Boolean'];
  mainBeamValue?: Maybe<Scalars['String']>;
  massageValue: Scalars['Boolean'];
  maxLoadWeightValue: Scalars['Int'];
  maxRoofWeightValue: Scalars['Int'];
  maxSpeedValue: Scalars['Int'];
  maxTrailerLoadUnbrakedValue: Scalars['Int'];
  mildHybridValue: Scalars['Boolean'];
  ncapStarValue: Scalars['Int'];
  ncapYearValue: Scalars['Int'];
  newVehicleWarrantyDistanceValue: Scalars['Int'];
  newVehicleWarrantyTimeValue: Scalars['Int'];
  noiseReducingWindowsValue: Scalars['Boolean'];
  numberOfGearsValue: Scalars['Int'];
  numberOfSpeakersValue: Scalars['Int'];
  numberOfUSBPortsValue: Scalars['Int'];
  otherAirbagsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  parkingAssistanceValue: Scalars['Boolean'];
  parkingSensorsFrontValue: Scalars['Boolean'];
  parkingSensorsRearValue: Scalars['Boolean'];
  pedestrianNCAPValue: Scalars['Int'];
  preHeaterValue: Scalars['Boolean'];
  rainSensorsValue: Scalars['Boolean'];
  remoteStartValue: Scalars['Boolean'];
  rimSizeValue: Scalars['Int'];
  roofColorValue?: Maybe<Scalars['String']>;
  roofRailingValue: Scalars['Boolean'];
  safetyAssistNCAPValue: Scalars['Int'];
  seatsValue: Scalars['Int'];
  segmentValue?: Maybe<Scalars['String']>;
  serviceWeightValue: Scalars['Int'];
  shoulderRoomFrontValue: Scalars['Int'];
  shoulderRoomRearValue: Scalars['Int'];
  sideMirrorFoldingValue?: Maybe<Scalars['String']>;
  speakerBrandValue?: Maybe<Scalars['String']>;
  startAndStopValue: Scalars['Boolean'];
  steeringWheelMaterialValue?: Maybe<Scalars['String']>;
  sunRoofValue: Scalars['Boolean'];
  tankVolumeValue: Scalars['Decimal'];
  timingBeltServiceIntervalDistanceValue: Scalars['Int'];
  timingBeltServiceIntervalTimeValue: Scalars['Int'];
  tintedWindowsValue: Scalars['Boolean'];
  tiresFrontValue?: Maybe<Scalars['String']>;
  tiresRearValue?: Maybe<Scalars['String']>;
  torqueValue: Scalars['Int'];
  touchScreenValue: Scalars['Boolean'];
  towHitchDetachableValue: Scalars['Boolean'];
  towHitchFoldableValue?: Maybe<Scalars['String']>;
  towHitchValue: Scalars['Boolean'];
  trafficSignRecognitionValue: Scalars['Boolean'];
  trailerTotalWeightBValue: Scalars['Int'];
  transmissionKnobMaterialValue?: Maybe<Scalars['String']>;
  trcSystemValue: Scalars['Boolean'];
  tripComputerValue: Scalars['Boolean'];
  trunkDepthValue: Scalars['Int'];
  trunkHeightValue: Scalars['Int'];
  trunkOutletValue: Scalars['Boolean'];
  trunkSpaceFrontValue: Scalars['Int'];
  trunkSpaceValue: Scalars['Int'];
  trunkWidthValue: Scalars['Int'];
  typeOfElectricCarValue?: Maybe<Scalars['String']>;
  uSBValue: Scalars['Boolean'];
  upholsteryValue?: Maybe<Scalars['String']>;
  ventilatedSeatsValue: Scalars['Boolean'];
  wheelBaseValue: Scalars['Int'];
  wiFiValue: Scalars['Boolean'];
  widthValue: Scalars['Int'];
  windowLiftsValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  wirelessPhoneChargerValue: Scalars['Boolean'];
};

export type EnrichedCheckboxListOption = {
  __typename?: 'EnrichedCheckboxListOption';
  enrichedText?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type EnrichedRadioButtonListOption = {
  __typename?: 'EnrichedRadioButtonListOption';
  enrichedText?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type EquipmentLevelCarImageColor = {
  __typename?: 'EquipmentLevelCarImageColor';
  colorCode?: Maybe<Scalars['String']>;
  equipmentLevelNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  hex?: Maybe<Scalars['String']>;
  imagesBasePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FaqBlock = BlockBaseType & {
  __typename?: 'FAQBlock';
  animation?: Maybe<Scalars['String']>;
  answerAuthor?: Maybe<Scalars['String']>;
  answerText?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  questionAuthor?: Maybe<Scalars['String']>;
  questionText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqListBlock = BlockBaseType & {
  __typename?: 'FAQListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<FaqBlock>>>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Facility = {
  __typename?: 'Facility';
  carMakes?: Maybe<Array<Maybe<CarMake>>>;
  facilityType: FacilityType;
  facilityTypeId?: Maybe<Scalars['ID']>;
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum FacilityType {
  /** None */
  None = 'NONE',
  /** Passenger car */
  PassengerCar = 'PASSENGER_CAR',
  /** Transport car */
  TransportCar = 'TRANSPORT_CAR'
}

export type Faq = {
  __typename?: 'Faq';
  answer: Scalars['String'];
  category: Scalars['String'];
  question: Scalars['String'];
  score: Scalars['Float'];
};

export type FaqDynamicListBlock = BlockBaseType & {
  __typename?: 'FaqDynamicListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carBrand?: Maybe<Scalars['String']>;
  carModel?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  root?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqPageNavigationBlock = BlockBaseType & {
  __typename?: 'FaqPageNavigationBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  navigations?: Maybe<Array<Maybe<FaqPageNavigationItemBlock>>>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqPageNavigationItemBlock = BlockBaseType & {
  __typename?: 'FaqPageNavigationItemBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  button?: Maybe<CallToAction>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqQuestionBlock = {
  __typename?: 'FaqQuestionBlock';
  animation?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  brandedQuestions?: Maybe<Array<Maybe<FaqQuestionBrandedBlock>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqQuestionBrandedBlock = {
  __typename?: 'FaqQuestionBrandedBlock';
  animation?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  carBrand?: Maybe<Scalars['String']>;
  carModel?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqSearchResult = {
  __typename?: 'FaqSearchResult';
  faqs?: Maybe<Array<Maybe<Faq>>>;
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type FaqSubPageCategoryBlockType = BlockBaseType & {
  __typename?: 'FaqSubPageCategoryBlockType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  root?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FaqSubPageCategoryListBlock = BlockBaseType & {
  __typename?: 'FaqSubPageCategoryListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<FaqSubPageCategoryBlockType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FavoritesBlock = BlockBaseType & {
  __typename?: 'FavoritesBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fetchListBody?: Maybe<Scalars['String']>;
  fetchListTitle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleNoListFound?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  whatIsAFavoriteListBody?: Maybe<Scalars['String']>;
  whatIsAFavoriteListTitle?: Maybe<Scalars['String']>;
};

export type FeatureText = {
  __typename?: 'FeatureText';
  miniText?: Maybe<Scalars['String']>;
  preText?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueText?: Maybe<Scalars['String']>;
};

export type FeatureTextBlock = BlockBaseType & {
  __typename?: 'FeatureTextBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  featureTexts?: Maybe<Array<Maybe<FeatureText>>>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FieldSorting = {
  __typename?: 'FieldSorting';
  field?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};

export type Filter = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type FilterResult = {
  __typename?: 'FilterResult';
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum FilterType {
  FinanceFilter = 'FINANCE_FILTER',
  HistogramRange = 'HISTOGRAM_RANGE',
  Links = 'LINKS',
  None = 'NONE',
  Range = 'RANGE',
  RangeSingle = 'RANGE_SINGLE',
  Terms = 'TERMS',
  TermsBoolean = 'TERMS_BOOLEAN',
  TermsColor = 'TERMS_COLOR',
  TermsDropdown = 'TERMS_DROPDOWN',
  TermsSingle = 'TERMS_SINGLE'
}

export enum FilterUnit {
  Currency = 'CURRENCY',
  Km = 'KM',
  Month = 'MONTH',
  None = 'NONE',
  Units = 'UNITS',
  Weight = 'WEIGHT',
  Year = 'YEAR'
}

export type FinanceFilterAggregateTypes = RangeSingleAggregate | TermsDropdownAggregate;

export type FinanceFilterAggregates = AggregateBase & {
  __typename?: 'FinanceFilterAggregates';
  aggregates?: Maybe<Array<Maybe<FinanceFilterAggregateTypes>>>;
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type FinanceWarningBlock = BlockBaseType & {
  __typename?: 'FinanceWarningBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FirstAvailableDate = {
  __typename?: 'FirstAvailableDate';
  dates?: Maybe<Array<Maybe<Scalars['DateOnly']>>>;
};

export type FirstAvailableDatesBookingQuery = {
  branchCode: Scalars['Int'];
  code?: InputMaybe<Scalars['String']>;
  isTireHotel: Scalars['Boolean'];
  regionCode: Scalars['Int'];
  serviceId: Scalars['ID'];
  siteId: Scalars['ID'];
};

export type FirstAvailableDatesBookingTechnicianQuery = {
  branchCode: Scalars['Int'];
  code?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  indexPrefix?: InputMaybe<Scalars['String']>;
  regionCode: Scalars['Int'];
  siteId: Scalars['ID'];
};

export type FooterContent = {
  __typename?: 'FooterContent';
  columnOneHeading?: Maybe<Scalars['String']>;
  columnOneLinks?: Maybe<Array<Maybe<CallToAction>>>;
  columnTwoHeading?: Maybe<Scalars['String']>;
  columnTwoLinks?: Maybe<Array<Maybe<CallToAction>>>;
  copyrightText?: Maybe<Scalars['String']>;
  customerServiceCtas?: Maybe<Array<Maybe<CallToAction>>>;
  customerServiceTitle?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  formCta?: Maybe<Array<Maybe<CallToAction>>>;
  formInputPlaceholder?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  instagramLink?: Maybe<Scalars['String']>;
  logos?: Maybe<Array<Maybe<CallToAction>>>;
  twitterLink?: Maybe<Scalars['String']>;
  youtubeLink?: Maybe<Scalars['String']>;
};

export type FormBlock = BlockBaseType & {
  __typename?: 'FormBlock';
  actions?: Maybe<Array<Maybe<Scalars['String']>>>;
  afterSubmitMessage?: Maybe<Scalars['String']>;
  afterSubmitRedirectUri?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  emailContent?: Maybe<Scalars['String']>;
  emailContentInternal?: Maybe<Scalars['String']>;
  emailPreamble?: Maybe<Scalars['String']>;
  emailTemplate?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  formElements?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  formName?: Maybe<Scalars['String']>;
  fromEmailAddress?: Maybe<Scalars['String']>;
  fromEmailName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sendCopyToCustomerServiceWhenCrmIsNotSupported: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  toEmailAddress?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type FormDataField = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FormElementAdditionalInformationPlaceholder = FormElementBase & {
  __typename?: 'FormElementAdditionalInformationPlaceholder';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementBase = {
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementButton = FormElementBase & {
  __typename?: 'FormElementButton';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementButtonDisplayTrigger = FormElementBase & {
  __typename?: 'FormElementButtonDisplayTrigger';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  labelAfterTrigger?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  triggerType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementCallToAction = FormElementBase & {
  __typename?: 'FormElementCallToAction';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementCheckbox = FormElementBase & {
  __typename?: 'FormElementCheckbox';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementCheckboxList = FormElementBase & {
  __typename?: 'FormElementCheckboxList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<CheckboxListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  renderHorizontally: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementContainer = FormElementBase & {
  __typename?: 'FormElementContainer';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementDataPopulatedEnrichedCheckboxList = FormElementBase & {
  __typename?: 'FormElementDataPopulatedEnrichedCheckboxList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dataType?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<SelectListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  removeCarMakesFromBranchNames: Scalars['Boolean'];
  requiredFilters?: Maybe<Array<Maybe<KeyValue>>>;
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementDataPopulatedEnrichedRadioButtonList = FormElementBase & {
  __typename?: 'FormElementDataPopulatedEnrichedRadioButtonList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dataType?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<SelectListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  removeCarMakesFromBranchNames: Scalars['Boolean'];
  requiredFilters?: Maybe<Array<Maybe<KeyValue>>>;
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementDataPopulatedSelectList = FormElementBase & {
  __typename?: 'FormElementDataPopulatedSelectList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dataType?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<SelectListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  multiple?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  removeCarMakesFromBranchNames: Scalars['Boolean'];
  requiredFilters?: Maybe<Array<Maybe<KeyValue>>>;
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementDateTimePicker = FormElementBase & {
  __typename?: 'FormElementDateTimePicker';
  alwaysOpen: Scalars['Boolean'];
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  onlyFutureTimeSlots: Scalars['Boolean'];
  onlyOpeningHours: Scalars['Boolean'];
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  slots?: Maybe<Array<Maybe<Scalars['String']>>>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementEmployeeDetails = FormElementBase & {
  __typename?: 'FormElementEmployeeDetails';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementEnrichedCheckbox = FormElementBase & {
  __typename?: 'FormElementEnrichedCheckbox';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  enrichedText?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementEnrichedCheckboxList = FormElementBase & {
  __typename?: 'FormElementEnrichedCheckboxList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<EnrichedCheckboxListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  renderHorizontally: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementEnrichedRadioButtonList = FormElementBase & {
  __typename?: 'FormElementEnrichedRadioButtonList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<EnrichedRadioButtonListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  renderHorizontally: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementHiddenField = FormElementBase & {
  __typename?: 'FormElementHiddenField';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementNumericRange = FormElementBase & {
  __typename?: 'FormElementNumericRange';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Int']>;
  mediaIds: Array<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  step?: Maybe<Scalars['Int']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementParagraph = FormElementBase & {
  __typename?: 'FormElementParagraph';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  paragraphText?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementRadioButtonList = FormElementBase & {
  __typename?: 'FormElementRadioButtonList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<RadioButtonListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  renderHorizontally: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementSectionTitle = FormElementBase & {
  __typename?: 'FormElementSectionTitle';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementSelectList = FormElementBase & {
  __typename?: 'FormElementSelectList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<SelectListOption>>>;
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  multiple?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  selectListOptionsType?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementSeparator = FormElementBase & {
  __typename?: 'FormElementSeparator';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementStarRatioList = FormElementBase & {
  __typename?: 'FormElementStarRatioList';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  textLeft?: Maybe<Scalars['String']>;
  textRight?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementTextarea = FormElementBase & {
  __typename?: 'FormElementTextarea';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  inputType?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementTextbox = FormElementBase & {
  __typename?: 'FormElementTextbox';
  animation?: Maybe<Scalars['String']>;
  autocomplete?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  inputType?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  patternMatch?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementValidator = {
  __typename?: 'FormElementValidator';
  message?: Maybe<Scalars['String']>;
  validationType?: Maybe<Scalars['String']>;
};

export type FormElementVehicleDetails = FormElementBase & {
  __typename?: 'FormElementVehicleDetails';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<FormElementsBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  emailFriendlyLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  predefinedValue?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  shade?: Maybe<Scalars['String']>;
  showChildElementsAutomaticallyIfAnyExists?: Maybe<Scalars['Boolean']>;
  systemKey?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  validators?: Maybe<Array<Maybe<FormElementValidator>>>;
};

export type FormElementsBlockContentType = FormElementAdditionalInformationPlaceholder | FormElementButton | FormElementButtonDisplayTrigger | FormElementCallToAction | FormElementCheckbox | FormElementCheckboxList | FormElementContainer | FormElementDataPopulatedEnrichedCheckboxList | FormElementDataPopulatedEnrichedRadioButtonList | FormElementDataPopulatedSelectList | FormElementDateTimePicker | FormElementEmployeeDetails | FormElementEnrichedCheckbox | FormElementEnrichedCheckboxList | FormElementEnrichedRadioButtonList | FormElementHiddenField | FormElementNumericRange | FormElementParagraph | FormElementRadioButtonList | FormElementSectionTitle | FormElementSelectList | FormElementSeparator | FormElementStarRatioList | FormElementTextarea | FormElementTextbox | FormElementVehicleDetails;

export type FormOption = {
  __typename?: 'FormOption';
  enrichedText?: Maybe<Scalars['String']>;
  groupHeader: Scalars['Boolean'];
  images?: Maybe<Array<Maybe<Image>>>;
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type GalleryImage = {
  __typename?: 'GalleryImage';
  altText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type GenericBlockContentType = AnchorLeadinBlock | AnchorLinksBarPropertyBlock | BigHighlightCardBlock | BranchCustomerSupportBlock | BranchEmployeesBlock | BranchFacilitiesBlock | BranchGeneralInformationBlock | BranchGeneralInformationHeroBlock | BranchIntroductionBlock | BranchNewsBlock | BranchOpeningHoursBlock | BranchSearchBarBlock | BranchSearchBlock | BranchSeoBlock | BrandLeadinCard | BrandLeadinGridBlock | BreadcrumbsBlock | CallToActionBarBlock | CallToActionNavigationBarBlock | Car | CarComparisonBlock | CarDynamicListBlock | CarFeatureAccordionTableBlock | CarFeatureTableBlock | CarFinanceCalculatorBlock | CarHeadBlock | CarMakeOverviewBlock | CarMakeOverviewCardBlock | CarModelLinksBlock | CarModelTabBlock | CarObjectAnchorLinksBarBlock | CarObjectBannerBlock | CarObjectChargingCostBlock | CarObjectFeatureAccordionTableBlock | CarObjectFeatureTableBlock | CarObjectFinanceCalculatorGeneralBlock | CarObjectFinanceCalculatorWaykeBlock | CarObjectGalleryBlock | CarObjectHeaderBlock | CarObjectHeroBlock | CarObjectInsuranceBlock | CarObjectInsuranceCalculatorBlock | CarObjectLeadinLargeBlock | CarObjectSalesDescriptionBlock | CarObjectTestInfoBlock | CarObjectWarrantiesBlock | CarSearchBarBlock | CarSearchBlock | CarVariantPickerBlock | CategoryLeadinCard | CategoryLinksBlock | CheckoutBlock | ContactActionBarBlock | CurrentBrandBlock | DispositionAreaPropertyBlock | DispositionBlock | DynamicListBlock | FaqBlock | FaqListBlock | FaqDynamicListBlock | FaqPageNavigationBlock | FaqPageNavigationItemBlock | FaqSubPageCategoryBlockType | FaqSubPageCategoryListBlock | FavoritesBlock | FeatureTextBlock | FinanceWarningBlock | FormBlock | GenericContentBlockCard | GenericLeadinCard | GridListBlock | HeroAreaBlock | HeroLeadinBlock | HighlightCardBlock | HtmlBlock | ImageBlock | InnerTemplateBlock | LinkCollectionBlock | LinkLeadinBlock | ListBlock | ManageWorkShopBookingBlock | MediaGalleryBlock | MegaMenuBarBlock | MenuLeadinBlock | MobiliaCareBookingBlock | MobiliaCareBookingConfirmationBlock | OfferAndPriceBlock | OfferLeadinBlockCard | OraConfiguratorBlock | OraConfiguratorChoiceBlock | OraConfiguratorChoicePlaceholderBlock | OraConfiguratorModelBlock | OraConfiguratorOptionBlock | OraConfiguratorOptionMileageBlock | OraConfiguratorOptionSmartBlock | OraConfiguratorPriceTypeBlock | OraConfiguratorSummaryBlock | OrderInformationBlock | OrderInformationLinksBlock | PricePropertyBlock | ProductCategoriesComparisonBlock | ProductHeadBlock | ProductSearchBlock | ReBookingWorkShopConfirmationBlock | RegNumberPropertyBlock | ScriptBlock | SearchBarBlock | SectionBlock | SectionEndBlock | ServiceLeadinCard | ServiceLeadinLargeBlock | SiteSearchBranchType | SiteSearchCarModelType | SiteSearchCarType | SiteSearchFaqType | SiteSearchPageType | SiteSearchProductType | SiteSearchTireType | SiteSearchType | SiteSearchWorkshopServiceType | SoldCarObjectBlock | TabSectionBlock | TabSectionContainerBlock | TeaserCardBlock | TeaserCardWithModalBlock | TextBlock | TireMatchBlock | TitleBlock | UspCard | UspInfoCard | UspLeadinCard | UnsubscribeCarFilterBlock | UspMixInBlock | UspSeoBlock | VolvoSisccWidgetBlock | WorkshopBookBarBlockCard;

export type GenericContentBlockCard = BlockBaseType & {
  __typename?: 'GenericContentBlockCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  campaign?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fullWidth: Scalars['Boolean'];
  id: Scalars['String'];
  imagePlacement?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  richText?: Maybe<RichText>;
  shade?: Maybe<Scalars['String']>;
  splitView: Scalars['Boolean'];
  subtitle?: Maybe<Scalars['String']>;
  textAlignment?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  videos?: Maybe<Array<Maybe<Video>>>;
};

export type GenericLeadinCard = BlockBaseType & {
  __typename?: 'GenericLeadinCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  disposition?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  introductionText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  textAlignment?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleAddOn?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type GetScheduleResponse = {
  __typename?: 'GetScheduleResponse';
  days?: Maybe<Array<Maybe<Day>>>;
  technicians?: Maybe<Array<Maybe<BookmakerTechnicianType>>>;
};

export type GridListBlock = BlockBaseType & {
  __typename?: 'GridListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  gridListArea1?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  gridListArea2?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  gridListArea3?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type HeroAreaBlock = BlockBaseType & {
  __typename?: 'HeroAreaBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type HeroLeadinBlock = BlockBaseType & {
  __typename?: 'HeroLeadinBlock';
  animation?: Maybe<Scalars['String']>;
  appearanceType?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<HeroLeadinBlockBlocksType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  campaign?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fullWidth: Scalars['Boolean'];
  heroType?: Maybe<Scalars['String']>;
  heroVariant?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  introduction?: Maybe<Scalars['String']>;
  logotype?: Maybe<Scalars['String']>;
  logotypePlacementX?: Maybe<Scalars['String']>;
  logotypePlacementY?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  serviceButtons?: Maybe<Array<Maybe<CallToAction>>>;
  serviceMessage?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tagType?: Maybe<Scalars['String']>;
  textPlacementH?: Maybe<Scalars['String']>;
  textPlacementV?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  videos?: Maybe<Array<Maybe<Video>>>;
  visualSize?: Maybe<Scalars['String']>;
};

export type HeroLeadinBlockBlocksType = BranchSearchBarBlock | WorkshopBookBarBlockCard;

export type HighlightCardBlock = BlockBaseType & {
  __typename?: 'HighlightCardBlock';
  animation?: Maybe<Scalars['String']>;
  badgeText?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  primaryShade?: Maybe<Scalars['String']>;
  secondaryShade?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showLogo: Scalars['Boolean'];
  skew: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type HistogramRangeAggregate = AggregateBase & {
  __typename?: 'HistogramRangeAggregate';
  decimals: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<HistogramRangeAggregateViewModelItem>>>;
  maxRangeValue: Scalars['Float'];
  maxSelectedRangeValue: Scalars['Float'];
  minRangeValue: Scalars['Float'];
  minSelectedRangeValue: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  step: Scalars['Float'];
  topFilter: Scalars['Boolean'];
};

export type HistogramRangeAggregateViewModelItem = {
  __typename?: 'HistogramRangeAggregateViewModelItem';
  hitCount: Scalars['Long'];
  value: Scalars['String'];
};

export type HtmlBlock = BlockBaseType & {
  __typename?: 'HtmlBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  css?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  markup?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export enum HtmlInputType {
  /** Checkbox input */
  Checkbox = 'CHECKBOX',
  /** Number input */
  Number = 'NUMBER',
  /** Radio button input */
  RadioButton = 'RADIO_BUTTON',
  /** Text input */
  Text = 'TEXT'
}

export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']>;
  hCrop?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  mediumHCrop?: Maybe<Scalars['String']>;
  mediumVCrop?: Maybe<Scalars['String']>;
  mediumZoom?: Maybe<Scalars['String']>;
  parallax: Scalars['Boolean'];
  smallHCrop?: Maybe<Scalars['String']>;
  smallVCrop?: Maybe<Scalars['String']>;
  smallZoom?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  vCrop?: Maybe<Scalars['String']>;
  zoom?: Maybe<Scalars['String']>;
};

export type ImageBlock = BlockBaseType & {
  __typename?: 'ImageBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Information = {
  __typename?: 'Information';
  activeDirectoryCompanyId: Scalars['ID'];
  branchCode?: Maybe<Scalars['String']>;
  crmName?: Maybe<Scalars['String']>;
  crmSiteId?: Maybe<Scalars['String']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  externalSalesUrl?: Maybe<Scalars['String']>;
  headerImagePath?: Maybe<Scalars['String']>;
  isDeliveryLocation: Scalars['Boolean'];
  isFulfillmentWarehouse: Scalars['Boolean'];
  leadsEmail?: Maybe<Scalars['String']>;
  listHeader?: Maybe<Scalars['String']>;
  listIntroText?: Maybe<Scalars['String']>;
  neutralName?: Maybe<Scalars['String']>;
  pinMeToIdentifier?: Maybe<Scalars['String']>;
  regionId: Scalars['ID'];
  showSalesPersons: Scalars['Boolean'];
  showTechnicians: Scalars['Boolean'];
  useCaesarForLeads: Scalars['Boolean'];
  useCrmForLeadsExceptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  useVps: Scalars['Boolean'];
  usedCarOrganizationId: Scalars['ID'];
};

export type InnerTemplateBlock = BlockBaseType & {
  __typename?: 'InnerTemplateBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export enum InputMode {
  /** Numeric */
  Numeric = 'NUMERIC',
  /** Text */
  Text = 'TEXT'
}

export type KeyValue = {
  __typename?: 'KeyValue';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type KeyValuePairStringLong = {
  __typename?: 'KeyValuePairStringLong';
  key?: Maybe<Scalars['String']>;
  value: Scalars['Long'];
};

export type Keyword = {
  __typename?: 'Keyword';
  category: KeywordCategory;
  partial: Scalars['Boolean'];
  score?: Maybe<Scalars['Float']>;
  value: Scalars['String'];
};

export enum KeywordCategory {
  Branch = 'BRANCH',
  BranchesTrigger = 'BRANCHES_TRIGGER',
  BranchFacility = 'BRANCH_FACILITY',
  BranchType = 'BRANCH_TYPE',
  Campaign = 'CAMPAIGN',
  CarsTrigger = 'CARS_TRIGGER',
  CarBodyType = 'CAR_BODY_TYPE',
  CarBrand = 'CAR_BRAND',
  CarDriveWheel = 'CAR_DRIVE_WHEEL',
  CarEngine = 'CAR_ENGINE',
  CarEngineType = 'CAR_ENGINE_TYPE',
  CarEquipment = 'CAR_EQUIPMENT',
  CarEquipmentLevel = 'CAR_EQUIPMENT_LEVEL',
  CarFuelType = 'CAR_FUEL_TYPE',
  CarModel = 'CAR_MODEL',
  CarModelsTrigger = 'CAR_MODELS_TRIGGER',
  CarModelSearchKeyword = 'CAR_MODEL_SEARCH_KEYWORD',
  CarRegistrationNumber = 'CAR_REGISTRATION_NUMBER',
  CarTransmission = 'CAR_TRANSMISSION',
  CarVariant = 'CAR_VARIANT',
  Color = 'COLOR',
  ContentSearchKeyword = 'CONTENT_SEARCH_KEYWORD',
  ContentTrigger = 'CONTENT_TRIGGER',
  Location = 'LOCATION',
  ProductsTrigger = 'PRODUCTS_TRIGGER',
  ProductBrand = 'PRODUCT_BRAND',
  ProductCategory = 'PRODUCT_CATEGORY',
  ProductCode = 'PRODUCT_CODE',
  ProductId = 'PRODUCT_ID',
  ProductIdentifier = 'PRODUCT_IDENTIFIER',
  ProductItemNumber = 'PRODUCT_ITEM_NUMBER',
  ProductItemNumberAndPrefix = 'PRODUCT_ITEM_NUMBER_AND_PREFIX',
  ProductItemNumberWithPrefix = 'PRODUCT_ITEM_NUMBER_WITH_PREFIX',
  ProductManufacturerItemNumber = 'PRODUCT_MANUFACTURER_ITEM_NUMBER',
  ProductModel = 'PRODUCT_MODEL',
  ProductNumber = 'PRODUCT_NUMBER',
  ProductNumberPrefix = 'PRODUCT_NUMBER_PREFIX',
  ProductNumberWithPrefix = 'PRODUCT_NUMBER_WITH_PREFIX',
  ProductSearchKeyword = 'PRODUCT_SEARCH_KEYWORD',
  ProductTireDimension = 'PRODUCT_TIRE_DIMENSION',
  ProductTireDimensionRadius = 'PRODUCT_TIRE_DIMENSION_RADIUS',
  ProductTireExtraStrength = 'PRODUCT_TIRE_EXTRA_STRENGTH',
  ProductTireLoadSpeed = 'PRODUCT_TIRE_LOAD_SPEED',
  ProductTireOriginal = 'PRODUCT_TIRE_ORIGINAL',
  ProductTireRunFlat = 'PRODUCT_TIRE_RUN_FLAT',
  ProductType = 'PRODUCT_TYPE',
  ProductVariationNumber = 'PRODUCT_VARIATION_NUMBER',
  ProductVariationNumberPrefix = 'PRODUCT_VARIATION_NUMBER_PREFIX',
  WorkshopService = 'WORKSHOP_SERVICE',
  WorkshopServicesTrigger = 'WORKSHOP_SERVICES_TRIGGER',
  WorkshopServiceSearchKeyword = 'WORKSHOP_SERVICE_SEARCH_KEYWORD',
  Year = 'YEAR'
}

export type KeywordSiteSearchResultType = {
  __typename?: 'KeywordSiteSearchResultType';
  originalSearchQuery: Scalars['String'];
  results?: Maybe<Array<Maybe<SearchPhraseResultType>>>;
  totalHits: Scalars['Long'];
  unmatchedQueryRemains: Scalars['String'];
};

export type LeaveTimeGraphType = {
  __typename?: 'LeaveTimeGraphType';
  customerCanWait: Scalars['Boolean'];
  default: Scalars['Boolean'];
  description: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isSiteDefault: Scalars['Boolean'];
  serviceId?: Maybe<Scalars['ID']>;
  timeEntryAsText: Scalars['String'];
  to: Scalars['String'];
  useFirstTime: Scalars['Boolean'];
};

export type LinkCollectionBlock = {
  __typename?: 'LinkCollectionBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  links?: Maybe<Array<Maybe<CallToAction>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type LinkLeadinBlock = BlockBaseType & {
  __typename?: 'LinkLeadinBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fixed: Scalars['Boolean'];
  hScroll: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  items?: Maybe<Array<Maybe<CallToAction>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type LinksAggregate = AggregateBase & {
  __typename?: 'LinksAggregate';
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<LinksAggregateViewModelItem>>>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type LinksAggregateViewModelItem = {
  __typename?: 'LinksAggregateViewModelItem';
  selected: Scalars['Boolean'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type ListBlock = BlockBaseType & {
  __typename?: 'ListBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoriesFiltersList?: Maybe<Array<Maybe<Category>>>;
  categoryFilterIds?: Maybe<Array<Scalars['ID']>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  filterBasedOnCurrentCarBrand: Scalars['Boolean'];
  fixed: Scalars['Boolean'];
  hScroll: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  hideAllFilterOption: Scalars['Boolean'];
  hideEmptyState: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelFilterShowAll?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  minimumColumnsOnSmallerScreens: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  paginationLarge: Scalars['Int'];
  paginationSmall: Scalars['Int'];
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useColumnList: Scalars['Boolean'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  contact?: Maybe<Contact>;
  coordinate?: Maybe<Coordinate>;
  region?: Maybe<Region>;
};

export type MainQuery = {
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  id: Scalars['String'];
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortings?: InputMaybe<Array<InputMaybe<QuerySort>>>;
};

export type ManageWorkShopBookingBlock = {
  __typename?: 'ManageWorkShopBookingBlock';
  animation?: Maybe<Scalars['String']>;
  backToStartPage?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookingNotFound?: Maybe<Scalars['String']>;
  bookingNotFoundInfoText?: Maybe<Scalars['String']>;
  branchAndDateHeading?: Maybe<Scalars['String']>;
  cancelBookingButton?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  changeDateLabel?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contactHeading?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dateAndTimeHeading?: Maybe<Scalars['String']>;
  deleteBooking?: Maybe<Scalars['String']>;
  deleteBookingCompletedInfoText?: Maybe<Scalars['String']>;
  deleteBookingCompletedTitle?: Maybe<Scalars['String']>;
  deleteBookingConfirmationInfoText?: Maybe<Scalars['String']>;
  deleteBookingConfirmationTitle?: Maybe<Scalars['String']>;
  deleteBookingHeading?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  firstAvailableTimeLabel?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  leaveCarTimeHeading?: Maybe<Scalars['String']>;
  manageBookingInfoNoReBookableCancelableText?: Maybe<Scalars['String']>;
  manageBookingInfoNoReBookableNoCancelableText?: Maybe<Scalars['String']>;
  manageBookingInfoReBookableNoCancelableText?: Maybe<Scalars['String']>;
  manageBookingInfoText?: Maybe<Scalars['String']>;
  manageBookingLabel?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  openInGoogleMaps?: Maybe<Scalars['String']>;
  rebookBookingButton?: Maybe<Scalars['String']>;
  saveAndContinue?: Maybe<Scalars['String']>;
  selectTechnician?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showAllDaysButtonLabel?: Maybe<Scalars['String']>;
  slotTimeHeading?: Maybe<Scalars['String']>;
  slotTimeInfoText?: Maybe<Scalars['String']>;
  stepOf?: Maybe<Scalars['String']>;
  timeFilterAfternoon?: Maybe<Scalars['String']>;
  timeFilterAll?: Maybe<Scalars['String']>;
  timeFilterHeading?: Maybe<Scalars['String']>;
  timeFilterLunch?: Maybe<Scalars['String']>;
  timeFilterMorning?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  vehicleHeading?: Maybe<Scalars['String']>;
};

export type MediaGalleryBlock = BlockBaseType & {
  __typename?: 'MediaGalleryBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fullWidth: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  initialMediaCount: Scalars['Int'];
  mediaIds: Array<Scalars['Int']>;
  mediaItems?: Maybe<Array<Maybe<MotoritMediaBlockType>>>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showGalleryBtnLabel?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export enum MediaType {
  Embedded = 'EMBEDDED',
  Image = 'IMAGE',
  Sphere = 'SPHERE'
}

export type MegaMenuBarBlock = BlockBaseType & {
  __typename?: 'MegaMenuBarBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type MenuLeadinBlock = BlockBaseType & {
  __typename?: 'MenuLeadinBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  links?: Maybe<Array<Maybe<CallToAction>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID'];
  isEmpty: Scalars['Boolean'];
  showOnConfirmationPage: Scalars['Boolean'];
  targetNewWindow: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MobiliaCareBookingBlock = {
  __typename?: 'MobiliaCareBookingBlock';
  acceptTermsLinkText?: Maybe<Scalars['String']>;
  acceptTermsText?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookAndOrderHeading?: Maybe<Scalars['String']>;
  bookTimeAndPlace?: Maybe<Scalars['String']>;
  bookingProgress?: Maybe<Scalars['String']>;
  bookingProgressFailed?: Maybe<Scalars['String']>;
  bookingProgressRetry?: Maybe<Scalars['String']>;
  branchAndTimeCalendarHeading?: Maybe<Scalars['String']>;
  branchAndTimeChangeDate?: Maybe<Scalars['String']>;
  branchAndTimeHeading?: Maybe<Scalars['String']>;
  branchAndTimeSlotsHeading?: Maybe<Scalars['String']>;
  branchSuggestions?: Maybe<Scalars['String']>;
  branchesViewMore?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  changeBranch?: Maybe<Scalars['String']>;
  changeTime?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contactFormHeading?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  dateAndTimeHeading?: Maybe<Scalars['String']>;
  emailErrorText?: Maybe<Scalars['String']>;
  emailLabel?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  faqLinkText?: Maybe<Scalars['String']>;
  faqLists?: Maybe<Array<Maybe<FaqListBlock>>>;
  findBranchHeading?: Maybe<Scalars['String']>;
  firstNameLabel?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  insuranceCompanyLabel?: Maybe<Scalars['String']>;
  lastNameLabel?: Maybe<Scalars['String']>;
  leaveCarTimeHeading?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  moreSalesHeading?: Maybe<Scalars['String']>;
  moreSalesListHeading?: Maybe<Scalars['String']>;
  moreSalesNoneAvailable?: Maybe<Scalars['String']>;
  moreSalesNoneSelected?: Maybe<Scalars['String']>;
  moreSalesViewMore?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneErrorText?: Maybe<Scalars['String']>;
  phoneLabel?: Maybe<Scalars['String']>;
  saveAndContinue?: Maybe<Scalars['String']>;
  searchLabel?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  searchTip?: Maybe<Scalars['String']>;
  selectVehicleHeading?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showAllDaysButtonLabel?: Maybe<Scalars['String']>;
  showMoreBranches?: Maybe<Scalars['String']>;
  slotTimeHeading?: Maybe<Scalars['String']>;
  slotTimeInfoText?: Maybe<Scalars['String']>;
  smsReminder?: Maybe<Scalars['String']>;
  stepOf?: Maybe<Scalars['String']>;
  submitOrderButton?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  termsHeading?: Maybe<Scalars['String']>;
  timeFilterAfternoon?: Maybe<Scalars['String']>;
  timeFilterAll?: Maybe<Scalars['String']>;
  timeFilterHeading?: Maybe<Scalars['String']>;
  timeFilterLunch?: Maybe<Scalars['String']>;
  timeFilterMorning?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  workshopBranchConfirmationAcceptButtonText?: Maybe<Scalars['String']>;
  workshopBranchConfirmationCancelButtonText?: Maybe<Scalars['String']>;
  workshopBranchConfirmationHeading?: Maybe<Scalars['String']>;
  workshopBranchConfirmationInfoText?: Maybe<Scalars['String']>;
  workshopBranchDeleteLabel?: Maybe<Scalars['String']>;
  workshopServiceCarglassHeading?: Maybe<Scalars['String']>;
  workshopServiceHeading?: Maybe<Scalars['String']>;
  workshopServiceNoAvailable?: Maybe<Scalars['String']>;
  workshopServiceSearching?: Maybe<Scalars['String']>;
};

export type MobiliaCareBookingConfirmationBlock = {
  __typename?: 'MobiliaCareBookingConfirmationBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookingConfirmationInfoText?: Maybe<Scalars['String']>;
  bookingInformationMissing?: Maybe<Scalars['String']>;
  bookingInformationWorkshopServiceHeading?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  manageBookingInfoText?: Maybe<Scalars['String']>;
  manageBookingLabel?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  noBranchInformation?: Maybe<Scalars['String']>;
  noDateTimeInformation?: Maybe<Scalars['String']>;
  openInGoogleMaps?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  timeAndPlace?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type MoreSale = {
  __typename?: 'MoreSale';
  description?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  getArticleAndPriceFromEcommerce: Scalars['Boolean'];
  id: Scalars['ID'];
  isTireHotelService: Scalars['Boolean'];
  name: Scalars['String'];
  price?: Maybe<ServicePrice>;
  requireSocialSecurityNumber: Scalars['Boolean'];
  serviceConfigurationInputs?: Maybe<Array<Maybe<ServiceConfigurationInput>>>;
  showCommentField: Scalars['Boolean'];
  socialSecurityNumber?: Maybe<Scalars['String']>;
  state: ViewState;
  userComment?: Maybe<Scalars['String']>;
};

export type MoreSaleInput = {
  description?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  getArticleAndPriceFromEcommerce: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price?: InputMaybe<PriceInput>;
  requireSocialSecurityNumber: Scalars['Boolean'];
  showCommentField: Scalars['Boolean'];
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  userComment?: InputMaybe<Scalars['String']>;
};

export type MoreSaleSettings = {
  __typename?: 'MoreSaleSettings';
  showBeforePagination: Scalars['Int'];
  showMoreSaleSettings: Scalars['Boolean'];
  topMoreSales: Scalars['Int'];
};

export type MoreSales = {
  __typename?: 'MoreSales';
  confirmationStepInitialMoreSaleItemDesktop: Scalars['Int'];
  confirmationStepInitialMoreSaleItemMobile: Scalars['Int'];
  confirmationStepMoreSales?: Maybe<Array<Maybe<MoreSale>>>;
  contactStepInitialMoreSaleItemDesktop: Scalars['Int'];
  contactStepInitialMoreSaleItemMobile: Scalars['Int'];
  contactStepMoreSales?: Maybe<Array<Maybe<MoreSale>>>;
};

export type MotoritMediaBlockType = Image | Video;

export type MotoritOnlineMutations = {
  __typename?: 'MotoritOnlineMutations';
  addCarToFavoritesList?: Maybe<AddToCarFavoritesListResponse>;
  addItemsToCart?: Maybe<OrderResponse>;
  addMoreSale?: Maybe<StatusCodeResponse>;
  deleteCarFavoritesList?: Maybe<DeleteCarFavoritesListResponse>;
  deleteCarFromFavoritesList?: Maybe<DeleteCarFromFavoritesResponse>;
  removeBranchAndDateCheckoutStep?: Maybe<OrderResponse>;
  removeItemFromCart?: Maybe<OrderResponse>;
  setOrderVehicleInformation?: Maybe<OrderResponse>;
  siteSearchLogClick?: Maybe<SiteSearchLogClickResponse>;
  submitBookAndOrderCheckoutStep?: Maybe<OrderResponse>;
  submitBooking?: Maybe<BookingResponse>;
  submitBranchAndDateCheckoutStep?: Maybe<OrderResponse>;
  submitCustomerInformationStep?: Maybe<OrderResponse>;
  submitForm?: Maybe<SubmittedFormValidationResult>;
  submitPreliminaryBooking?: Maybe<SubmittedPreliminaryBookingResponseType>;
  subscribeToCarFilter?: Maybe<CarFilterSubscriptionResult>;
  subscribeToNewsletter?: Maybe<NewsletterResult>;
  unsubscribeFromCarFilter?: Maybe<UnsubscribeFromCarFilterResult>;
  updateCartItemQuantity?: Maybe<OrderResponse>;
};


export type MotoritOnlineMutationsAddCarToFavoritesListArgs = {
  indexPrefix: Scalars['String'];
  licensePlate: Scalars['String'];
  listId: Scalars['String'];
};


export type MotoritOnlineMutationsAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


export type MotoritOnlineMutationsAddMoreSaleArgs = {
  addMoreSaleQuery: AddMoreSaleQueryInput;
};


export type MotoritOnlineMutationsDeleteCarFavoritesListArgs = {
  listId: Scalars['String'];
};


export type MotoritOnlineMutationsDeleteCarFromFavoritesListArgs = {
  indexPrefix: Scalars['String'];
  licensePlate: Scalars['String'];
  listId: Scalars['String'];
};


export type MotoritOnlineMutationsRemoveBranchAndDateCheckoutStepArgs = {
  input: RemoveBranchAndDateInputType;
};


export type MotoritOnlineMutationsRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


export type MotoritOnlineMutationsSetOrderVehicleInformationArgs = {
  input: OrderVehicleInformationInput;
};


export type MotoritOnlineMutationsSiteSearchLogClickArgs = {
  indexPrefix: Scalars['String'];
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
  url: Scalars['String'];
};


export type MotoritOnlineMutationsSubmitBookAndOrderCheckoutStepArgs = {
  input: SubmitOrderInputType;
};


export type MotoritOnlineMutationsSubmitBookingArgs = {
  submitBookingQuery: SubmitBookingQueryInput;
};


export type MotoritOnlineMutationsSubmitBranchAndDateCheckoutStepArgs = {
  input: SubmitBranchAndDateInput;
};


export type MotoritOnlineMutationsSubmitCustomerInformationStepArgs = {
  input: SubmitCustomerInformationInputType;
};


export type MotoritOnlineMutationsSubmitFormArgs = {
  host: Scalars['String'];
  indexPrefix: Scalars['String'];
  languageCode: Scalars['String'];
  previewindex: Scalars['Boolean'];
  siteId: Scalars['Guid'];
  submittedForm: SubmittedForm;
};


export type MotoritOnlineMutationsSubmitPreliminaryBookingArgs = {
  branchId: Scalars['Guid'];
  containerId: Scalars['Int'];
  date: Scalars['DateTime'];
  indexPrefix: Scalars['String'];
  isTireHotel?: InputMaybe<Scalars['Boolean']>;
  regionCode: Scalars['Int'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineMutationsSubscribeToCarFilterArgs = {
  siteId: Scalars['Guid'];
  subscription: CarFilterSubscriptionInput;
};


export type MotoritOnlineMutationsSubscribeToNewsletterArgs = {
  siteId: Scalars['Guid'];
  subscription: NewsletterInput;
};


export type MotoritOnlineMutationsUnsubscribeFromCarFilterArgs = {
  id: Scalars['Guid'];
};


export type MotoritOnlineMutationsUpdateCartItemQuantityArgs = {
  input: UpdateCartItemQuantityInput;
};

export type MotoritOnlineQueries = {
  __typename?: 'MotoritOnlineQueries';
  bookingInformation?: Maybe<BookingInformationResponse>;
  bookingSettings?: Maybe<BookingSettings>;
  branchNames?: Maybe<Array<Maybe<BranchNamesType>>>;
  branchSearch?: Maybe<BranchSearchResult>;
  branchSuggestTerms?: Maybe<SuggestSearchTerms>;
  car?: Maybe<Car>;
  carBrands?: Maybe<Array<Maybe<Scalars['String']>>>;
  carFavoritesList?: Maybe<CarFavoritesGetFavoritesByIdResponse>;
  carFilterSubscription?: Maybe<CarFilterSubscriptionInfoResult>;
  carMakes?: Maybe<Array<Maybe<CarMakes>>>;
  carMetaDataBrands?: Maybe<Array<Maybe<Scalars['String']>>>;
  carMetaDataColors?: Maybe<Array<Maybe<CarMetadataColorsBlockType>>>;
  carMetaDataModels?: Maybe<Array<Maybe<CarMetadataModelsBlockType>>>;
  carMetaDataOptionPacks?: Maybe<Array<Maybe<CarMetadataOptionPacksBlockType>>>;
  carMetaDataStructure?: Maybe<Array<Maybe<Area>>>;
  carMetaDataVersions?: Maybe<Array<Maybe<CarMetadataVersionsBlockType>>>;
  carModels?: Maybe<BrandModelCombinationModel>;
  /** @deprecated Should be able to remove this query and related code once MON-9042 is deployed to production */
  carObjectStructure?: Maybe<Array<Maybe<Area>>>;
  carSearch?: Maybe<SearchResultViewModel>;
  carSearchNew?: Maybe<CarSearchResultViewModel>;
  carSuggestTerms?: Maybe<SuggestSearchTerms>;
  checkout: OrderResponse;
  checkoutWorkshopBranches: BranchSearchResult;
  checkoutWorkshopSchedule: ScheduleBookingResponse;
  createCarFavoritesList?: Maybe<CarFavoritesCreateFavoritesListResponse>;
  customerByPhoneNumber?: Maybe<Customer>;
  deleteBooking?: Maybe<StatusCodeResponse>;
  departmentsByIdentifier?: Maybe<Array<Maybe<Department>>>;
  dynamiclist?: Maybe<Array<Maybe<QueryResult>>>;
  employees?: Maybe<Array<Maybe<EmployeeGenericType>>>;
  faqDynamicSearch?: Maybe<Array<Maybe<FaqQuestionBlock>>>;
  firstAvailableDates?: Maybe<FirstAvailableDate>;
  firstAvailableDatesTechnician?: Maybe<FirstAvailableDate>;
  formelementdata?: Maybe<Array<Maybe<FormOption>>>;
  latestCarMetaDataVersions?: Maybe<Array<Maybe<CarMetadataVersionsBlockType>>>;
  moveBooking?: Maybe<StatusCodeResponse>;
  orderById?: Maybe<PurchaseOrderResponse>;
  pageContent?: Maybe<PageContent>;
  productSearch?: Maybe<ProductSearchResult>;
  productServices?: Maybe<Array<Maybe<ProductService>>>;
  query?: Maybe<SingleQuery>;
  resourcesByGroups?: Maybe<Scalars['Dictionary']>;
  schedule?: Maybe<GetScheduleResponse>;
  service?: Maybe<WorkshopService>;
  serviceGroups?: Maybe<ServiceGroupResponse>;
  servicePlan?: Maybe<ServicePlan>;
  siteContent?: Maybe<SiteContent>;
  siteSearch?: Maybe<SiteSearchResult>;
  timeSlots?: Maybe<Array<Maybe<Slot>>>;
  tireDimensions?: Maybe<TireDimensionsResponse>;
  tireMatch?: Maybe<TireLookupByRegistrationNumberResponse>;
  usp?: Maybe<Array<Maybe<Usp>>>;
  uspCards?: Maybe<UspSearchResult>;
  variationsByRegistrationNumber?: Maybe<Array<Maybe<VariationsUnion>>>;
  vehicleInformation?: Maybe<Vehicle>;
};


export type MotoritOnlineQueriesBookingInformationArgs = {
  bookingInformationQuery?: InputMaybe<BookingInformationRequest>;
};


export type MotoritOnlineQueriesBookingSettingsArgs = {
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesBranchNamesArgs = {
  branchNamesQuery?: InputMaybe<BranchNamesQuery>;
};


export type MotoritOnlineQueriesBranchSearchArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  sort?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesBranchSuggestTermsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  query: Scalars['String'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarArgs = {
  indexPrefix: Scalars['String'];
  registrationNumber: Scalars['String'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarBrandsArgs = {
  host: Scalars['String'];
};


export type MotoritOnlineQueriesCarFavoritesListArgs = {
  indexPrefix: Scalars['String'];
  listId: Scalars['String'];
};


export type MotoritOnlineQueriesCarFilterSubscriptionArgs = {
  id: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarMakesArgs = {
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarMetaDataBrandsArgs = {
  languageCode: Scalars['String'];
};


export type MotoritOnlineQueriesCarMetaDataColorsArgs = {
  uniqueId: Scalars['String'];
  year: Scalars['String'];
};


export type MotoritOnlineQueriesCarMetaDataModelsArgs = {
  carMake: Scalars['String'];
  languageCode: Scalars['String'];
};


export type MotoritOnlineQueriesCarMetaDataOptionPacksArgs = {
  languageCode: Scalars['String'];
  uniqueId: Scalars['String'];
  year: Scalars['String'];
};


export type MotoritOnlineQueriesCarMetaDataStructureArgs = {
  host: Scalars['String'];
  languageCode: Scalars['String'];
  modelYear: Scalars['String'];
  optionId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['Guid'];
  uniqueId: Scalars['String'];
};


export type MotoritOnlineQueriesCarMetaDataVersionsArgs = {
  carModelVersion: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarModelsArgs = {
  activeConfigurationGroupId: Scalars['String'];
  host: Scalars['String'];
  languageCode: Scalars['String'];
  templateId?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesCarObjectStructureArgs = {
  host: Scalars['String'];
  indexPrefix: Scalars['String'];
  languageCode: Scalars['String'];
  registrationNumber: Scalars['String'];
  templateId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCarSearchArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  fixedFilters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  sort?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesCarSearchNewArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  fixedFilters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  sort?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesCarSuggestTermsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  query: Scalars['String'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCheckoutArgs = {
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCheckoutWorkshopBranchesArgs = {
  orderId: Scalars['Guid'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCheckoutWorkshopScheduleArgs = {
  branchId: Scalars['Guid'];
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesCustomerByPhoneNumberArgs = {
  culture: Scalars['String'];
  mobileNumber: Scalars['String'];
  registrationNumber: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesDeleteBookingArgs = {
  deleteBookingQuery?: InputMaybe<DeleteBookingRequest>;
};


export type MotoritOnlineQueriesDepartmentsByIdentifierArgs = {
  indexPrefix: Scalars['String'];
  pinMeToIdentifier: Scalars['String'];
};


export type MotoritOnlineQueriesDynamiclistArgs = {
  mainQuery: MainQuery;
  subQueries?: InputMaybe<Array<InputMaybe<Queries>>>;
};


export type MotoritOnlineQueriesEmployeesArgs = {
  branchId?: InputMaybe<Scalars['Guid']>;
  employeeType?: InputMaybe<Scalars['String']>;
  indexPrefix: Scalars['String'];
};


export type MotoritOnlineQueriesFaqDynamicSearchArgs = {
  indexPrefix?: InputMaybe<Scalars['String']>;
  previewindex: Scalars['Boolean'];
  route?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MotoritOnlineQueriesFirstAvailableDatesArgs = {
  firstAvailableDatesQuery?: InputMaybe<FirstAvailableDatesBookingQuery>;
};


export type MotoritOnlineQueriesFirstAvailableDatesTechnicianArgs = {
  technicianDatesQuery?: InputMaybe<FirstAvailableDatesBookingTechnicianQuery>;
};


export type MotoritOnlineQueriesFormelementdataArgs = {
  datatype: Scalars['String'];
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  host: Scalars['String'];
  indexPrefix: Scalars['String'];
  removeCarMakesFromBranchNames?: InputMaybe<Scalars['Boolean']>;
};


export type MotoritOnlineQueriesLatestCarMetaDataVersionsArgs = {
  fromDate: Scalars['DateOnly'];
  languageCode: Scalars['String'];
};


export type MotoritOnlineQueriesMoveBookingArgs = {
  moveBookingQuery?: InputMaybe<MoveBookingRequest>;
};


export type MotoritOnlineQueriesOrderByIdArgs = {
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesPageContentArgs = {
  context?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  indexPrefix: Scalars['String'];
  previewindex: Scalars['Boolean'];
  route: Scalars['String'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesProductSearchArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Guid']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  sort?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesProductServicesArgs = {
  productServicesRequest?: InputMaybe<ProductServicesRequest>;
};


export type MotoritOnlineQueriesQueryArgs = {
  id: Scalars['String'];
};


export type MotoritOnlineQueriesResourcesByGroupsArgs = {
  groups: Array<InputMaybe<Scalars['String']>>;
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesScheduleArgs = {
  getScheduleQuery?: InputMaybe<ScheduleQuery>;
};


export type MotoritOnlineQueriesServiceArgs = {
  carMake: Scalars['String'];
  classificationCode?: InputMaybe<Scalars['Int']>;
  hasTireHotel: Scalars['Boolean'];
  model: Scalars['String'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  serviceIdList?: InputMaybe<Array<Scalars['Guid']>>;
  siteId: Scalars['Guid'];
  year: Scalars['Int'];
};


export type MotoritOnlineQueriesServiceGroupsArgs = {
  carMake: Scalars['String'];
  classificationCode?: InputMaybe<Scalars['Int']>;
  hasTireHotel: Scalars['Boolean'];
  languageCode: Scalars['String'];
  model: Scalars['String'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  typeHigh?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};


export type MotoritOnlineQueriesServicePlanArgs = {
  carMake: Scalars['String'];
  culture: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  registrationNumber: Scalars['String'];
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesSiteContentArgs = {
  host: Scalars['String'];
  indexPrefix?: InputMaybe<Scalars['String']>;
  previewindex?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Guid']>;
};


export type MotoritOnlineQueriesSiteSearchArgs = {
  indexPrefix: Scalars['String'];
  languageCode: Scalars['String'];
  query: Scalars['String'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
  siteId: Scalars['Guid'];
  tireDimension?: InputMaybe<Scalars['String']>;
};


export type MotoritOnlineQueriesTimeSlotsArgs = {
  timeSlotsQuery?: InputMaybe<TimeSlotsRequest>;
};


export type MotoritOnlineQueriesTireDimensionsArgs = {
  tireDimensionsRequest?: InputMaybe<TireDimensionsRequest>;
};


export type MotoritOnlineQueriesTireMatchArgs = {
  registrationNumber: Scalars['String'];
};


export type MotoritOnlineQueriesUspArgs = {
  carMake?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['Guid']>;
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesUspCardsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  fixedFilters?: InputMaybe<Array<InputMaybe<Filter>>>;
  indexPrefix: Scalars['String'];
  previewindex: Scalars['Boolean'];
  searchBlockId: Scalars['Guid'];
  searchPageId?: InputMaybe<Scalars['Guid']>;
  siteId: Scalars['Guid'];
};


export type MotoritOnlineQueriesVariationsByRegistrationNumberArgs = {
  indexPrefix: Scalars['String'];
  isTransportVehicle?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  registrationNumber: Scalars['String'];
  route?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Guid'];
  tireSeason: Season;
};


export type MotoritOnlineQueriesVehicleInformationArgs = {
  culture: Scalars['String'];
  indexPrefix?: InputMaybe<Scalars['String']>;
  registrationNumber: Scalars['String'];
  siteId: Scalars['Guid'];
};

export type MoveBookingRequest = {
  bookedDate: Scalars['DateTime'];
  bookingId: Scalars['String'];
  containerId: Scalars['Int'];
  regionCode: Scalars['Int'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  siteId: Scalars['ID'];
};

export type NavigationContent = {
  __typename?: 'NavigationContent';
  blockIds?: Maybe<Array<Scalars['ID']>>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  children?: Maybe<Array<Maybe<NavigationContent>>>;
  childrenIds?: Maybe<Array<Scalars['ID']>>;
  displayInHeader: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  route: Scalars['String'];
  topBlockIds?: Maybe<Array<Scalars['ID']>>;
  topBlocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
};

export type NavigationPanelChildType = {
  __typename?: 'NavigationPanelChildType';
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  icon?: Maybe<Scalars['String']>;
  iconAltText?: Maybe<Scalars['String']>;
  sectionBlocks?: Maybe<Array<Maybe<NavigationPanelSectionContentType>>>;
  showLink: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NavigationPanelLinkType = {
  __typename?: 'NavigationPanelLinkType';
  description?: Maybe<Scalars['String']>;
  hasPanel: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  iconAltText?: Maybe<Scalars['String']>;
  isExternal: Scalars['Boolean'];
  panel?: Maybe<NavigationPanelChildType>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type NavigationPanelSectionContentType = NavigationPanelLinkType | NavigationPanelSectionType;

export type NavigationPanelSectionType = {
  __typename?: 'NavigationPanelSectionType';
  links?: Maybe<Array<Maybe<NavigationPanelLinkType>>>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type NavigationPanelType = {
  __typename?: 'NavigationPanelType';
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  enabled: Scalars['Boolean'];
  links?: Maybe<Array<Maybe<NavigationPanelLinkType>>>;
};

export type NewsletterInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsletterResult = {
  __typename?: 'NewsletterResult';
  success: Scalars['Boolean'];
};

export type OfferAndPriceBlock = BlockBaseType & {
  __typename?: 'OfferAndPriceBlock';
  alignment?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  offerModels?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerType?: Maybe<Scalars['String']>;
  price?: Maybe<PricePropertyBlock>;
  priceColumns: Scalars['Int'];
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OfferLeadinBlockCard = BlockBaseType & {
  __typename?: 'OfferLeadinBlockCard';
  animate: Scalars['Boolean'];
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  campaignText?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fullWidth: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageFullWidth: Scalars['Boolean'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  offerModels?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerType?: Maybe<Scalars['String']>;
  overlayTheme?: Maybe<Scalars['String']>;
  preTitleText?: Maybe<Scalars['String']>;
  price?: Maybe<PricePropertyBlock>;
  priceColumns: Scalars['Int'];
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  richText?: Maybe<RichText>;
  shade?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OpenHour = {
  __typename?: 'OpenHour';
  day?: Maybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  isClosed: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  startDateTime: Scalars['DateTime'];
  state?: Maybe<Scalars['String']>;
};

export type OptionsInput = {
  branchId?: InputMaybe<Scalars['ID']>;
  customerWait: Scalars['Boolean'];
  insuranceCompany?: InputMaybe<Scalars['String']>;
  leaveCarTimeText?: InputMaybe<Scalars['String']>;
  pickupTimeAndOtherQuestions?: InputMaybe<Scalars['String']>;
  rentalCar?: InputMaybe<Scalars['Boolean']>;
  serviceId: Scalars['ID'];
  smsReminder?: InputMaybe<Scalars['Boolean']>;
  subscriptionBoosterData?: InputMaybe<Array<InputMaybe<SubscriptionBoosterData>>>;
};

export type OraConfiguratorBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  models?: Maybe<Array<Maybe<OraConfiguratorModelBlock>>>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorChoiceBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorChoiceBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  choiceType?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  designType?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionTitle?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OraConfiguratorOptionBlock>>>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorChoicePlaceholderBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorChoicePlaceholderBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  choiceType?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  configurationPageUrl?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorModelBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorModelBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  choices?: Maybe<Array<Maybe<OraConfiguratorChoiceBlock>>>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preTitleText?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  richText?: Maybe<RichText>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorOptionBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorOptionBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fourthColor?: Maybe<Scalars['String']>;
  iconImage?: Maybe<Image>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  labelText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  preTitleText?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  primaryColor?: Maybe<Scalars['String']>;
  richText?: Maybe<RichText>;
  secondaryColor?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  summaryImage?: Maybe<Image>;
  thirdColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorOptionMileageBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorOptionMileageBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorOptionSmartBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorOptionSmartBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorPriceTypeBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorPriceTypeBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttonCashText?: Maybe<Scalars['String']>;
  buttonLeasingText?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OraConfiguratorSummaryBlock = BlockBaseType & {
  __typename?: 'OraConfiguratorSummaryBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Order = {
  __typename?: 'Order';
  booking?: Maybe<BookingReference>;
  cart: Cart;
  customerInformation?: Maybe<CartCustomerInformationGraphType>;
  orderDate: Scalars['DateTime'];
  orderNumber: Scalars['String'];
  orderStatus: OrderStatus;
  vehicle?: Maybe<VehicleReference>;
};

export type OrderInformationBlock = {
  __typename?: 'OrderInformationBlock';
  amountExcludingTax?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  assemblyOnSite?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookingHeading?: Maybe<Scalars['String']>;
  branchHeading?: Maybe<Scalars['String']>;
  cancelBookingInfo?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  changeBooking?: Maybe<Scalars['String']>;
  changeBookingUrl?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  faqHeading?: Maybe<Scalars['String']>;
  faqLists?: Maybe<Array<Maybe<FaqListBlock>>>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mapLinkText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  moreSalesHeading?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderConfirmedBody?: Maybe<Scalars['String']>;
  orderConfirmedHeading?: Maybe<Scalars['String']>;
  orderHeading?: Maybe<Scalars['String']>;
  orderReceivedBody?: Maybe<Scalars['String']>;
  orderReceivedHeading?: Maybe<Scalars['String']>;
  paymentFootnote?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentOnSite?: Maybe<Scalars['String']>;
  paymentOptionServiceTechnician?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tableEntry?: Maybe<Scalars['String']>;
  tableValue?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['String']>;
  technicianHeading?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OrderInformationLinkBlock = {
  __typename?: 'OrderInformationLinkBlock';
  description: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type OrderInformationLinksBlock = {
  __typename?: 'OrderInformationLinksBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  links?: Maybe<Array<Maybe<OrderInformationLinkBlock>>>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type OrderOperationMessage = {
  __typename?: 'OrderOperationMessage';
  code: ValidationError;
  message: Scalars['String'];
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  cart?: Maybe<Cart>;
  checkoutSteps: Array<Maybe<CheckoutStep>>;
  operationMessages: Array<Maybe<OrderOperationMessage>>;
  orderId: Scalars['Guid'];
  status: CheckoutStatus;
};

export enum OrderStatus {
  Completed = 'COMPLETED'
}

export type OrderVehicleInformationInput = {
  /** If a id is not provided then a id will be generated and returned in the response. */
  orderId?: InputMaybe<Scalars['Guid']>;
  registrationNumber: Scalars['String'];
  siteId: Scalars['Guid'];
};

export type OriginalServiceBlock = {
  __typename?: 'OriginalServiceBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  button?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  links?: Maybe<Array<Maybe<CallToAction>>>;
  logo?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type PackageCartProduct = {
  __typename?: 'PackageCartProduct';
  id: Scalars['String'];
  items: Array<Maybe<PackageCartProductItem>>;
};

export type PackageCartProductItem = {
  __typename?: 'PackageCartProductItem';
  product?: Maybe<CartProductsUnion>;
  quantity: Scalars['Int'];
};

export type PackageVersion = {
  __typename?: 'PackageVersion';
  /** @deprecated Remove usage of this value since it's not being used anywhere */
  currentBiliaCardLaborPrice: Scalars['Int'];
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentLaborPrice: Scalars['Int'];
  currentPrice: Scalars['Int'];
  discountAmount?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  packageVersionBrandId: Scalars['Int'];
  packageVersionCode?: Maybe<Scalars['String']>;
  packageVersionDescription?: Maybe<Scalars['String']>;
  packageVersionExtraLimitationText?: Maybe<Scalars['String']>;
  packageVersionExtraLimitationTextErp?: Maybe<Scalars['String']>;
  packageVersionName?: Maybe<Scalars['String']>;
  packageVersionNameErp?: Maybe<Scalars['String']>;
  packageVersionNumber?: Maybe<Scalars['String']>;
  packageVersionVehicleTypeId: Scalars['Int'];
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
};

export type PageBreadcrumbs = {
  __typename?: 'PageBreadcrumbs';
  items?: Maybe<Array<Maybe<Breadcrumb>>>;
  label?: Maybe<Scalars['String']>;
};

export type PageContent = {
  __typename?: 'PageContent';
  activeConfigurationGroupId?: Maybe<Scalars['String']>;
  anchorLinksBarSettings?: Maybe<AnchorLinksBarPropertyBlock>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  branchSalesPersonContactPageUrl?: Maybe<Scalars['String']>;
  branchTechnicianPersonContactPageUrl?: Maybe<Scalars['String']>;
  car?: Maybe<Car>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  checkoutPageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  navigationPanelId?: Maybe<Scalars['ID']>;
  orderPageUrl?: Maybe<Scalars['String']>;
  pageInstance?: Maybe<PageInstance>;
  /** @deprecated Replaced by property Type instead. */
  pageType?: Maybe<Scalars['String']>;
  registrationNumberModalSettings?: Maybe<RegistrationNumberModalSettings>;
  route?: Maybe<Scalars['String']>;
  serviceIds?: Maybe<Scalars['String']>;
  serviceMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  simpleUrl?: Maybe<Scalars['String']>;
  tireSeason: Season;
  type?: Maybe<Scalars['String']>;
};

export type PageFormMetaData = {
  __typename?: 'PageFormMetaData';
  branch?: Maybe<Scalars['String']>;
  carBrand?: Maybe<Scalars['String']>;
  carModel?: Maybe<Scalars['String']>;
  isTransportVehicleFallback: Scalars['Boolean'];
};

export type PageInstance = {
  __typename?: 'PageInstance';
  breadcrumbs?: Maybe<PageBreadcrumbs>;
  formMetaData?: Maybe<PageFormMetaData>;
  metadata?: Maybe<PageMetadata>;
  pageLayout?: Maybe<Scalars['String']>;
  pageTheme?: Maybe<Scalars['String']>;
  schema?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PageMetadata = {
  __typename?: 'PageMetadata';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noIndex: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum PartOfDay {
  Afternoon = 'AFTERNOON',
  AllDay = 'ALL_DAY',
  Morning = 'MORNING',
  Noon = 'NOON'
}

export type PositionInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PreliminaryBookingResponse = {
  __typename?: 'PreliminaryBookingResponse';
  bookingId?: Maybe<Scalars['String']>;
  reservedTime?: Maybe<Scalars['Int']>;
  responseMessage?: Maybe<Scalars['String']>;
};

export enum PriceDetailType {
  Article = 'ARTICLE',
  Discount = 'DISCOUNT',
  Fee = 'FEE'
}

export type PriceInput = {
  biliaCardPrice?: InputMaybe<Scalars['Int']>;
  disclaimer: Scalars['String'];
  isFromPrice: Scalars['Boolean'];
  packageCode?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  priceDescription: Scalars['String'];
  priceGroupName?: InputMaybe<Scalars['String']>;
  textPrice: Scalars['String'];
};

export type PriceItem = {
  __typename?: 'PriceItem';
  message: Scalars['String'];
  price: Scalars['Int'];
  reducedPrice: Scalars['Int'];
};

export type PriceItemInput = {
  message: Scalars['String'];
  price: Scalars['Int'];
  reducedPrice: Scalars['Int'];
};

export type PriceProperty = {
  __typename?: 'PriceProperty';
  description?: Maybe<Scalars['String']>;
  isMonthlyPrice: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  priceType?: Maybe<Scalars['String']>;
};

export type PricePropertyBlock = {
  __typename?: 'PricePropertyBlock';
  labelMonthlyCost?: Maybe<Scalars['String']>;
  labelPrimaryPrice?: Maybe<Scalars['String']>;
  labelReducedPrice?: Maybe<Scalars['String']>;
  labelSecondaryPrice?: Maybe<Scalars['String']>;
  monthlyCost?: Maybe<Scalars['String']>;
  primaryPrice?: Maybe<Scalars['String']>;
  reducedPrice?: Maybe<Scalars['String']>;
  secondaryPrice?: Maybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductBikeCarrier = {
  __typename?: 'ProductBikeCarrier';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBikeCarrierAttachment?: Maybe<Scalars['String']>;
  productBikeCarrierBikeAttachment?: Maybe<Scalars['String']>;
  productBikeCarrierBikeLock?: Maybe<Scalars['String']>;
  productBikeCarrierBrakeDiscCompatibility?: Maybe<Scalars['Boolean']>;
  productBikeCarrierDetachableFrameHolder?: Maybe<Scalars['Boolean']>;
  productBikeCarrierFrameSize?: Maybe<Scalars['String']>;
  productBikeCarrierTypeOfPlug?: Maybe<Scalars['String']>;
  productBikeCarrierWithBacklight?: Maybe<Scalars['Boolean']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductBikeCarrierDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductBikeCarrierImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductBikeCarrierVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductBikeCarrierVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductCategoriesComparisonBlock = {
  __typename?: 'ProductCategoriesComparisonBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  productCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  numberOfProductsToFetch: Scalars['Int'];
  pageId: Scalars['ID'];
  pageUrl: Scalars['String'];
  tireSeason: Season;
  title?: Maybe<Scalars['String']>;
};

export type ProductCategoryPageLinkType = {
  __typename?: 'ProductCategoryPageLinkType';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ProductCategoryTiresType = {
  __typename?: 'ProductCategoryTiresType';
  pageLink?: Maybe<ProductCategoryPageLinkType>;
  tires?: Maybe<Array<Maybe<Product>>>;
};

export type ProductDetailPageUspBlock = {
  __typename?: 'ProductDetailPageUspBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspCalculation: UspCalculation;
};

export type ProductDogCage = {
  __typename?: 'ProductDogCage';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productDogCageAdjustableVolume?: Maybe<Scalars['Boolean']>;
  productDogCageDeformationZone?: Maybe<Scalars['Boolean']>;
  productDogCageEmergencyDoor?: Maybe<Scalars['Boolean']>;
  productDogCageFitsHighTrunk?: Maybe<Scalars['Boolean']>;
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductDogCageDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductDogCageImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductDogCageVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductDogCageVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductElectricCarCharge = {
  __typename?: 'ProductElectricCarCharge';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productElectricCarMode?: Maybe<Scalars['String']>;
  productElectricCarPlug?: Maybe<Scalars['String']>;
  productElectricCarSupply?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductElectricCarChargeDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductElectricCarChargeImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductElectricCarChargeVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductElectricCarChargeVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductHeadBlock = BlockBaseType & {
  __typename?: 'ProductHeadBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  downloads?: Maybe<Array<Maybe<Download>>>;
  excludeFromQueries: Scalars['Boolean'];
  faqLists?: Maybe<Array<Maybe<FaqListBlock>>>;
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<ProductsUnion>;
  productSpecifications?: Maybe<Array<Maybe<ProductSpecification>>>;
  shade?: Maybe<Scalars['String']>;
  termsAndConditionLists?: Maybe<Array<Maybe<FaqListBlock>>>;
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspBlockIds?: Maybe<Array<Scalars['ID']>>;
  uspBlocks?: Maybe<Array<Maybe<ProductDetailPageUspBlock>>>;
  variation?: Maybe<VariationsUnion>;
  variationsByRegistrationNumber?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
};


export type ProductHeadBlockVariationsByRegistrationNumberArgs = {
  isTransportVehicle?: InputMaybe<Scalars['Boolean']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  altText?: Maybe<Scalars['String']>;
  changed: Scalars['DateTime'];
  contentReferenceId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ResourceType;
};

export type ProductInfantCarSeat = {
  __typename?: 'ProductInfantCarSeat';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBaseIncluded?: Maybe<Scalars['Boolean']>;
  productBaseNeeded?: Maybe<Scalars['Boolean']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productFitsAgeFrom: Scalars['Int'];
  productFitsAgeTo: Scalars['Int'];
  productFitsLengthFrom: Scalars['Int'];
  productFitsLengthTo: Scalars['Int'];
  productFitsWeightFrom: Scalars['Int'];
  productFitsWeightTo: Scalars['Int'];
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductInfantCarSeatDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductInfantCarSeatImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductInfantCarSeatVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductInfantCarSeatVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductParts = {
  __typename?: 'ProductParts';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductPartsDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductPartsImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductPartsVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductPartsVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Int'];
  discount?: Maybe<ProductPriceDiscount>;
  isFromPrice: Scalars['Boolean'];
};

export type ProductPriceDiscount = {
  __typename?: 'ProductPriceDiscount';
  amount: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['Int'];
  /** The lowest price for the product during the 30 days prior to the price reduction */
  previousPrice: Scalars['Int'];
};

export type ProductRim = {
  __typename?: 'ProductRim';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productRimBoltCircle?: Maybe<Scalars['String']>;
  productRimWinterAdapted?: Maybe<Scalars['Boolean']>;
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductRimDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductRimImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductRimVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductRimVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductRoofBox = {
  __typename?: 'ProductRoofBox';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCollapsable?: Maybe<Scalars['Boolean']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLoadCapacitySkiFrom?: Maybe<Scalars['Int']>;
  productLoadCapacitySkiTo?: Maybe<Scalars['Int']>;
  productLoadCapacitySnowboardFrom?: Maybe<Scalars['Int']>;
  productLoadCapacitySnowboardTo?: Maybe<Scalars['Int']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productRoofBoxMaxSkiLength?: Maybe<Scalars['Int']>;
  productRoofBoxOpening?: Maybe<Scalars['String']>;
  productRoofBoxPositioning?: Maybe<Scalars['String']>;
  productRoofBoxSkiAttachment?: Maybe<Scalars['String']>;
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductRoofBoxDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductRoofBoxImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductRoofBoxVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductRoofBoxVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductSearchBlock = BlockBaseType & {
  __typename?: 'ProductSearchBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  clearFilterAriaLabel?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  filtersHeading?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  mixInBlockFrequency: Scalars['Int'];
  mixInBlockIds?: Maybe<Array<Scalars['ID']>>;
  mixInBlockRepetitions: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  resultLabel?: Maybe<Scalars['String']>;
  seoBlockIds?: Maybe<Array<Scalars['ID']>>;
  shade?: Maybe<Scalars['String']>;
  sortings?: Maybe<Array<Maybe<TextValue>>>;
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type ProductSearchResult = {
  __typename?: 'ProductSearchResult';
  aggregates?: Maybe<Array<Maybe<AggregateTypes>>>;
  products?: Maybe<Array<Maybe<ProductsUnion>>>;
  totalNumberOfHits: Scalars['Long'];
};

export type ProductService = {
  __typename?: 'ProductService';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentServiceId: Scalars['ID'];
  parentServiceName?: Maybe<Scalars['String']>;
  productCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  serviceId: Scalars['ID'];
};

export type ProductServicesRequest = {
  carMake: Scalars['String'];
  hasTireHotel: Scalars['Boolean'];
  indexPrefix: Scalars['String'];
  productCategories: Array<Scalars['String']>;
};

export type ProductSiteSearchResultType = {
  __typename?: 'ProductSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  result?: Maybe<Array<Maybe<SearchProduct>>>;
  suggest?: Maybe<Array<Maybe<Content>>>;
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type ProductSkiCarrier = {
  __typename?: 'ProductSkiCarrier';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLoadCapacitySkiFrom?: Maybe<Scalars['Int']>;
  productLoadCapacitySkiTo?: Maybe<Scalars['Int']>;
  productLoadCapacitySnowboardFrom?: Maybe<Scalars['Int']>;
  productLoadCapacitySnowboardTo?: Maybe<Scalars['Int']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductSkiCarrierDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductSkiCarrierImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductSkiCarrierVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductSkiCarrierVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductSpecification = {
  __typename?: 'ProductSpecification';
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  value: Scalars['String'];
};

export type ProductTire = {
  __typename?: 'ProductTire';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productManufacturerUsp?: Maybe<Scalars['String']>;
  productManufacturerUspText?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTireRunFlat?: Maybe<Scalars['Boolean']>;
  productTireSeason?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductTireDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductTireImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductTireVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductTireVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductVideo = {
  __typename?: 'ProductVideo';
  altText?: Maybe<Scalars['String']>;
  changed: Scalars['DateTime'];
  contentReferenceId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ResourceType;
  videoId?: Maybe<Scalars['String']>;
  videoStreamingService?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type ProductWatersportCarrier = {
  __typename?: 'ProductWatersportCarrier';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Remove usage from Product class, use from ProductTire and ProductWheel instead */
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductWatersportCarrierDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductWatersportCarrierImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductWatersportCarrierVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductWatersportCarrierVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductWheel = {
  __typename?: 'ProductWheel';
  canonicalUrl?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  categoryNames: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  displayPrice: ProductPrice;
  downloads?: Maybe<Array<Maybe<Download>>>;
  hasDifferentDeliveryDateStatus: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  indexedDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use field displayPrice.isFromPrice instead when 30-days rule is in place */
  isFromPrice?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use field displayPrice.amount instead when 30-days rule is in place */
  lowestVariationPrice?: Maybe<Scalars['Int']>;
  numberOfVariations?: Maybe<Scalars['Int']>;
  primaryCategoryCode?: Maybe<Scalars['String']>;
  primaryCategoryIds: Array<Scalars['Int']>;
  primaryCategoryPageId?: Maybe<Scalars['ID']>;
  primaryRoute?: Maybe<Scalars['String']>;
  productAccessoriesAttachmentType?: Maybe<Scalars['String']>;
  productAllowStorePickup: Scalars['Boolean'];
  productAssortment?: Maybe<Scalars['String']>;
  productBestInTest: Scalars['Boolean'];
  productBestInTestStatement?: Maybe<Scalars['String']>;
  productBestInTestUrl?: Maybe<Scalars['String']>;
  productBrand?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCurrency?: Maybe<Scalars['String']>;
  productCustomDeliveryTime?: Maybe<Scalars['Int']>;
  productDefaultAmount: Scalars['Int'];
  productEcoLabel?: Maybe<Scalars['String']>;
  productExtendedWarrantyRegistration: Scalars['Boolean'];
  productExtendedWarrantyRegistrationNumYears?: Maybe<Scalars['Decimal']>;
  productExtendedWarrantyRegistrationUrl?: Maybe<Scalars['String']>;
  productGoogleProductCategory: Scalars['Int'];
  productItemVariationIdentifier?: Maybe<Scalars['String']>;
  productLockable?: Maybe<Scalars['String']>;
  productManual?: Maybe<Scalars['String']>;
  productManufacturerUsp?: Maybe<Scalars['String']>;
  productManufacturerUspText?: Maybe<Scalars['String']>;
  productMaterial?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNotShippedToPostOmbud: Scalars['Boolean'];
  productNumber?: Maybe<Scalars['String']>;
  productNumberPrefix?: Maybe<Scalars['String']>;
  productPictogram?: Maybe<Scalars['String']>;
  productRecommended: Scalars['Boolean'];
  productRimBoltCircle?: Maybe<Scalars['String']>;
  productRimWinterAdapted?: Maybe<Scalars['Boolean']>;
  productSafetyCertification?: Maybe<Scalars['String']>;
  productSalesUnit?: Maybe<Scalars['String']>;
  productServiceId?: Maybe<Scalars['ID']>;
  productShippingGroup?: Maybe<Scalars['String']>;
  productSocialMediaDescription?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productSubcategory?: Maybe<Scalars['String']>;
  productSupplierName?: Maybe<Scalars['String']>;
  productTireRunFlat?: Maybe<Scalars['Boolean']>;
  productTireSeason?: Maybe<Scalars['String']>;
  productTransportPackageHeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageLength?: Maybe<Scalars['Decimal']>;
  productTransportPackageWeight?: Maybe<Scalars['Decimal']>;
  productTransportPackageWidth?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  productTypeKey?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  productWarranty?: Maybe<Scalars['Decimal']>;
  productWheelRimBrand?: Maybe<Scalars['String']>;
  productWheelRimModel?: Maybe<Scalars['String']>;
  productWheelRimType?: Maybe<Scalars['String']>;
  productWheelTireBrand?: Maybe<Scalars['String']>;
  productWheelTireModel?: Maybe<Scalars['String']>;
  productWheelTireType?: Maybe<Scalars['String']>;
  productWheelTpms?: Maybe<Scalars['Boolean']>;
  selectedVariationCode?: Maybe<Scalars['String']>;
  shortestDeliveryDateStatus: DeliveryDateStatus;
  slug?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  type: Scalars['String'];
  /** @deprecated Use field variationWithLowestPrice.variationDisplayValue instead */
  variationDisplayValue?: Maybe<Scalars['String']>;
  variationWithLowestPrice?: Maybe<VariationsUnion>;
  variations?: Maybe<Array<Maybe<VariationsUnion>>>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type ProductWheelDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type ProductWheelImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type ProductWheelVariationsArgs = {
  numberOfVariations?: InputMaybe<Scalars['Int']>;
};


export type ProductWheelVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type ProductsUnion = Product | ProductBikeCarrier | ProductDogCage | ProductElectricCarCharge | ProductInfantCarSeat | ProductParts | ProductRim | ProductRoofBox | ProductSkiCarrier | ProductTire | ProductWatersportCarrier | ProductWheel;

export type PurchaseOrderResponse = {
  __typename?: 'PurchaseOrderResponse';
  order?: Maybe<Order>;
  orderId: Scalars['Guid'];
};

export type Queries = {
  frequency: Scalars['Int'];
  id: Scalars['String'];
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortings?: InputMaybe<Array<InputMaybe<QuerySort>>>;
};

export type QueryFilter = {
  field: Scalars['String'];
  value: Scalars['String'];
};

export type QueryResult = {
  __typename?: 'QueryResult';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  frequency: Scalars['Int'];
  isMainResult: Scalars['Boolean'];
  mainResult?: Maybe<Array<Maybe<QueryUnionType>>>;
  subResult?: Maybe<Array<Maybe<QueryUnionType>>>;
  totalItems: Scalars['Long'];
  type?: Maybe<Scalars['String']>;
};

export type QuerySort = {
  field: Scalars['String'];
  sort: Scalars['String'];
};

export type QueryUnionType = Car | CarModelPageBlock | GenericLeadinCard | OfferLeadinBlockCard | Product | UspCard | UspInfoCard | UspLeadinCard;

export type RadioButtonChoice = {
  __typename?: 'RadioButtonChoice';
  label: Scalars['String'];
};

export type RadioButtonListOption = {
  __typename?: 'RadioButtonListOption';
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type RangeAggregate = AggregateBase & {
  __typename?: 'RangeAggregate';
  decimals: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  maxRangeValue: Scalars['Float'];
  maxSelectedRangeValue: Scalars['Float'];
  minRangeValue: Scalars['Float'];
  minSelectedRangeValue: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  step: Scalars['Float'];
  topFilter: Scalars['Boolean'];
};

export type RangeSingleAggregate = AggregateBase & {
  __typename?: 'RangeSingleAggregate';
  decimals: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  maxRangeValue: Scalars['Float'];
  minRangeValue: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  selectedRangeValue: Scalars['Float'];
  sortOrder: Scalars['Int'];
  step: Scalars['Float'];
  topFilter: Scalars['Boolean'];
};

export type ReBookingWorkShopConfirmationBlock = {
  __typename?: 'ReBookingWorkShopConfirmationBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookingNotFoundInfoText?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  openInGoogleMaps?: Maybe<Scalars['String']>;
  reBookingConfirmationInfoText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  timeAndPlace?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type RegNumberPropertyBlock = {
  __typename?: 'RegNumberPropertyBlock';
  errorText?: Maybe<Scalars['String']>;
  inputPattern?: Maybe<Scalars['String']>;
  placeholderText?: Maybe<Scalars['String']>;
  plateCountryCode?: Maybe<Scalars['String']>;
};

export type Region = {
  __typename?: 'Region';
  name?: Maybe<Scalars['String']>;
  regionCode: Scalars['Int'];
};

export type RegistrationNumberModalSettings = {
  __typename?: 'RegistrationNumberModalSettings';
  carBrandsTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  showCarBrands: Scalars['Boolean'];
  showTireDimension: Scalars['Boolean'];
  tireDimensionLinkTitle?: Maybe<Scalars['String']>;
  tireDimensionTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RemoveBranchAndDateInputType = {
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};

export type RemoveItemFromCartInput = {
  cartItemId: Scalars['Guid'];
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
};

export type ResellerPackagingOption = {
  __typename?: 'ResellerPackagingOption';
  ctaName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum ResourceType {
  Ann = 'ANN',
  Anvi = 'ANVI',
  Arb = 'ARB',
  Arvi = 'ARVI',
  Bro = 'BRO',
  Kab = 'KAB',
  Kat = 'KAT',
  Logo = 'LOGO',
  Man = 'MAN',
  Mavi = 'MAVI',
  Mib = 'MIB',
  Mivi = 'MIVI',
  Mju = 'MJU',
  Pab = 'PAB',
  Prb = 'PRB',
  Prt = 'PRT',
  Prvi = 'PRVI',
  Vab = 'VAB',
  Vavi = 'VAVI',
  Vil = 'VIL'
}

export type RichText = {
  __typename?: 'RichText';
  content?: Maybe<Scalars['String']>;
  showLessLabel?: Maybe<Scalars['String']>;
  showMoreLabel?: Maybe<Scalars['String']>;
};

export enum SalesCategory {
  NewCar = 'NEW_CAR',
  Unknown = 'UNKNOWN',
  UsedCar = 'USED_CAR'
}

export type SalesPerson = {
  __typename?: 'SalesPerson';
  brand?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  departmentId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  employeeNumber: Scalars['Int'];
  employeeType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sells?: Maybe<Array<Maybe<Scalars['String']>>>;
  supportedCarMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ScheduleBookingResponse = {
  __typename?: 'ScheduleBookingResponse';
  days?: Maybe<Array<Maybe<Day>>>;
  technicians?: Maybe<Array<Maybe<BookmakerTechnicianType>>>;
};

export type ScheduleQuery = {
  branchId: Scalars['ID'];
  carMake?: InputMaybe<Scalars['String']>;
  carMakeCode: Scalars['String'];
  culture: Scalars['String'];
  forwardDays: Scalars['Boolean'];
  hasTireInCart: Scalars['Boolean'];
  indexPrefix: Scalars['String'];
  isSlot?: InputMaybe<Scalars['Boolean']>;
  isTireHotel: Scalars['Boolean'];
  numberOfDays: Scalars['Int'];
  oneDaySelected: Scalars['Boolean'];
  operationType?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['ID']>;
  siteId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type ScriptBlock = BlockBaseType & {
  __typename?: 'ScriptBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isAsync: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SearchBarBlock = BlockBaseType & {
  __typename?: 'SearchBarBlock';
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeHolder?: Maybe<Scalars['String']>;
  productSectionId: Scalars['Int'];
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  searchBarType?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showMoreText?: Maybe<Scalars['String']>;
  sticky: Scalars['Boolean'];
  suggestionsHeading?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SearchFilterParameter = {
  __typename?: 'SearchFilterParameter';
  key?: Maybe<Scalars['String']>;
  keyword: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type SearchMatch = {
  __typename?: 'SearchMatch';
  brand?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
};

export enum SearchObjectType {
  Accessories = 'ACCESSORIES',
  BikeCarrier = 'BIKE_CARRIER',
  DogCage = 'DOG_CAGE',
  ElectricCarCharge = 'ELECTRIC_CAR_CHARGE',
  Generic = 'GENERIC',
  InfantSeat = 'INFANT_SEAT',
  Lamp = 'LAMP',
  Parts = 'PARTS',
  Rim = 'RIM',
  RoofBox = 'ROOF_BOX',
  RoofRack = 'ROOF_RACK',
  SkiCarrier = 'SKI_CARRIER',
  Tire = 'TIRE',
  WatersportCarrier = 'WATERSPORT_CARRIER',
  Wheel = 'WHEEL',
  WorkShopService = 'WORK_SHOP_SERVICE'
}

export type SearchPhraseResultType = {
  __typename?: 'SearchPhraseResultType';
  keywords?: Maybe<Array<Maybe<Keyword>>>;
  phrase: Scalars['String'];
};

export type SearchProduct = {
  __typename?: 'SearchProduct';
  brand?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  productType?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  variations?: Maybe<Array<Scalars['String']>>;
};

export type SearchResultViewModel = {
  __typename?: 'SearchResultViewModel';
  aggregates?: Maybe<Array<Maybe<AggregateTypes>>>;
  cars?: Maybe<Array<Maybe<Car>>>;
  totalNumberOfHits: Scalars['Long'];
};

export type SearchSlot = {
  __typename?: 'SearchSlot';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isSiteDefault: Scalars['Boolean'];
  partOfDay: PartOfDay;
  rangeStart?: Maybe<Scalars['String']>;
};

export enum Season {
  Summer = 'SUMMER',
  Unknown = 'UNKNOWN',
  Winter = 'WINTER'
}

export type SectionBlock = BlockBaseType & {
  __typename?: 'SectionBlock';
  anchorIcon?: Maybe<Scalars['String']>;
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  innerPadding?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  showInAnchorLeadinBlock: Scalars['Boolean'];
  subTheme?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useBlockWidth: Scalars['Boolean'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SectionEndBlock = {
  __typename?: 'SectionEndBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SelectListOption = {
  __typename?: 'SelectListOption';
  groupHeader: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type SelectedQuery = {
  __typename?: 'SelectedQuery';
  frequency: Scalars['Int'];
  queryId: Scalars['ID'];
  queryName?: Maybe<Scalars['String']>;
  queryTypeId: Scalars['ID'];
  queryTypeName?: Maybe<Scalars['String']>;
  sortings?: Maybe<Array<Maybe<FieldSorting>>>;
};

export type Service = {
  __typename?: 'Service';
  description: Scalars['String'];
  icon: Scalars['String'];
  name: Scalars['String'];
};

export type ServiceCartProduct = {
  __typename?: 'ServiceCartProduct';
  icon: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ServiceConfigurationInput = {
  __typename?: 'ServiceConfigurationInput';
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  placeHolder?: Maybe<Scalars['String']>;
  serviceConfigurationInputType: ServiceConfigurationInputType;
  sortOrder: Scalars['Int'];
};

export enum ServiceConfigurationInputType {
  /** Customer comment */
  CustomerComment = 'CUSTOMER_COMMENT',
  /** Mileage */
  Mileage = 'MILEAGE',
  /** Wheel sales */
  WheelSales = 'WHEEL_SALES'
}

export type ServiceGroup = {
  __typename?: 'ServiceGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  openByDefault: Scalars['Boolean'];
  services?: Maybe<Array<Maybe<WorkshopService>>>;
};

export type ServiceGroupResponse = ServiceGroups | StatusCodeResponse;

export type ServiceGroups = {
  __typename?: 'ServiceGroups';
  serviceGroupList?: Maybe<Array<Maybe<ServiceGroup>>>;
};

export type ServiceLeadinCard = BlockBaseType & {
  __typename?: 'ServiceLeadinCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  campaign?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  initBtnLabel?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<PricePropertyBlock>;
  priceColumns: Scalars['Int'];
  prices?: Maybe<Array<Maybe<PriceProperty>>>;
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type ServiceLeadinLargeBlock = BlockBaseType & {
  __typename?: 'ServiceLeadinLargeBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  bookingModalTitlePrefix?: Maybe<Scalars['String']>;
  button?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  hideAllOriginalServicesText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  originalServices?: Maybe<Array<Maybe<OriginalServiceBlock>>>;
  originalServicesListTitle?: Maybe<Scalars['String']>;
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  shade?: Maybe<Scalars['String']>;
  showAllOriginalServicesText?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type ServicePlan = {
  __typename?: 'ServicePlan';
  description: Scalars['String'];
  hasServiceAgreement: Scalars['Boolean'];
  kitCode: Scalars['Int'];
  name: Scalars['String'];
  price?: Maybe<PriceItem>;
  serviceActivities?: Maybe<Array<Maybe<Scalars['String']>>>;
  servicePlanSummarize: Scalars['String'];
  serviceTypes?: Maybe<Array<Maybe<Service>>>;
};

export type ServicePlanInput = {
  hasServiceAgreement?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<PriceItemInput>;
  serviceActivities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  servicePlanSummarize?: InputMaybe<Scalars['String']>;
};

export type ServicePrice = {
  __typename?: 'ServicePrice';
  biliaCardPrice?: Maybe<Scalars['Int']>;
  disclaimer: Scalars['String'];
  id: Scalars['ID'];
  isFromPrice: Scalars['Boolean'];
  packageCode?: Maybe<Scalars['String']>;
  parentId: Scalars['ID'];
  price: Scalars['Int'];
  priceDescription: Scalars['String'];
  priceGroupName?: Maybe<Scalars['String']>;
  textPrice: Scalars['String'];
};

export type SingleQuery = {
  __typename?: 'SingleQuery';
  result?: Maybe<Array<Maybe<QueryUnionType>>>;
  totalItems: Scalars['Long'];
  type?: Maybe<Scalars['String']>;
};

export type SiteCarMake = {
  __typename?: 'SiteCarMake';
  code?: Maybe<Scalars['String']>;
  isTransportCar: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type SiteContent = {
  __typename?: 'SiteContent';
  branchSettings?: Maybe<BranchSettings>;
  footer?: Maybe<FooterContent>;
  general?: Maybe<SiteContentGeneral>;
  id: Scalars['String'];
  navigation?: Maybe<SiteNavigationContent>;
  navigationPanel?: Maybe<NavigationPanelType>;
  resources?: Maybe<Array<Maybe<SiteContentResource>>>;
  siteSearch?: Maybe<SiteSearchType>;
};

export type SiteContentGeneral = {
  __typename?: 'SiteContentGeneral';
  checkoutPageUrl?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencyMonth?: Maybe<Scalars['String']>;
  currencyVisualLabel?: Maybe<Scalars['String']>;
  defaultBranchSearchUrl?: Maybe<Scalars['String']>;
  defaultCarSearchUrl?: Maybe<Scalars['String']>;
  favoritesPageUrl?: Maybe<Scalars['String']>;
  financePostbackPageUrl?: Maybe<Scalars['String']>;
  headerScript?: Maybe<Scalars['String']>;
  indexPrefix?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  logoAlt?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  numberRegex?: Maybe<Scalars['String']>;
  orderPageUrl?: Maybe<Scalars['String']>;
  pageNotFoundErrorText?: Maybe<Scalars['String']>;
  priceValueRegex?: Maybe<Scalars['String']>;
  showWarningTextGlobally: Scalars['Boolean'];
  siteId: Scalars['ID'];
  siteName?: Maybe<Scalars['String']>;
  siteTheme?: Maybe<Scalars['String']>;
  supportUrl?: Maybe<Scalars['String']>;
  tireHelpLinks?: Maybe<Array<Maybe<CallToAction>>>;
  warningText?: Maybe<Scalars['String']>;
};

export type SiteContentResource = {
  __typename?: 'SiteContentResource';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SiteNavigationContent = {
  __typename?: 'SiteNavigationContent';
  blockIds?: Maybe<Array<Scalars['ID']>>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  breadcrumbsLabel?: Maybe<Scalars['String']>;
  childrenIds?: Maybe<Array<Scalars['ID']>>;
  footerLinks?: Maybe<Array<Maybe<CallToAction>>>;
  items?: Maybe<Array<Maybe<NavigationContent>>>;
  panelLabel?: Maybe<Scalars['String']>;
};

export type SiteSearchBranchType = BlockBaseType & {
  __typename?: 'SiteSearchBranchType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchCarModelType = BlockBaseType & {
  __typename?: 'SiteSearchCarModelType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchCarType = BlockBaseType & {
  __typename?: 'SiteSearchCarType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchFaqType = BlockBaseType & {
  __typename?: 'SiteSearchFaqType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchLogClickResponse = {
  __typename?: 'SiteSearchLogClickResponse';
  success: Scalars['Boolean'];
};

export type SiteSearchPageType = BlockBaseType & {
  __typename?: 'SiteSearchPageType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SiteSearchProductType = BlockBaseType & {
  __typename?: 'SiteSearchProductType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  registrationNumberText?: Maybe<Scalars['String']>;
  registrationNumberTitle?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchResult = {
  __typename?: 'SiteSearchResult';
  branch?: Maybe<BranchSiteSearchResultType>;
  car?: Maybe<CarSiteSearchResultType>;
  carmodel?: Maybe<CarModelSiteSearchResultType>;
  content?: Maybe<ContentSiteSearchResultType>;
  faq?: Maybe<FaqSearchResult>;
  /** @deprecated Remove once not being used in frontend anymore */
  id?: Maybe<Scalars['String']>;
  keyword?: Maybe<KeywordSiteSearchResultType>;
  /** @deprecated Remove usage in frontend, then remove this field */
  match?: Maybe<SearchMatch>;
  product?: Maybe<ProductSiteSearchResultType>;
  tire?: Maybe<TireSiteSearchResultType>;
  totalHits: Scalars['Long'];
  vehicletire?: Maybe<TireSiteSearchResultType>;
  workshopservice?: Maybe<WorkshopServiceSiteSearchResultType>;
};

export type SiteSearchTireType = BlockBaseType & {
  __typename?: 'SiteSearchTireType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  registrationNumberText?: Maybe<Scalars['String']>;
  registrationNumberTitle?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  viewAllResultText?: Maybe<Scalars['String']>;
};

export type SiteSearchType = BlockBaseType & {
  __typename?: 'SiteSearchType';
  allOptionText?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  bottomText?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  feedbackButtonText?: Maybe<Scalars['String']>;
  feedbackDescription?: Maybe<Scalars['String']>;
  feedbackUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  popularTitle?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  showBetaLabel: Scalars['Boolean'];
  showFeedback: Scalars['Boolean'];
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topText?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type SiteSearchWorkshopServiceType = BlockBaseType & {
  __typename?: 'SiteSearchWorkshopServiceType';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  popularWords?: Maybe<Array<Maybe<Scalars['String']>>>;
  shade?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type Slot = {
  __typename?: 'Slot';
  available: Scalars['Boolean'];
  containerId: Scalars['Int'];
  span: Scalars['Int'];
  startTime: Scalars['DateTime'];
  startTimeUtc: Scalars['DateTimeOffset'];
};

export type SlotGroup = {
  __typename?: 'SlotGroup';
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  to?: Maybe<Scalars['String']>;
};

export type SoldCarObjectBlock = BlockBaseType & {
  __typename?: 'SoldCarObjectBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  missingOrSoldCarText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  uspText?: Maybe<Scalars['String']>;
};

export type StatusCodeResponse = {
  __typename?: 'StatusCodeResponse';
  message?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
};

export type SubmitBookingQueryInput = {
  branchCode?: InputMaybe<Scalars['String']>;
  branchName?: InputMaybe<Scalars['String']>;
  branchPhone?: InputMaybe<Scalars['String']>;
  branchPosition?: InputMaybe<PositionInput>;
  branchPostalNumber?: InputMaybe<Scalars['String']>;
  branchStreetAddress?: InputMaybe<Scalars['String']>;
  branchTown?: InputMaybe<Scalars['String']>;
  carMake: Scalars['String'];
  carMakeCode?: InputMaybe<Scalars['String']>;
  carMakeYear?: InputMaybe<Scalars['Int']>;
  carModel?: InputMaybe<Scalars['String']>;
  container?: InputMaybe<ContainerInput>;
  culture: Scalars['String'];
  customerInformation: CustomerInformationInput;
  freeStorage?: InputMaybe<Scalars['Boolean']>;
  hasTireHotel?: InputMaybe<Scalars['Boolean']>;
  indexPrefix?: InputMaybe<Scalars['String']>;
  moreSales?: InputMaybe<Array<InputMaybe<MoreSaleInput>>>;
  options: OptionsInput;
  preliminaryBookingId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<PriceInput>;
  regionCode?: InputMaybe<Scalars['Int']>;
  registrationNumber: Scalars['String'];
  selectedDate: Scalars['DateTime'];
  servicePlan?: InputMaybe<ServicePlanInput>;
  siteId: Scalars['ID'];
  typedMileage?: InputMaybe<Scalars['Int']>;
  wheels?: InputMaybe<WheelInput>;
};

export type SubmitBranchAndDateInput = {
  branchId: Scalars['Guid'];
  /** Identity of the bookable resource (technician or slot-group) */
  containerId: Scalars['Int'];
  /** Date or date and time when the shop will perform the work */
  dateTime: Scalars['DateTimeOffset'];
  /** Duration of booking in minutes */
  duration?: InputMaybe<Scalars['Int']>;
  /** Identity of selected leave time. */
  leaveTimeId?: InputMaybe<Scalars['Guid']>;
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
  /** Identity of selected technician. */
  technicianId?: InputMaybe<Scalars['String']>;
};

export type SubmitCustomerInformationInputType = {
  address?: InputMaybe<AddressInformationInputType>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  orderId: Scalars['Guid'];
  phone: Scalars['String'];
  siteId: Scalars['Guid'];
};

export type SubmitOrderGraphType = {
  __typename?: 'SubmitOrderGraphType';
  agreementAccepted?: Maybe<Scalars['Boolean']>;
  smsReminder?: Maybe<Scalars['Boolean']>;
};

export type SubmitOrderInputType = {
  agreementAccepted: Scalars['Boolean'];
  orderComment?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Guid'];
  siteId: Scalars['Guid'];
  smsReminder: Scalars['Boolean'];
};

export type SubmitOrderState = {
  __typename?: 'SubmitOrderState';
  /** SubmitOrder */
  submitOrder?: Maybe<SubmitOrderGraphType>;
};

export type SubmittedBooking = {
  __typename?: 'SubmittedBooking';
  bookingId?: Maybe<Scalars['String']>;
  manageBookingUrl?: Maybe<Scalars['String']>;
};

export type SubmittedForm = {
  blockId: Scalars['ID'];
  /** List of form elements that are submitted with the form */
  formElements: Array<InputMaybe<SubmittedFormElement>>;
  host?: InputMaybe<Scalars['String']>;
  /** A group of fields used for getting metadata for the form, such as route, referral etc */
  metadata?: InputMaybe<SubmittedFormMetadata>;
  /** A group of fields used for getting metadata for any vehicle used in the form */
  vehicleMetadata?: InputMaybe<SubmittedFormVehicleMetadata>;
};

export type SubmittedFormElement = {
  blockId?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubmittedFormMetadata = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  formRoute?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  referral?: InputMaybe<Scalars['String']>;
};

export type SubmittedFormValidationError = {
  __typename?: 'SubmittedFormValidationError';
  /** The id of the form element that validated faulty */
  blockId?: Maybe<Scalars['String']>;
  /** A list of faulty validation(s) for the element */
  details?: Maybe<Array<Maybe<SubmittedFormValidationErrorDetails>>>;
};

export type SubmittedFormValidationErrorDetails = {
  __typename?: 'SubmittedFormValidationErrorDetails';
  /** An error message to display next to the faulty element */
  message?: Maybe<Scalars['String']>;
  /** The type of validation error that occurred */
  validatorType?: Maybe<Scalars['String']>;
};

export type SubmittedFormValidationResult = {
  __typename?: 'SubmittedFormValidationResult';
  /** Indicates whether the form was validated succsessfully or not */
  passedValidation: Scalars['Boolean'];
  /** List of the elements that was unsuccessfully validated */
  validationErrors?: Maybe<Array<Maybe<SubmittedFormValidationError>>>;
};

export type SubmittedFormVehicleMetadata = {
  activeConfigurationGroupId?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  isTransportVehicleFallback: Scalars['Boolean'];
  model?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  uniqueId?: InputMaybe<Scalars['String']>;
};

export type SubmittedPreliminaryBookingResponseType = PreliminaryBookingResponse | StatusCodeResponse;

export type SubscriptionBooster = {
  __typename?: 'SubscriptionBooster';
  bookingConfirmationText?: Maybe<Scalars['String']>;
  boosterInputFields?: Maybe<Array<Maybe<BoosterInputField>>>;
  boosterType: BoosterType;
  description?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  dmsText?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  servicesIds: Array<Scalars['ID']>;
  shouldSendToCustomerService: Scalars['Boolean'];
  shouldSendToDms: Scalars['Boolean'];
  siteId?: Maybe<Scalars['ID']>;
};

export type SubscriptionBoosterData = {
  bookingConfirmationText?: InputMaybe<Scalars['String']>;
  boosterId: Scalars['ID'];
  formData?: InputMaybe<Array<InputMaybe<FormDataField>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type SuggestSearchTerm = {
  __typename?: 'SuggestSearchTerm';
  combination: Scalars['Boolean'];
  displayValue?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<SuggestSearchTermFilter>>>;
  hitCount: Scalars['Long'];
  identifier?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export type SuggestSearchTermFilter = {
  __typename?: 'SuggestSearchTermFilter';
  displayValue?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SuggestSearchTerms = {
  __typename?: 'SuggestSearchTerms';
  suggestedSearchTerms?: Maybe<Array<Maybe<SuggestSearchTerm>>>;
};

export type TabSectionBlock = BlockBaseType & {
  __typename?: 'TabSectionBlock';
  activeTab: Scalars['Boolean'];
  anchorId?: Maybe<Scalars['String']>;
  anchorName?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subTheme?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type TabSectionContainerBlock = BlockBaseType & {
  __typename?: 'TabSectionContainerBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<GenericBlockContentType>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  fadeUp: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  innerPadding?: Maybe<Scalars['String']>;
  linkNavigation: Scalars['Boolean'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  subTheme?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type TeaserCardBlock = BlockBaseType & {
  __typename?: 'TeaserCardBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  useVerticalMargin: Scalars['Boolean'];
};

export type TeaserCardWithModalBlock = BlockBaseType & {
  __typename?: 'TeaserCardWithModalBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  image?: Maybe<Image>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  useVerticalMargin: Scalars['Boolean'];
};

export type Technician = {
  __typename?: 'Technician';
  brand?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  departmentId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  employeeNumber: Scalars['Int'];
  employeeType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  supportedCarMakes?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type TechnicianInput = {
  branchCode?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  generalContainer?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl: Scalars['String'];
  regionCode: Scalars['Int'];
  scheduleBookingGrade?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type TermsAggregate = AggregateBase & {
  __typename?: 'TermsAggregate';
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<TermsAggregateItem>>>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type TermsAggregateItem = {
  __typename?: 'TermsAggregateItem';
  displayValue?: Maybe<Scalars['String']>;
  hitCount: Scalars['Long'];
  selected: Scalars['Boolean'];
  subAggregateItems?: Maybe<Array<Maybe<TermsAggregateItem>>>;
  value: Scalars['String'];
};

export type TermsDropdownAggregate = AggregateBase & {
  __typename?: 'TermsDropdownAggregate';
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  selectedValue?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
  values: Array<Scalars['String']>;
};

export type TermsSingleAggregate = AggregateBase & {
  __typename?: 'TermsSingleAggregate';
  displayName?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterType>;
  filterUnit?: Maybe<FilterUnit>;
  identifier?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<TermsAggregateItem>>>;
  sortOrder: Scalars['Int'];
  topFilter: Scalars['Boolean'];
};

export type TextBlock = BlockBaseType & {
  __typename?: 'TextBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  richText?: Maybe<RichText>;
  shade?: Maybe<Scalars['String']>;
  textAlignment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type TextValue = {
  __typename?: 'TextValue';
  default: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Time = {
  __typename?: 'Time';
  customerCanWait: Scalars['Boolean'];
  default: Scalars['Boolean'];
  description: Scalars['String'];
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isSiteDefault: Scalars['Boolean'];
  serviceId?: Maybe<Scalars['ID']>;
  timeEntryAsText: Scalars['String'];
  to?: Maybe<Scalars['String']>;
  useFirstTime: Scalars['Boolean'];
};

export type TimeSlotsRequest = {
  branchId: Scalars['ID'];
  carMake: Scalars['String'];
  indexPrefix: Scalars['String'];
  selectedDate: Scalars['DateOnly'];
  serviceId?: InputMaybe<Scalars['ID']>;
};

export type TireAlternatives = {
  __typename?: 'TireAlternatives';
  back?: Maybe<Array<Maybe<TireInformation>>>;
  front?: Maybe<Array<Maybe<TireInformation>>>;
};

export type TireCartProduct = {
  __typename?: 'TireCartProduct';
  dimensions: Scalars['String'];
  id: Scalars['String'];
  images: Array<Maybe<CartProductImage>>;
  name: Scalars['String'];
};


export type TireCartProductImagesArgs = {
  count?: InputMaybe<Scalars['Int']>;
};

export type TireDimensionsRequest = {
  indexPrefix: Scalars['String'];
  isTransportVehicle?: InputMaybe<Scalars['Boolean']>;
  pageId: Scalars['ID'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  tireProfile?: InputMaybe<Scalars['String']>;
  tireRadius?: InputMaybe<Scalars['String']>;
  tireWidth?: InputMaybe<Scalars['String']>;
};

export type TireDimensionsResponse = {
  __typename?: 'TireDimensionsResponse';
  tireProfiles?: Maybe<Array<Maybe<KeyValuePairStringLong>>>;
  tireRadius?: Maybe<Array<Maybe<KeyValuePairStringLong>>>;
  tireWidths?: Maybe<Array<Maybe<KeyValuePairStringLong>>>;
};

export type TireHotelReference = {
  __typename?: 'TireHotelReference';
  branchId: Scalars['Guid'];
};

export type TireInformation = {
  __typename?: 'TireInformation';
  dimension?: Maybe<Scalars['String']>;
  isOriginalDimension?: Maybe<Scalars['Boolean']>;
  loadIndex?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  profile?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  speedRating?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  width?: Maybe<Scalars['String']>;
};

export type TireLookupByRegistrationNumberResponse = {
  __typename?: 'TireLookupByRegistrationNumberResponse';
  make: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
  originalEquipmentMark: Scalars['String'];
  preferredTireMake: Scalars['String'];
  tires?: Maybe<TireLookupTires>;
  vehicleType: Scalars['String'];
};

export type TireLookupTireSet = {
  __typename?: 'TireLookupTireSet';
  front?: Maybe<TireLookupTireType>;
  rear?: Maybe<TireLookupTireType>;
  season: Scalars['String'];
};

export type TireLookupTireType = {
  __typename?: 'TireLookupTireType';
  construction: Scalars['String'];
  diameter: Scalars['Int'];
  displayValue: Scalars['String'];
  isCommercial: Scalars['Boolean'];
  isExtraLoad: Scalars['Boolean'];
  loadIndex: Array<Scalars['Int']>;
  profile: Scalars['Int'];
  speedRating?: Maybe<Scalars['String']>;
  studs?: Maybe<Scalars['Boolean']>;
  width: Scalars['Int'];
};

export type TireLookupTires = {
  __typename?: 'TireLookupTires';
  alternativeTireSets?: Maybe<Array<Maybe<TireLookupTireSet>>>;
  tireSets?: Maybe<Array<Maybe<TireLookupTireSet>>>;
};

export type TireMatchBlock = BlockBaseType & {
  __typename?: 'TireMatchBlock';
  animation?: Maybe<Scalars['String']>;
  backTire?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  changeBackWheels?: Maybe<Scalars['String']>;
  changeDimensions?: Maybe<Scalars['String']>;
  changeFrontWheels?: Maybe<Scalars['String']>;
  changeRegistrationNumber?: Maybe<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  frontTire?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isFoundCarCorrect?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  noRegistrationNumber?: Maybe<Scalars['String']>;
  removeRegistrationNumber?: Maybe<Scalars['String']>;
  saveAndContinue?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  vehicleModel?: Maybe<Scalars['String']>;
};

export type TireResultSummaryType = {
  __typename?: 'TireResultSummaryType';
  productCategoryPageLinks?: Maybe<Array<Maybe<ProductCategoryPageLinkType>>>;
  tires?: Maybe<Array<Maybe<Product>>>;
};

export type TireSet = {
  __typename?: 'TireSet';
  branchCode?: Maybe<Scalars['String']>;
  /** First available wheel shift branch */
  branchId?: Maybe<Scalars['Guid']>;
  branchName?: Maybe<Scalars['String']>;
  campaignCustomerInformation?: Maybe<CampaignCustomerType>;
  changeNecessaryThreshold: Scalars['Float'];
  changeRecommendedThreshold: Scalars['Float'];
  equipmentSetId: Scalars['ID'];
  freeStorage: Scalars['Boolean'];
  hasSubscription?: Maybe<Scalars['Boolean']>;
  lowestTreadDepth: Scalars['Float'];
  measurementRemaining: Scalars['Float'];
  numberOfWornTires?: Maybe<Scalars['Int']>;
  onCar: Scalars['Boolean'];
  /** @deprecated Use tireSeason enum instead, remove after deploy v1.61.0 */
  season?: Maybe<Scalars['String']>;
  stockId: Scalars['ID'];
  stockName?: Maybe<Scalars['String']>;
  tireClassification?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  tireSuggestions?: Maybe<Array<Maybe<VariationTireSuggestion>>>;
  tiresInTireHotel?: Maybe<Array<Maybe<TiresInTireHotel>>>;
  /** @deprecated Since this field returns tires that are currently in tire hotel, name is misleading, use tiresInTireHotel instead, remove after deploy v1.61.0 */
  tiresOnCar?: Maybe<Array<Maybe<TiresOnCar>>>;
};

export type TireSiteSearchResultType = {
  __typename?: 'TireSiteSearchResultType';
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  result?: Maybe<Array<Maybe<SearchProduct>>>;
  suggest?: Maybe<Array<Maybe<Content>>>;
  summary?: Maybe<TireResultSummaryType>;
  tireCategories?: Maybe<Array<Maybe<ProductCategoryTiresType>>>;
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type TiresInTireHotel = {
  __typename?: 'TiresInTireHotel';
  aspectRatio?: Maybe<Scalars['String']>;
  equipmentId?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  rimDiameter?: Maybe<Scalars['String']>;
  sectionWidth?: Maybe<Scalars['String']>;
  speedRating?: Maybe<Scalars['String']>;
  studs?: Maybe<Scalars['Boolean']>;
  treadDepth: Scalars['Float'];
  treadDepthStatus: TreadDepthStatus;
};

export type TiresOnCar = {
  __typename?: 'TiresOnCar';
  aspectRatio?: Maybe<Scalars['String']>;
  equipmentId?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  rimDiameter?: Maybe<Scalars['String']>;
  sectionWidth?: Maybe<Scalars['String']>;
  speedRating?: Maybe<Scalars['String']>;
  studs?: Maybe<Scalars['Boolean']>;
  treadDepth: Scalars['Float'];
  treadDepthStatus: TreadDepthStatus;
};

export type TitleBlock = BlockBaseType & {
  __typename?: 'TitleBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mainText?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  secondaryText?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  tagType?: Maybe<Scalars['String']>;
  textAlignment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
  visualSize?: Maybe<Scalars['String']>;
};

export enum TreadDepthStatus {
  ChangeNecessary = 'CHANGE_NECESSARY',
  ChangeNotNecessary = 'CHANGE_NOT_NECESSARY',
  ChangeRecommended = 'CHANGE_RECOMMENDED',
  Unknown = 'UNKNOWN'
}

export type UspCard = BlockBaseType & {
  __typename?: 'USPCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  frequency: Scalars['Int'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type UspInfoCard = BlockBaseType & {
  __typename?: 'USPInfoCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  richText?: Maybe<RichText>;
  shade?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type UspLeadinCard = BlockBaseType & {
  __typename?: 'USPLeadinCard';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<Image>>>;
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type UnsubscribeCarFilterBlock = BlockBaseType & {
  __typename?: 'UnsubscribeCarFilterBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  labelBack?: Maybe<Scalars['String']>;
  labelEmail?: Maybe<Scalars['String']>;
  labelEndSubscription?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type UnsubscribeFromCarFilterResult = {
  __typename?: 'UnsubscribeFromCarFilterResult';
  success: Scalars['Boolean'];
};

export type UpdateCartItemQuantityInput = {
  cartItemId: Scalars['Guid'];
  orderId: Scalars['Guid'];
  quantity: Scalars['Decimal'];
  siteId: Scalars['Guid'];
};

export type Usp = {
  __typename?: 'Usp';
  carMakeName: Scalars['String'];
  id: Scalars['ID'];
  serviceId?: Maybe<Scalars['ID']>;
  serviceName: Scalars['String'];
  siteCarMakeSettingId?: Maybe<Scalars['ID']>;
  siteId: Scalars['ID'];
  siteName: Scalars['String'];
  text: Scalars['String'];
};

export enum UspCalculation {
  CarPayPrice = 'CAR_PAY_PRICE',
  None = 'NONE',
  TireHotelDiscountPrice = 'TIRE_HOTEL_DISCOUNT_PRICE'
}

export type UspMixInBlock = {
  __typename?: 'UspMixInBlock';
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  content?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  primaryShade?: Maybe<Scalars['String']>;
  secondaryShade?: Maybe<Scalars['String']>;
  skew?: Maybe<Scalars['Boolean']>;
  subTheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UspSearchResult = {
  __typename?: 'UspSearchResult';
  id: Scalars['String'];
  mixInBlocks?: Maybe<Array<Maybe<UspMixInBlock>>>;
  seoBlock?: Maybe<UspSeoBlock>;
};

export type UspSeoBlock = {
  __typename?: 'UspSeoBlock';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Possible validation and error messages. */
export enum ValidationError {
  CartEmpty = 'CART_EMPTY',
  CartInvalidArticle = 'CART_INVALID_ARTICLE',
  CartItemNotFound = 'CART_ITEM_NOT_FOUND',
  CheckoutProcessingFailed = 'CHECKOUT_PROCESSING_FAILED',
  ConsentsNotAccepted = 'CONSENTS_NOT_ACCEPTED',
  CustomerInformationMissing = 'CUSTOMER_INFORMATION_MISSING',
  Forbidden = 'FORBIDDEN',
  OrderConflict = 'ORDER_CONFLICT',
  OrderNotFound = 'ORDER_NOT_FOUND',
  PreliminaryBookingConflict = 'PRELIMINARY_BOOKING_CONFLICT',
  PreliminaryBookingExpired = 'PRELIMINARY_BOOKING_EXPIRED',
  PreliminaryBookingFailed = 'PRELIMINARY_BOOKING_FAILED',
  PreliminaryBookingGone = 'PRELIMINARY_BOOKING_GONE',
  PreliminaryBookingMissing = 'PRELIMINARY_BOOKING_MISSING',
  VehicleInformationMissing = 'VEHICLE_INFORMATION_MISSING',
  VehicleNotFound = 'VEHICLE_NOT_FOUND'
}

export enum ValidationType {
  /** Validate email address */
  Email = 'EMAIL',
  /** No validation */
  None = 'NONE',
  /** Validate social security number */
  SocialSecurityNumber = 'SOCIAL_SECURITY_NUMBER'
}

export type Variation = {
  __typename?: 'Variation';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationAuxiliaryLamp = {
  __typename?: 'VariationAuxiliaryLamp';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemAuxiliaryLampGlassColor?: Maybe<Scalars['String']>;
  itemAuxiliaryLampLight?: Maybe<Scalars['String']>;
  itemAuxiliaryLampLightLength?: Maybe<Scalars['String']>;
  itemAuxiliaryLampType?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationAuxiliaryLampDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationAuxiliaryLampImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationAuxiliaryLampVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationBikeCarrier = {
  __typename?: 'VariationBikeCarrier';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemBikeCarrierDistanceBetweenBikes: Scalars['Int'];
  itemBikeCarrierElectricBikeCompatibility?: Maybe<Scalars['Boolean']>;
  itemBikeCarrierFitsWithExternalSpareWheel?: Maybe<Scalars['Boolean']>;
  itemBikeCarrierMaxAmountBikes?: Maybe<Scalars['String']>;
  itemBikeCarrierMaxBikeWeight: Scalars['Int'];
  itemBikeCarrierTrunkAccess?: Maybe<Scalars['Boolean']>;
  itemCollapsable?: Maybe<Scalars['Boolean']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationBikeCarrierDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationBikeCarrierImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationBikeCarrierVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationDogCage = {
  __typename?: 'VariationDogCage';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemFitsWeightFrom?: Maybe<Scalars['Decimal']>;
  itemFitsWeightTo: Scalars['Decimal'];
  itemFitsWeightUnit?: Maybe<Scalars['String']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationDogCageDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationDogCageImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationDogCageVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationElectricCarCharge = {
  __typename?: 'VariationElectricCarCharge';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemElectricCarCurrentFrom?: Maybe<Scalars['Int']>;
  itemElectricCarCurrentTo?: Maybe<Scalars['Int']>;
  itemElectricCarEffectFrom?: Maybe<Scalars['Decimal']>;
  itemElectricCarEffectTo?: Maybe<Scalars['Decimal']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationElectricCarChargeDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationElectricCarChargeImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationElectricCarChargeVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationParts = {
  __typename?: 'VariationParts';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationPartsDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationPartsImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationPartsVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationRim = {
  __typename?: 'VariationRim';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemRimEt: Scalars['Decimal'];
  itemRimRadius: Scalars['Int'];
  itemRimWidth: Scalars['Decimal'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationRimDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationRimImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationRimVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationTire = {
  __typename?: 'VariationTire';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemTireDimension?: Maybe<Scalars['String']>;
  itemTireDimensionProfileString?: Maybe<Scalars['String']>;
  itemTireDimensionRadius?: Maybe<Scalars['String']>;
  itemTireDimensionWidthString?: Maybe<Scalars['String']>;
  itemTireEprel?: Maybe<Scalars['String']>;
  itemTireExtraStrength?: Maybe<Scalars['Boolean']>;
  itemTireFuelConsumption?: Maybe<Scalars['String']>;
  itemTireLoadIndex?: Maybe<Scalars['Int']>;
  itemTireLoadIndexString?: Maybe<Scalars['String']>;
  itemTireLoadSpeed: Scalars['String'];
  itemTireNoice: Scalars['Int'];
  itemTireNoiceClass?: Maybe<Scalars['String']>;
  itemTireNoiseCancelling?: Maybe<Scalars['String']>;
  itemTireOriginal?: Maybe<Array<Scalars['String']>>;
  itemTireSpeedRating?: Maybe<Scalars['String']>;
  itemTireVehicle?: Maybe<Scalars['String']>;
  itemTireWetGrip?: Maybe<Scalars['String']>;
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationTireDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationTireImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationTireVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationTireSuggestion = {
  __typename?: 'VariationTireSuggestion';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  campaignPrice?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentPrice?: Maybe<Scalars['Decimal']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['String']>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  firstBookableDateForTire?: Maybe<Scalars['DateTime']>;
  hasUsp: Scalars['Boolean'];
  historicalLowestPrice?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemTireDimension?: Maybe<Scalars['String']>;
  itemTireDimensionProfileString?: Maybe<Scalars['String']>;
  itemTireDimensionRadius?: Maybe<Scalars['String']>;
  itemTireDimensionWidthString?: Maybe<Scalars['String']>;
  itemTireEprel?: Maybe<Scalars['String']>;
  itemTireExtraStrength?: Maybe<Scalars['Boolean']>;
  itemTireFuelConsumption?: Maybe<Scalars['String']>;
  itemTireLoadIndex?: Maybe<Scalars['Int']>;
  itemTireLoadIndexString?: Maybe<Scalars['String']>;
  itemTireLoadSpeed: Scalars['String'];
  itemTireNoice: Scalars['Int'];
  itemTireNoiceClass?: Maybe<Scalars['String']>;
  itemTireNoiseCancelling?: Maybe<Scalars['String']>;
  itemTireOriginal?: Maybe<Array<Scalars['String']>>;
  itemTireSpeedRating?: Maybe<Scalars['String']>;
  itemTireVehicle?: Maybe<Scalars['String']>;
  itemTireWetGrip?: Maybe<Scalars['String']>;
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageExtraPrice?: Maybe<Scalars['Int']>;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  standardPrice: Scalars['Int'];
  tireSeason?: Maybe<Season>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  visitsLastMonth: Scalars['Int'];
};

export type VariationWheel = {
  __typename?: 'VariationWheel';
  bookableDateDiff?: Maybe<Scalars['Int']>;
  crossSell?: Maybe<Array<Scalars['String']>>;
  currentBiliaCardPrice?: Maybe<Scalars['Int']>;
  currentPrice: Scalars['Int'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDateDiff?: Maybe<Scalars['Int']>;
  deliveryDateGroup?: Maybe<Scalars['Int']>;
  deliveryDateStatus: DeliveryDateStatus;
  downloads?: Maybe<Array<Maybe<Download>>>;
  environmentalFee: Scalars['Int'];
  environmentalFeeDescription?: Maybe<Scalars['String']>;
  eonTyreProductId: Scalars['Int'];
  hasUsp: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isBiliaCardPriceArticle: Scalars['Boolean'];
  isCampaignArticle: Scalars['Boolean'];
  itemAccessoriesMaxWeight?: Maybe<Scalars['Int']>;
  itemAccessoriesMaxWeightUnit?: Maybe<Scalars['String']>;
  itemColor?: Maybe<Scalars['String']>;
  itemDepthFrom?: Maybe<Scalars['Decimal']>;
  itemDepthTo?: Maybe<Scalars['Decimal']>;
  itemDepthUnit?: Maybe<Scalars['String']>;
  itemDiameterFrom?: Maybe<Scalars['Decimal']>;
  itemDiameterTo?: Maybe<Scalars['Decimal']>;
  itemDiameterUnit?: Maybe<Scalars['String']>;
  itemEnvFeeCode?: Maybe<Scalars['String']>;
  itemErpPrefix: Scalars['String'];
  itemExtraSpecification?: Maybe<Scalars['String']>;
  itemFitsAllVehicles?: Maybe<Scalars['Boolean']>;
  itemGtin?: Maybe<Scalars['String']>;
  itemHeightFrom?: Maybe<Scalars['Decimal']>;
  itemHeightTo?: Maybe<Scalars['Decimal']>;
  itemHeightUnit?: Maybe<Scalars['String']>;
  itemHighlightFeature?: Maybe<Scalars['String']>;
  itemIsSoftware?: Maybe<Scalars['Boolean']>;
  itemLengthFrom?: Maybe<Scalars['Decimal']>;
  itemLengthTo?: Maybe<Scalars['Decimal']>;
  itemLengthUnit?: Maybe<Scalars['String']>;
  itemLongDescription?: Maybe<Scalars['String']>;
  itemLongName: Scalars['String'];
  itemName?: Maybe<Scalars['String']>;
  itemNameOverride?: Maybe<Scalars['String']>;
  itemNonStock: Scalars['Boolean'];
  itemNotSoldSeparately: Scalars['Boolean'];
  itemNotSoldWithGds: Scalars['Boolean'];
  itemNumber: Scalars['String'];
  itemNumberAndPrefix: Scalars['String'];
  itemNumberManufacturer?: Maybe<Scalars['String']>;
  itemNumberSupplier?: Maybe<Scalars['String']>;
  itemOnlySoldWithRegNumber: Scalars['Boolean'];
  itemRimEt: Scalars['Decimal'];
  itemRimRadius: Scalars['Int'];
  itemRimWidth: Scalars['Decimal'];
  itemSearchDescription?: Maybe<Scalars['String']>;
  itemSearchTags?: Maybe<Array<Scalars['String']>>;
  itemSearchTitle?: Maybe<Scalars['String']>;
  itemShortDescription?: Maybe<Scalars['String']>;
  itemShortName?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  itemTempOutOfStock: Scalars['Boolean'];
  itemTireDimension?: Maybe<Scalars['String']>;
  itemTireDimensionProfileString?: Maybe<Scalars['String']>;
  itemTireDimensionRadius?: Maybe<Scalars['String']>;
  itemTireDimensionWidthString?: Maybe<Scalars['String']>;
  itemTireEprel?: Maybe<Scalars['String']>;
  itemTireExtraStrength?: Maybe<Scalars['Boolean']>;
  itemTireFuelConsumption?: Maybe<Scalars['String']>;
  itemTireLoadIndex?: Maybe<Scalars['Int']>;
  itemTireLoadIndexString?: Maybe<Scalars['String']>;
  itemTireLoadSpeed: Scalars['String'];
  itemTireNoice: Scalars['Int'];
  itemTireNoiceClass?: Maybe<Scalars['String']>;
  itemTireNoiseCancelling?: Maybe<Scalars['String']>;
  itemTireOriginal?: Maybe<Array<Scalars['String']>>;
  itemTireSpeedRating?: Maybe<Scalars['String']>;
  itemTireVehicle?: Maybe<Scalars['String']>;
  itemTireWetGrip?: Maybe<Scalars['String']>;
  itemUniqueValue?: Maybe<Scalars['String']>;
  itemUsp1?: Maybe<Scalars['String']>;
  itemUsp2?: Maybe<Scalars['String']>;
  itemUsp3?: Maybe<Scalars['String']>;
  itemVariantCode?: Maybe<Scalars['String']>;
  itemVariantCodeRegularExpression?: Maybe<Scalars['String']>;
  itemVoltage?: Maybe<Scalars['Decimal']>;
  itemVolume?: Maybe<Scalars['Decimal']>;
  itemVolumeUnit?: Maybe<Scalars['String']>;
  itemWebColor?: Maybe<Array<Scalars['String']>>;
  itemWeight?: Maybe<Scalars['Decimal']>;
  itemWeightUnit?: Maybe<Scalars['String']>;
  itemWidthFrom?: Maybe<Scalars['Decimal']>;
  itemWidthTo?: Maybe<Scalars['Decimal']>;
  itemWidthUnit?: Maybe<Scalars['String']>;
  objectType: SearchObjectType;
  packageVersions?: Maybe<Array<Maybe<PackageVersion>>>;
  /** @deprecated Switch to using StandardPrice/CampaignPrice once we have 30-day rule in place */
  previousPrice: Scalars['Int'];
  price: ProductPrice;
  productBrand?: Maybe<Scalars['String']>;
  productItemLongName?: Maybe<Scalars['String']>;
  productItemShortName?: Maybe<Scalars['String']>;
  productModel?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tireSeason?: Maybe<Season>;
  variationDisplayValue: Scalars['String'];
  variationUrl?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<ProductVideo>>>;
  visitsLastMonth: Scalars['Int'];
};


export type VariationWheelDownloadsArgs = {
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
};


export type VariationWheelImagesArgs = {
  numberOfImages?: InputMaybe<Scalars['Int']>;
};


export type VariationWheelVideosArgs = {
  numberOfVideos?: InputMaybe<Scalars['Int']>;
};

export type VariationsUnion = Variation | VariationAuxiliaryLamp | VariationBikeCarrier | VariationDogCage | VariationElectricCarCharge | VariationParts | VariationRim | VariationTire | VariationWheel;

export type Vehicle = {
  __typename?: 'Vehicle';
  /** @deprecated Use tireHotelInformation.campaignCustomerInformation instead */
  campaignCustomer?: Maybe<CampaignCustomerType>;
  classificationCode?: Maybe<Scalars['Int']>;
  classificationDescription?: Maybe<Scalars['String']>;
  classificationText?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  emissionClass?: Maybe<Scalars['Int']>;
  enginePower?: Maybe<Scalars['Int']>;
  fuel1?: Maybe<Scalars['Int']>;
  fuel2?: Maybe<Scalars['Int']>;
  fuel3?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  isTransportCar: Scalars['Boolean'];
  kerbWeight?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  manufacturingYearAndMonth?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  rimBack?: Maybe<Scalars['String']>;
  rimFront?: Maybe<Scalars['String']>;
  siteCarMake?: Maybe<SiteCarMake>;
  tireAlternatives?: Maybe<TireAlternatives>;
  tireBack?: Maybe<TireInformation>;
  tireFront?: Maybe<TireInformation>;
  tireHotelInformation?: Maybe<TireSet>;
  typeHigh?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  /** Returns modelYear if set, otherwise vehicleYear or 0 */
  year?: Maybe<Scalars['Int']>;
};

export type VehicleEquipmentLevelModel = {
  __typename?: 'VehicleEquipmentLevelModel';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vehicles?: Maybe<Array<Maybe<VehicleModel>>>;
};

export type VehicleModel = {
  __typename?: 'VehicleModel';
  areas?: Maybe<Array<Maybe<Area>>>;
  colors?: Maybe<Array<Maybe<CarImageColor>>>;
  engineVersionName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optionId?: Maybe<Scalars['String']>;
  primaryFuelTypeCode?: Maybe<Scalars['String']>;
  secondaryFuelTypeCode?: Maybe<Scalars['String']>;
};

export type VehicleReference = {
  __typename?: 'VehicleReference';
  isCrmCustomer: Scalars['Boolean'];
  make: Scalars['String'];
  makeCode: Scalars['String'];
  model: Scalars['String'];
  modelYear?: Maybe<Scalars['Int']>;
  registrationNumber: Scalars['String'];
  tireHotel?: Maybe<TireHotelReference>;
};

export type Video = {
  __typename?: 'Video';
  autoplay: Scalars['Boolean'];
  controls: Scalars['Boolean'];
  loop: Scalars['Boolean'];
  mediaType?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['String']>;
  streamingService?: Maybe<Scalars['String']>;
  videoSource?: Maybe<Scalars['String']>;
};

export enum ViewState {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
  Working = 'WORKING'
}

export type VolvoSisccWidgetBlock = {
  __typename?: 'VolvoSisccWidgetBlock';
  animation?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shade?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type WheelInput = {
  amount: Scalars['Int'];
  price: Scalars['Float'];
  uuid: Scalars['String'];
  wheelId: Scalars['String'];
};

export type WorkshopBookBarBlockCard = BlockBaseType & {
  __typename?: 'WorkshopBookBarBlockCard';
  alignment?: Maybe<Scalars['String']>;
  animation?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockMargin?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<Maybe<CallToAction>>>;
  categoryIds: Array<Scalars['ID']>;
  categoryNames: Array<Scalars['String']>;
  columnSize?: Maybe<Scalars['String']>;
  contentLink?: Maybe<Scalars['String']>;
  excludeFromQueries: Scalars['Boolean'];
  guidingText?: Maybe<Scalars['String']>;
  guidingTextPlacement?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indexedDate: Scalars['DateTime'];
  isSticky: Scalars['Boolean'];
  labelEnterRegNr?: Maybe<Scalars['String']>;
  mediaIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  registrationNumberInput?: Maybe<RegNumberPropertyBlock>;
  shade?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  useVerticalMargin: Scalars['Boolean'];
};

export type WorkshopService = {
  __typename?: 'WorkshopService';
  bookingEngine: BookingEngine;
  bookingType: BookingScheduleType;
  checkForPersonalServiceTechnician: Scalars['Boolean'];
  childServices?: Maybe<Array<Maybe<WorkshopService>>>;
  description?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  fetchServicePlan: Scalars['Boolean'];
  hasServicePriceConfigurations: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  hideAboutService: Scalars['Boolean'];
  hideDialog: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  isSlot: Scalars['Boolean'];
  isTireHotelService: Scalars['Boolean'];
  kobraPackageName?: Maybe<Scalars['String']>;
  logoName?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
  moreSales?: Maybe<MoreSales>;
  name: Scalars['String'];
  operationType: Scalars['Int'];
  price?: Maybe<ServicePrice>;
  serviceConfigurationInputs?: Maybe<Array<Maybe<ServiceConfigurationInput>>>;
  showCustomerWaitOption: Scalars['Boolean'];
  subscriptionBoosters?: Maybe<Array<Maybe<SubscriptionBooster>>>;
  useVps: Scalars['Boolean'];
  workTime?: Maybe<Scalars['Int']>;
};

export type WorkshopServiceCategorySiteSearchResultType = {
  __typename?: 'WorkshopServiceCategorySiteSearchResultType';
  name: Scalars['String'];
  services?: Maybe<Array<Maybe<WorkshopServiceModel>>>;
};

export type WorkshopServiceModel = {
  __typename?: 'WorkshopServiceModel';
  description: Scalars['String'];
  iconPath: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type WorkshopServiceSiteSearchResultType = {
  __typename?: 'WorkshopServiceSiteSearchResultType';
  categories?: Maybe<Array<Maybe<WorkshopServiceCategorySiteSearchResultType>>>;
  firstUrl: Scalars['String'];
  highestScore: Scalars['Float'];
  totalHits: Scalars['Long'];
  type: Scalars['String'];
};

export type AddMoreSaleMutationVariables = Exact<{
  addMoreSaleQuery: AddMoreSaleQueryInput;
}>;


export type AddMoreSaleMutation = { __typename?: 'MotoritOnlineMutations', addMoreSale?: { __typename?: 'StatusCodeResponse', message?: string, statusCode: number } };

export type BookingSettingsQueryQueryVariables = Exact<{
  siteId: Scalars['Guid'];
}>;


export type BookingSettingsQueryQuery = { __typename?: 'MotoritOnlineQueries', bookingSettings?: { __typename?: 'BookingSettings', chatId: number, imageUrl?: string, priceThousandSeparator?: string, socialSecurityMask?: string, termsAndConditionText?: string, registrationNumberMask?: string, registrationNumberRegexp?: string, policyUrl?: string, emailRegex?: string, moreSaleSettings?: { __typename?: 'MoreSaleSettings', topMoreSales: number, showBeforePagination: number, showMoreSaleSettings: boolean }, slotGroups?: Array<{ __typename?: 'SlotGroup', label: string, from?: string, to?: string }>, message?: { __typename?: 'Message', id: string, title?: string, text?: string, url?: string, targetNewWindow: boolean, showOnConfirmationPage: boolean } } };

export type BranchNamesQueryQueryVariables = Exact<{
  branchNamesQuery?: InputMaybe<BranchNamesQuery>;
}>;


export type BranchNamesQueryQuery = { __typename?: 'MotoritOnlineQueries', branchNames?: Array<{ __typename?: 'BranchNamesType', id: string, name: string }> };

export type CarMakesQueryVariables = Exact<{
  siteId: Scalars['Guid'];
}>;


export type CarMakesQuery = { __typename?: 'MotoritOnlineQueries', carMakes?: Array<{ __typename?: 'CarMakes', name: string, value: string, carMakeCode: string }> };

export type CustomerByPhoneNumberQueryVariables = Exact<{
  uuid: Scalars['String'];
  culture: Scalars['String'];
  mobileNumber: Scalars['String'];
  registrationNumber: Scalars['String'];
}>;


export type CustomerByPhoneNumberQuery = { __typename?: 'MotoritOnlineQueries', customerByPhoneNumber?: { __typename?: 'Customer', firstName?: string, lastName?: string, email?: string, name?: string, registrationNumber: string } };

export type FirstAvailableDatesQueryQueryVariables = Exact<{
  siteId: Scalars['ID'];
  serviceId: Scalars['ID'];
  regionCode: Scalars['Int'];
  branchCode: Scalars['Int'];
  isTireHotel: Scalars['Boolean'];
  code: Scalars['String'];
}>;


export type FirstAvailableDatesQueryQuery = { __typename?: 'MotoritOnlineQueries', firstAvailableDates?: { __typename?: 'FirstAvailableDate', dates?: Array<any> } };

export type PreliminaryBookingMutationVariables = Exact<{
  siteId: Scalars['Guid'];
  serviceId: Scalars['Guid'];
  containerId: Scalars['Int'];
  date: Scalars['DateTime'];
  regionCode: Scalars['Int'];
  isTireHotel?: InputMaybe<Scalars['Boolean']>;
  branchId: Scalars['Guid'];
  indexPrefix: Scalars['String'];
  registrationNumber: Scalars['String'];
}>;


export type PreliminaryBookingMutation = { __typename?: 'MotoritOnlineMutations', submitPreliminaryBooking?: { __typename: 'PreliminaryBookingResponse', bookingId?: string, responseMessage?: string, reservedTime?: number } | { __typename: 'StatusCodeResponse', message?: string, statusCode: number } };

export type ScheduleQueryQueryVariables = Exact<{
  branchId: Scalars['ID'];
  carMakeCode: Scalars['String'];
  culture: Scalars['String'];
  hasTireInCart: Scalars['Boolean'];
  indexPrefix: Scalars['String'];
  isTireHotel: Scalars['Boolean'];
  numberOfDays: Scalars['Int'];
  oneDaySelected: Scalars['Boolean'];
  serviceId: Scalars['ID'];
  siteId: Scalars['ID'];
  carMake?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  forwardDays: Scalars['Boolean'];
  registrationNumber: Scalars['String'];
}>;


export type ScheduleQueryQuery = { __typename?: 'MotoritOnlineQueries', schedule?: { __typename?: 'GetScheduleResponse', days?: Array<{ __typename?: 'Day', label: number, date: any, available: boolean, month: string, dayInWeek: number, newMonth: boolean, availableTechnician?: Array<number>, retrieveTimeSlots: boolean, slotGroups?: Array<{ __typename?: 'Slot', startTime: any, available: boolean, span: number, containerId: number }> }>, technicians?: Array<{ __typename?: 'BookmakerTechnicianType', branchCode?: string, containerId?: number, generalContainer?: boolean, email: string, id: string, name: string, phone: string, photoUrl: string, title?: string, scheduleBookingGrade?: number, firstAvailableTimes?: Array<{ __typename?: 'Day', label: number, date: any, available: boolean, month: string, dayInWeek: number, newMonth: boolean, availableTechnician?: Array<number>, slotGroups?: Array<{ __typename?: 'Slot', startTime: any, available: boolean, span: number, containerId: number }> }> }> } };

export type ServiceQueryVariables = Exact<{
  siteId: Scalars['Guid'];
  carMake: Scalars['String'];
  model: Scalars['String'];
  year: Scalars['Int'];
  classificationCode?: InputMaybe<Scalars['Int']>;
  hasTireHotel: Scalars['Boolean'];
  serviceIdList?: InputMaybe<Array<Scalars['Guid']> | Scalars['Guid']>;
  registrationNumber: Scalars['String'];
}>;


export type ServiceQuery = { __typename?: 'MotoritOnlineQueries', service?: (
    { __typename?: 'WorkshopService', childServices?: Array<(
      { __typename?: 'WorkshopService' }
      & WorkshopServiceFieldsFragment
    )> }
    & WorkshopServiceFieldsFragment
  ) };

export type WorkshopServiceFieldsFragment = { __typename?: 'WorkshopService', id: string, name: string, heading?: string, description?: string, longDescription?: string, eventName?: string, logoName?: string, externalUrl?: string, bookingType: BookingScheduleType, showCustomerWaitOption: boolean, fetchServicePlan: boolean, hideDialog: boolean, hideAboutService: boolean, checkForPersonalServiceTechnician: boolean, isTireHotelService: boolean, isSlot: boolean, operationType: number, message?: { __typename?: 'Message', id: string, title?: string, text?: string, url?: string, targetNewWindow: boolean, showOnConfirmationPage: boolean }, serviceConfigurationInputs?: Array<{ __typename?: 'ServiceConfigurationInput', id: string, serviceConfigurationInputType: ServiceConfigurationInputType, isRequired: boolean, header?: string, description?: string, placeHolder?: string, sortOrder: number }>, price?: { __typename?: 'ServicePrice', price: number, textPrice: string, priceDescription: string, isFromPrice: boolean, biliaCardPrice?: number, disclaimer: string, packageCode?: string, priceGroupName?: string }, moreSales?: { __typename?: 'MoreSales', confirmationStepMoreSales?: Array<{ __typename?: 'MoreSale', id: string, name: string, description?: string, eventName?: string, requireSocialSecurityNumber: boolean, getArticleAndPriceFromEcommerce: boolean, showCommentField: boolean, isTireHotelService: boolean, price?: { __typename?: 'ServicePrice', price: number, biliaCardPrice?: number, textPrice: string, priceDescription: string, isFromPrice: boolean, disclaimer: string, packageCode?: string, priceGroupName?: string }, serviceConfigurationInputs?: Array<{ __typename?: 'ServiceConfigurationInput', id: string, serviceConfigurationInputType: ServiceConfigurationInputType, isRequired: boolean, header?: string, description?: string, placeHolder?: string, sortOrder: number }> }>, contactStepMoreSales?: Array<{ __typename?: 'MoreSale', id: string, name: string, description?: string, eventName?: string, requireSocialSecurityNumber: boolean, getArticleAndPriceFromEcommerce: boolean, showCommentField: boolean, isTireHotelService: boolean, price?: { __typename?: 'ServicePrice', price: number, biliaCardPrice?: number, textPrice: string, priceDescription: string, isFromPrice: boolean, disclaimer: string, packageCode?: string, priceGroupName?: string }, serviceConfigurationInputs?: Array<{ __typename?: 'ServiceConfigurationInput', id: string, serviceConfigurationInputType: ServiceConfigurationInputType, isRequired: boolean, header?: string, description?: string, placeHolder?: string, sortOrder: number }> }> }, subscriptionBoosters?: Array<{ __typename?: 'SubscriptionBooster', id: string, boosterType: BoosterType, header?: string, name?: string, description?: string, disclaimer?: string, bookingConfirmationText?: string, imageUrl?: string, boosterInputFields?: Array<{ __typename?: 'BoosterInputField', autoComplete: AutoComplete, formatMatch?: string, htmlInputType: HtmlInputType, name: string, placeholder?: string, tooltip?: string, validationType: ValidationType, maxLength?: number, inputMode: InputMode, radioButtonChoices?: Array<{ __typename?: 'RadioButtonChoice', label: string }> }> }> };

export type ServiceGroupsQueryVariables = Exact<{
  languageCode: Scalars['String'];
  siteId: Scalars['Guid'];
  carMake: Scalars['String'];
  model: Scalars['String'];
  year: Scalars['Int'];
  classificationCode?: InputMaybe<Scalars['Int']>;
  hasTireHotel: Scalars['Boolean'];
  typeHigh?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
}>;


export type ServiceGroupsQuery = { __typename?: 'MotoritOnlineQueries', serviceGroups?: { __typename?: 'ServiceGroups', serviceGroupList?: Array<{ __typename?: 'ServiceGroup', id: string, name: string, openByDefault: boolean, services?: Array<{ __typename?: 'WorkshopService', id: string, heading?: string, isTireHotelService: boolean, message?: { __typename?: 'Message', id: string, title?: string, text?: string, url?: string, targetNewWindow: boolean, showOnConfirmationPage: boolean }, price?: { __typename?: 'ServicePrice', biliaCardPrice?: number, price: number, textPrice: string, priceDescription: string, isFromPrice: boolean, disclaimer: string, packageCode?: string } }> }> } | { __typename?: 'StatusCodeResponse', statusCode: number, message?: string } };

export type ServicePlanQueryQueryVariables = Exact<{
  culture: Scalars['String'];
  siteId: Scalars['Guid'];
  registrationNumber: Scalars['String'];
  mileage: Scalars['Int'];
  carMake: Scalars['String'];
  model: Scalars['String'];
}>;


export type ServicePlanQueryQuery = { __typename?: 'MotoritOnlineQueries', servicePlan?: { __typename?: 'ServicePlan', name: string, description: string, kitCode: number, hasServiceAgreement: boolean, servicePlanSummarize: string, serviceActivities?: Array<string>, price?: { __typename?: 'PriceItem', price: number, reducedPrice: number, message: string }, serviceTypes?: Array<{ __typename?: 'Service', name: string, description: string, icon: string }> } };

export type SubmitBookingMutationVariables = Exact<{
  submitBookingQuery: SubmitBookingQueryInput;
}>;


export type SubmitBookingMutation = { __typename?: 'MotoritOnlineMutations', submitBooking?: { __typename?: 'StatusCodeResponse', message?: string, statusCode: number } | { __typename?: 'SubmittedBooking', bookingId?: string, manageBookingUrl?: string } };

export type ResourcesByGroupsQueryVariables = Exact<{
  siteId: Scalars['Guid'];
  groups: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type ResourcesByGroupsQuery = { __typename?: 'MotoritOnlineQueries', resourcesByGroups?: any };

export type TimeSlotsQueryQueryVariables = Exact<{
  timeSlotsQuery?: InputMaybe<TimeSlotsRequest>;
}>;


export type TimeSlotsQueryQuery = { __typename?: 'MotoritOnlineQueries', timeSlots?: Array<{ __typename?: 'Slot', available: boolean, containerId: number, span: number, startTime: any }> };

export type UspQueryVariables = Exact<{
  siteId: Scalars['Guid'];
  carMake?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['Guid']>;
}>;


export type UspQuery = { __typename?: 'MotoritOnlineQueries', usp?: Array<{ __typename?: 'Usp', id: string, siteId: string, text: string, siteCarMakeSettingId?: string, serviceId?: string }> };

export type VehicleInformationQueryVariables = Exact<{
  registrationNumber: Scalars['String'];
  culture: Scalars['String'];
  siteId: Scalars['Guid'];
}>;


export type VehicleInformationQuery = { __typename?: 'MotoritOnlineQueries', vehicleInformation?: { __typename?: 'Vehicle', make?: string, model?: string, year?: number, typeHigh?: string, isTransportCar: boolean, registrationNumber?: string, classificationCode?: number, siteCarMake?: { __typename?: 'SiteCarMake', code?: string, value?: string }, tireHotelInformation?: { __typename?: 'TireSet', freeStorage: boolean, numberOfWornTires?: number, branchId?: any, branchCode?: string, tireSeason?: Season, measurementRemaining: number, changeNecessaryThreshold: number, changeRecommendedThreshold: number, tiresInTireHotel?: Array<{ __typename?: 'TiresInTireHotel', treadDepth: number, position: number, treadDepthStatus: TreadDepthStatus }>, tireSuggestions?: Array<{ __typename?: 'VariationTireSuggestion', id: string, productItemShortName?: string, productBrand?: string, productModel?: string, imageUrl?: string, currentPrice?: any, discountPercentage?: string, packageExtraPrice?: number, environmentalFee: number, itemTireDimension?: string, itemTireNoice: number, itemTireWetGrip?: string, itemTireFuelConsumption?: string, itemTireSpeedRating?: string, itemTireLoadIndex?: number, tireSeason?: Season, productType?: string, firstBookableDateForTire?: any }>, campaignCustomerInformation?: { __typename?: 'CampaignCustomerType', uuid: string, hasSubmittedInfo: boolean } } } };
